import { default as button96b0EZI4ysMeta } from "/www/gamefi/pages/_demoGround/button.vue?macro=true";
import { default as iconMi7AtwvQC9Meta } from "/www/gamefi/pages/_demoGround/icon.vue?macro=true";
import { default as inputSpw3Qfk98FMeta } from "/www/gamefi/pages/_demoGround/input.vue?macro=true";
import { default as navkuiqJ8kfZKMeta } from "/www/gamefi/pages/_demoGround/nav.vue?macro=true";
import { default as others43HYRsb2c3Meta } from "/www/gamefi/pages/_demoGround/others.vue?macro=true";
import { default as _404HG0pb9MEqzMeta } from "/www/gamefi/pages/404.vue?macro=true";
import { default as BetOptionsfCCnRXE8h2Meta } from "/www/gamefi/pages/casino/blackjackGame/_components/BetOptions.vue?macro=true";
import { default as Card6OSW9tz7PzMeta } from "/www/gamefi/pages/casino/blackjackGame/_components/Card.vue?macro=true";
import { default as GameControls54eoiVazA3Meta } from "/www/gamefi/pages/casino/blackjackGame/_components/GameControls.vue?macro=true";
import { default as Point1vOgesi8AjMeta } from "/www/gamefi/pages/casino/blackjackGame/_components/Point.vue?macro=true";
import { default as ProWinYylXQfPhH4Meta } from "/www/gamefi/pages/casino/blackjackGame/_components/ProWin.vue?macro=true";
import { default as SideBar8MEbsotXRgMeta } from "/www/gamefi/pages/casino/blackjackGame/_components/SideBar.vue?macro=true";
import { default as Status5JISlzNnaXMeta } from "/www/gamefi/pages/casino/blackjackGame/_components/Status.vue?macro=true";
import { default as TableLinenUAdTf9TTcMeta } from "/www/gamefi/pages/casino/blackjackGame/_components/TableLine.vue?macro=true";
import { default as indexX6oC6ICf6kMeta } from "/www/gamefi/pages/casino/blackjackGame/index.vue?macro=true";
import { default as blackjackGameEVudAJo1uKMeta } from "/www/gamefi/pages/casino/blackjackGame/ts/blackjackGame.ts?macro=true";
import { default as blackjackRuleWNR7TqqvO1Meta } from "/www/gamefi/pages/casino/blackjackGame/ts/blackjackRule.ts?macro=true";
import { default as indexJS5L4N20uwMeta } from "/www/gamefi/pages/casino/circleGame/_components/circleBetHistory/index.vue?macro=true";
import { default as indexXLjWfGW9CDMeta } from "/www/gamefi/pages/casino/circleGame/_components/circleBoard/index.vue?macro=true";
import { default as indexW3QnY9BJBoMeta } from "/www/gamefi/pages/casino/circleGame/_components/circleForm/index.vue?macro=true";
import { default as indexi47I7nKjJgMeta } from "/www/gamefi/pages/casino/circleGame/_components/circleResults/index.vue?macro=true";
import { default as index1Gg7s4f6zHMeta } from "/www/gamefi/pages/casino/circleGame/_components/jackpot/index.vue?macro=true";
import { default as indexIvCcwyFp5uMeta } from "/www/gamefi/pages/casino/circleGame/_components/resultPopup/index.vue?macro=true";
import { default as indexO8RzDDmh95Meta } from "/www/gamefi/pages/casino/circleGame/data/index.ts?macro=true";
import { default as indexXJX8iCZja7Meta } from "/www/gamefi/pages/casino/circleGame/index.vue?macro=true";
import { default as indexJgCRPVu0BYMeta } from "/www/gamefi/pages/casino/coinflipGame/_components/betBoard/index.vue?macro=true";
import { default as indexgUCu1g5C8dMeta } from "/www/gamefi/pages/casino/coinflipGame/_components/betOptions/index.vue?macro=true";
import { default as indexhCtf8G4l4qMeta } from "/www/gamefi/pages/casino/coinflipGame/_components/betResult/index.vue?macro=true";
import { default as index1ivpZTaBDgMeta } from "/www/gamefi/pages/casino/coinflipGame/_components/resultHistory/index.vue?macro=true";
import { default as indexeXhJSB2HoIMeta } from "/www/gamefi/pages/casino/coinflipGame/data/index.js?macro=true";
import { default as indexuVkTJbkC1SMeta } from "/www/gamefi/pages/casino/coinflipGame/index.vue?macro=true";
import { default as indexiA5REVesnVMeta } from "/www/gamefi/pages/casino/corgipharaohGame/index.vue?macro=true";
import { default as pharaoh_45anim_4501zqEpSm0wEfMeta } from "/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-01.js?macro=true";
import { default as pharaoh_45anim_4502OZ3KobvcvIMeta } from "/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-02.js?macro=true";
import { default as pharaoh_45anim_45datai9eMwMFyDdMeta } from "/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-data.js?macro=true";
import { default as pharaoh_45methodscqbgsWAKcgMeta } from "/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-methods.js?macro=true";
import { default as pharaohRuleGTMLmELliMMeta } from "/www/gamefi/pages/casino/corgipharaohGame/js/pharaohRule.js?macro=true";
import { default as indexsMGI4mEBGsMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/board/index.vue?macro=true";
import { default as _7OBqe4bjBqDMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/cards/7.vue?macro=true";
import { default as cherrytEzRSfqhSpMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/cards/cherry.vue?macro=true";
import { default as doubleK59EoLhRVbMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/cards/double.vue?macro=true";
import { default as indexKxll6zldlmMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/cards/index.vue?macro=true";
import { default as singlesAvkwnJIZ0Meta } from "/www/gamefi/pages/casino/corgiwildGame/_components/cards/single.vue?macro=true";
import { default as tripleS0St4QG4BWMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/cards/triple.vue?macro=true";
import { default as wildhMk3tCZC4nMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/cards/wild.vue?macro=true";
import { default as indexR3zkWltYBOMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/result/index.vue?macro=true";
import { default as dialogPaylinesfzYpaXn0F6Meta } from "/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogPaylines.vue?macro=true";
import { default as dialogPayTablevNumoiYU3TMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogPayTable.vue?macro=true";
import { default as dialogRulesRvPgeRF9xAMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogRules.vue?macro=true";
import { default as ruleDialog5GtNdZOhr2Meta } from "/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/ruleDialog.vue?macro=true";
import { default as ruleDialogTabs0bFrq3kkf7Meta } from "/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/ruleDialogTabs.vue?macro=true";
import { default as indexwIsvvarPBSMeta } from "/www/gamefi/pages/casino/corgiwildGame/_components/rules/index.vue?macro=true";
import { default as index8LY8oA21RWMeta } from "/www/gamefi/pages/casino/corgiwildGame/data/index.ts?macro=true";
import { default as index5ywX2YEukzMeta } from "/www/gamefi/pages/casino/corgiwildGame/index.vue?macro=true";
import { default as _countDown7Ywf3WvzuZMeta } from "/www/gamefi/pages/casino/crashGame/compo/_countDown.vue?macro=true";
import { default as _jackpotjz4KUmwe3yMeta } from "/www/gamefi/pages/casino/crashGame/compo/_jackpot.vue?macro=true";
import { default as _placeBetBtnm7qDhvx0YMMeta } from "/www/gamefi/pages/casino/crashGame/compo/_placeBetBtn.vue?macro=true";
import { default as _smokeDwd4SlghK5Meta } from "/www/gamefi/pages/casino/crashGame/compo/_smoke.vue?macro=true";
import { default as indexpN6syZXcIqMeta } from "/www/gamefi/pages/casino/crashGame/index.vue?macro=true";
import { default as crashGameRgJ7uYEwTEMeta } from "/www/gamefi/pages/casino/crashGame/js/crashGame.js?macro=true";
import { default as crashRuleseOnemql5zMeta } from "/www/gamefi/pages/casino/crashGame/js/crashRule.js?macro=true";
import { default as CoefficientsidrI0l7AwtMeta } from "/www/gamefi/pages/casino/cryptosGame/_components/Coefficients.vue?macro=true";
import { default as CryptosBoardwP7uVgv7J7Meta } from "/www/gamefi/pages/casino/cryptosGame/_components/CryptosBoard.vue?macro=true";
import { default as indexptjgNd2XukMeta } from "/www/gamefi/pages/casino/cryptosGame/datas/index.ts?macro=true";
import { default as indexMVILR5SPeSMeta } from "/www/gamefi/pages/casino/cryptosGame/index.vue?macro=true";
import { default as Board4wX5MplBfVMeta } from "/www/gamefi/pages/casino/diceGame/_components/Board.vue?macro=true";
import { default as ControlsvvJyprQZk3Meta } from "/www/gamefi/pages/casino/diceGame/_components/Controls.vue?macro=true";
import { default as HistoryBarOBSov7D1xDMeta } from "/www/gamefi/pages/casino/diceGame/_components/HistoryBar.vue?macro=true";
import { default as SliderHzON2xZxEeMeta } from "/www/gamefi/pages/casino/diceGame/_components/Slider.vue?macro=true";
import { default as indexWljfxnPQ55Meta } from "/www/gamefi/pages/casino/diceGame/index.vue?macro=true";
import { default as confirmMXGQzfhqoWMeta } from "/www/gamefi/pages/casino/futuresGame/_components/confirm.vue?macro=true";
import { default as contractStateUM9FX4NxZAMeta } from "/www/gamefi/pages/casino/futuresGame/_components/contractState.vue?macro=true";
import { default as durationPickerXulr2Bfy4wMeta } from "/www/gamefi/pages/casino/futuresGame/_components/durationPicker.vue?macro=true";
import { default as fairnessT93nXu57iEMeta } from "/www/gamefi/pages/casino/futuresGame/_components/fairness.vue?macro=true";
import { default as feeTypeRadioB35DtZaeCfMeta } from "/www/gamefi/pages/casino/futuresGame/_components/feeTypeRadio.vue?macro=true";
import { default as hashBarhCD24qH90PMeta } from "/www/gamefi/pages/casino/futuresGame/_components/hashBar.vue?macro=true";
import { default as howItWorksWJGxjhhRlLMeta } from "/www/gamefi/pages/casino/futuresGame/_components/howItWorks.vue?macro=true";
import { default as profitLossSetting7PIq3xg8pbMeta } from "/www/gamefi/pages/casino/futuresGame/_components/profitLossSetting.vue?macro=true";
import { default as rangeBarEGOoaz9cciMeta } from "/www/gamefi/pages/casino/futuresGame/_components/rangeBar.vue?macro=true";
import { default as RoiCalculatorkq2ULJ23liMeta } from "/www/gamefi/pages/casino/futuresGame/_components/RoiCalculator.vue?macro=true";
import { default as TheWaveChart7oBzZIsnXXMeta } from "/www/gamefi/pages/casino/futuresGame/_components/TheWaveChart.vue?macro=true";
import { default as wagerSettero9ovIQMIsmMeta } from "/www/gamefi/pages/casino/futuresGame/_components/wagerSetter.vue?macro=true";
import { default as wavesCoinMenu3FzrB9cq4pMeta } from "/www/gamefi/pages/casino/futuresGame/_components/wavesCoinMenu.vue?macro=true";
import { default as wavesValueWIARkwhRqZMeta } from "/www/gamefi/pages/casino/futuresGame/_components/wavesValue.vue?macro=true";
import { default as _91id_93lS88449YgHMeta } from "/www/gamefi/pages/casino/futuresGame/[id].vue?macro=true";
import { default as index1heMkfix9OMeta } from "/www/gamefi/pages/casino/futuresGame/index.vue?macro=true";
import { default as indexgOONNE1pgMMeta } from "/www/gamefi/pages/casino/futuresGame/priceFormulation/index.vue?macro=true";
import { default as wave_45chart_45about0a3HHhm5tNMeta } from "/www/gamefi/pages/casino/futuresGame/ts/wave-chart-about.ts?macro=true";
import { default as wavesControlCenterYzdyXFi4e4Meta } from "/www/gamefi/pages/casino/futuresGame/ts/wavesControlCenter.ts?macro=true";
import { default as wavesDataCpSTsvVfxSMeta } from "/www/gamefi/pages/casino/futuresGame/ts/wavesData.ts?macro=true";
import { default as wavesFnWzOY9r0qgfMeta } from "/www/gamefi/pages/casino/futuresGame/ts/wavesFn.ts?macro=true";
import { default as wavesMethodsw9YUubZzVkMeta } from "/www/gamefi/pages/casino/futuresGame/ts/wavesMethods.ts?macro=true";
import { default as btn_45for_45chosinge7cN6M0V2KMeta } from "/www/gamefi/pages/casino/hiloGame/_components/btn-for-chosing.vue?macro=true";
import { default as card_45listdlvD16tV8BMeta } from "/www/gamefi/pages/casino/hiloGame/_components/card-list.vue?macro=true";
import { default as pokerLTGqGutdbpMeta } from "/www/gamefi/pages/casino/hiloGame/_components/poker.vue?macro=true";
import { default as indexyjl3J2dL6eMeta } from "/www/gamefi/pages/casino/hiloGame/index.vue?macro=true";
import { default as hiloConstantY7IZSHE92zMeta } from "/www/gamefi/pages/casino/hiloGame/js/hiloConstant.js?macro=true";
import { default as hiloGameI8mKmwegOFMeta } from "/www/gamefi/pages/casino/hiloGame/js/hiloGame.js?macro=true";
import { default as HiloRule9y2K9kgiZHMeta } from "/www/gamefi/pages/casino/hiloGame/js/HiloRule.js?macro=true";
import { default as cardTypeDXeBjL6zx8Meta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/cardType.vue?macro=true";
import { default as GameRulesModalOx0VQiFJ6VMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/GameRulesModal.vue?macro=true";
import { default as hallCoverxFgI3xtlWQMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/hallCover.vue?macro=true";
import { default as historyListSxhoe3hdr6Meta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/historyList.vue?macro=true";
import { default as nameTagYZERMrEH7yMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/nameTag.vue?macro=true";
import { default as playerF01Gg98k0mMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/player.vue?macro=true";
import { default as pokerCardswuBFD3CB2Meta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/pokerCard.vue?macro=true";
import { default as wagerAmountEKAhh1tOmIMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/wagerAmount.vue?macro=true";
import { default as indexE2aLdWItmiMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/entrance/index.vue?macro=true";
import { default as indexN6jTLuSzYsMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/index.vue?macro=true";
import { default as _91id_9379KAziR3OxMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/indoor/[id].vue?macro=true";
import { default as index7KmZaSTr8VMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/indoor/index.vue?macro=true";
import { default as cardsConstant8IkRk9vQgFMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/cardsConstant.ts?macro=true";
import { default as constantstffwNUmhW2Meta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/constants.ts?macro=true";
import { default as goldenFlowerCommonKHtT3GND5lMeta } from "/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/goldenFlowerCommon.ts?macro=true";
import { default as indexrPgLmdFBAIMeta } from "/www/gamefi/pages/casino/kenoGame/index.vue?macro=true";
import { default as kenou9pSCH7jvMMeta } from "/www/gamefi/pages/casino/kenoGame/js/keno.js?macro=true";
import { default as kenoRuledFwgImJ1NDMeta } from "/www/gamefi/pages/casino/kenoGame/js/kenoRule.js?macro=true";
import { default as betTargetOption8raUcT9hKhMeta } from "/www/gamefi/pages/casino/limboGame/_components/betOptions/betTargetOption.vue?macro=true";
import { default as index0isOmtDx92Meta } from "/www/gamefi/pages/casino/limboGame/_components/betOptions/index.vue?macro=true";
import { default as indextYqgPtrSa0Meta } from "/www/gamefi/pages/casino/limboGame/_components/historyResult/index.vue?macro=true";
import { default as indexcIChxu3PcoMeta } from "/www/gamefi/pages/casino/limboGame/data/index.js?macro=true";
import { default as indexKXyhXltRW2Meta } from "/www/gamefi/pages/casino/limboGame/index.vue?macro=true";
import { default as starsSOxk5s0w6bMeta } from "/www/gamefi/pages/casino/limboGame/js/stars.ts?macro=true";
import { default as util5L9wgrsq8EMeta } from "/www/gamefi/pages/casino/limboGame/js/util.js?macro=true";
import { default as indexhhGSehXYJkMeta } from "/www/gamefi/pages/casino/minesGame/index.vue?macro=true";
import { default as mines_45methodsBFDRw5TLEUMeta } from "/www/gamefi/pages/casino/minesGame/js/mines-methods.js?macro=true";
import { default as mines_45ruleya5PSiLX57Meta } from "/www/gamefi/pages/casino/minesGame/js/mines-rule.js?macro=true";
import { default as MinesBackgroundStepsov5PTFaSdNMeta } from "/www/gamefi/pages/casino/minesGame/js/MinesBackgroundSteps.js?macro=true";
import { default as CanvasTextCMTakCQM5EMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/CanvasText.vue?macro=true";
import { default as HallCardk45M7XB3kmMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/HallCard.vue?macro=true";
import { default as HallCoverDm7b3R14BJMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/HallCover.vue?macro=true";
import { default as HallFooterqN3RyOljsTMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/HallFooter.vue?macro=true";
import { default as HallHeadertToKMwgBVlMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/HallHeader.vue?macro=true";
import { default as historyListlctpImRDyNMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/historyList.vue?macro=true";
import { default as IndoorHeaderoW1Q4OBKYpMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/IndoorHeader.vue?macro=true";
import { default as PlayerListJf9x4KKX4nMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/PlayerList.vue?macro=true";
import { default as playStatuszcqZAYyLdaMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/playStatus.vue?macro=true";
import { default as PokerCard_32copyBOt4kAWXFtMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/PokerCard copy.vue?macro=true";
import { default as PokerCardDqtXr9TX9CMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/PokerCard.vue?macro=true";
import { default as SelectRoomN4mGyvzNK4Meta } from "/www/gamefi/pages/casino/niuniuGame/_components/SelectRoom.vue?macro=true";
import { default as TrendChartwgF2rldNWmMeta } from "/www/gamefi/pages/casino/niuniuGame/_components/TrendChart.vue?macro=true";
import { default as indexj06FmqhUfMMeta } from "/www/gamefi/pages/casino/niuniuGame/entrance/index.vue?macro=true";
import { default as indexYHyKc4kDk6Meta } from "/www/gamefi/pages/casino/niuniuGame/index.vue?macro=true";
import { default as _91id_93SlZ1T6xombMeta } from "/www/gamefi/pages/casino/niuniuGame/indoor/[id].vue?macro=true";
import { default as index10n6YXcm6SMeta } from "/www/gamefi/pages/casino/niuniuGame/indoor/index.vue?macro=true";
import { default as bettingAnimationGFYDC1lP2DMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/bettingAnimation.ts?macro=true";
import { default as cardAnimationNBuOhZLZ6dMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/cardAnimation.ts?macro=true";
import { default as cardConstantsLfJeXXugoXMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/cardConstants.ts?macro=true";
import { default as chipFlowAnimationIzhxwWrHjlMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/chipFlowAnimation.ts?macro=true";
import { default as chipSettlementAnimation5WlilG21ScMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/chipSettlementAnimation.ts?macro=true";
import { default as gameAudio2pN4ZawuTdMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/gameAudio.ts?macro=true";
import { default as gameTpslHoFvK9pnVMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/gameTps.ts?macro=true";
import { default as niuniuCommonzY5HUQYPAwMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/niuniuCommon.ts?macro=true";
import { default as roundResultHelpers5xKdl3aQiQMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/roundResultHelpers.ts?macro=true";
import { default as visibilityHandlerkcQvNq7WiZMeta } from "/www/gamefi/pages/casino/niuniuGame/ts/visibilityHandler.ts?macro=true";
import { default as index7OH0FM8S5hMeta } from "/www/gamefi/pages/casino/plinkoGame/_components/jackpot/index.vue?macro=true";
import { default as indexlVOWdHuTDtMeta } from "/www/gamefi/pages/casino/plinkoGame/_components/multiRows/index.vue?macro=true";
import { default as indexy6QTNZrieEMeta } from "/www/gamefi/pages/casino/plinkoGame/_components/resultHistory/index.vue?macro=true";
import { default as oddsDataZvu086qJCBMeta } from "/www/gamefi/pages/casino/plinkoGame/data/oddsData.ts?macro=true";
import { default as rows10_big0EjLp1fzb5Meta } from "/www/gamefi/pages/casino/plinkoGame/data/rows10_big.js?macro=true";
import { default as rows10_mobOjYTslzaCIMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows10_mob.js?macro=true";
import { default as rows11_bighSjXq9qV1NMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows11_big.js?macro=true";
import { default as rows11_mobXDJO2vYp1lMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows11_mob.js?macro=true";
import { default as rows12_bigcVr59vFvUnMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows12_big.js?macro=true";
import { default as rows12_mobgVAoCaKUYBMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows12_mob.js?macro=true";
import { default as rows13_bigQDKBOV3tJIMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows13_big.js?macro=true";
import { default as rows13_mobRd2un6YFp1Meta } from "/www/gamefi/pages/casino/plinkoGame/data/rows13_mob.js?macro=true";
import { default as rows14_bigCtHUz2QgIxMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows14_big.js?macro=true";
import { default as rows14_mobhkkcoY9UEZMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows14_mob.js?macro=true";
import { default as rows15_bigEp2oLH36NsMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows15_big.js?macro=true";
import { default as rows15_mobKDsLpIfzZjMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows15_mob.js?macro=true";
import { default as rows16_bigap9UT1Q3FoMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows16_big.js?macro=true";
import { default as rows16_mob0iy9SEvA9AMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows16_mob.js?macro=true";
import { default as rows8_bigQDU1n4JAS1Meta } from "/www/gamefi/pages/casino/plinkoGame/data/rows8_big.js?macro=true";
import { default as rows8_mob3xMCnlZr69Meta } from "/www/gamefi/pages/casino/plinkoGame/data/rows8_mob.js?macro=true";
import { default as rows9_bigaWGXPChoT3Meta } from "/www/gamefi/pages/casino/plinkoGame/data/rows9_big.js?macro=true";
import { default as rows9_mobcHPMIAgBctMeta } from "/www/gamefi/pages/casino/plinkoGame/data/rows9_mob.js?macro=true";
import { default as index1jUMMqFBnXMeta } from "/www/gamefi/pages/casino/plinkoGame/index.vue?macro=true";
import { default as autoBetfGf6mZq2c8Meta } from "/www/gamefi/pages/casino/plinkoGame/js/autoBet.ts?macro=true";
import { default as module85Cy41ag75Meta } from "/www/gamefi/pages/casino/plinkoGame/js/module.js?macro=true";
import { default as plinkoGameTohQlurRSSMeta } from "/www/gamefi/pages/casino/plinkoGame/js/plinkoGame.js?macro=true";
import { default as indexlzalHV6y0lMeta } from "/www/gamefi/pages/casino/plinkoGame/utils/index.ts?macro=true";
import { default as hallCovereh5DZBxda9Meta } from "/www/gamefi/pages/casino/redpacketGame/_components/hallCover.vue?macro=true";
import { default as historyList3ADP5CySvYMeta } from "/www/gamefi/pages/casino/redpacketGame/_components/historyList.vue?macro=true";
import { default as packetOJuiShBiLEMeta } from "/www/gamefi/pages/casino/redpacketGame/_components/packet.vue?macro=true";
import { default as index7yGgHsk8ozMeta } from "/www/gamefi/pages/casino/redpacketGame/entrance/index.vue?macro=true";
import { default as indexw5nLLhIQEBMeta } from "/www/gamefi/pages/casino/redpacketGame/index.vue?macro=true";
import { default as _91id_93elALhyAAIRMeta } from "/www/gamefi/pages/casino/redpacketGame/indoor/[id].vue?macro=true";
import { default as indexHeEmnAZaG7Meta } from "/www/gamefi/pages/casino/redpacketGame/indoor/index.vue?macro=true";
import { default as redPacketCommonNMe6iBL156Meta } from "/www/gamefi/pages/casino/redpacketGame/ts/redPacketCommon.ts?macro=true";
import { default as PickersZG5tRmdXGwMeta } from "/www/gamefi/pages/casino/ringGame/_components/Pickers.vue?macro=true";
import { default as indexNVZfvveX6mMeta } from "/www/gamefi/pages/casino/ringGame/_components/Rings/index.vue?macro=true";
import { default as ResultYYHoZPYAYpMeta } from "/www/gamefi/pages/casino/ringGame/_components/Rings/Result.vue?macro=true";
import { default as StarsLaUIlYtgahMeta } from "/www/gamefi/pages/casino/ringGame/_components/Rings/Stars.vue?macro=true";
import { default as indexhh2rhT31XhMeta } from "/www/gamefi/pages/casino/ringGame/data/index.ts?macro=true";
import { default as indexaRCx6gIwLaMeta } from "/www/gamefi/pages/casino/ringGame/index.vue?macro=true";
import { default as ringGamexD2Y1qp0NUMeta } from "/www/gamefi/pages/casino/ringGame/ts/ringGame.ts?macro=true";
import { default as indexi5k6NnlRcQMeta } from "/www/gamefi/pages/casino/rouletteGame/index.vue?macro=true";
import { default as rouletteData8nVDpMSc3gMeta } from "/www/gamefi/pages/casino/rouletteGame/js/rouletteData.ts?macro=true";
import { default as rouletteFngdzsDs7GOFMeta } from "/www/gamefi/pages/casino/rouletteGame/js/rouletteFn.ts?macro=true";
import { default as rouletteGameUaSCy2weXsMeta } from "/www/gamefi/pages/casino/rouletteGame/js/rouletteGame.js?macro=true";
import { default as rouletteRuleCZFSI3VzdIMeta } from "/www/gamefi/pages/casino/rouletteGame/js/rouletteRule.js?macro=true";
import { default as ChoseNumberZB0jnw1SQEMeta } from "/www/gamefi/pages/casino/spacediceGame/_components/BetNumber/ChoseNumber.vue?macro=true";
import { default as indexpzQzeewYIvMeta } from "/www/gamefi/pages/casino/spacediceGame/_components/BetNumber/index.vue?macro=true";
import { default as CasinoIconEput4NxGYAMeta } from "/www/gamefi/pages/casino/spacediceGame/_components/CasinoIcon.vue?macro=true";
import { default as DicePointerS9hRHxjp2YMeta } from "/www/gamefi/pages/casino/spacediceGame/_components/DicePointer.vue?macro=true";
import { default as HistoryBarfqVvmBLObDMeta } from "/www/gamefi/pages/casino/spacediceGame/_components/HistoryBar.vue?macro=true";
import { default as Sliderh60rfUt028Meta } from "/www/gamefi/pages/casino/spacediceGame/_components/Slider.vue?macro=true";
import { default as StatisticsW8uw4jaX7IMeta } from "/www/gamefi/pages/casino/spacediceGame/_components/Statistics.vue?macro=true";
import { default as indexSC96BH4tetMeta } from "/www/gamefi/pages/casino/spacediceGame/index.vue?macro=true";
import { default as composablekL2bttF4XxMeta } from "/www/gamefi/pages/casino/spacediceGame/js/composable.ts?macro=true";
import { default as spaceDiceRule1mqUVNg9qOMeta } from "/www/gamefi/pages/casino/spacediceGame/js/spaceDiceRule.js?macro=true";
import { default as Boarde1LKvA7UuaMeta } from "/www/gamefi/pages/casino/stairsGame/_components/Board.vue?macro=true";
import { default as CoefficientsInner0Q74cArWGuMeta } from "/www/gamefi/pages/casino/stairsGame/_components/CoefficientsInner.vue?macro=true";
import { default as LevelOptionQNF2LBziRvMeta } from "/www/gamefi/pages/casino/stairsGame/_components/LevelOption.vue?macro=true";
import { default as Mans92619KbPLMeta } from "/www/gamefi/pages/casino/stairsGame/_components/Man.vue?macro=true";
import { default as StairsTileGoxHC1LkvdMeta } from "/www/gamefi/pages/casino/stairsGame/_components/StairsTile.vue?macro=true";
import { default as useStairpbCR5xD8ITMeta } from "/www/gamefi/pages/casino/stairsGame/composable/useStair.ts?macro=true";
import { default as indexCzhHWynsn7Meta } from "/www/gamefi/pages/casino/stairsGame/data/index.ts?macro=true";
import { default as indexp6mNTODM7yMeta } from "/www/gamefi/pages/casino/stairsGame/index.vue?macro=true";
import { default as indexIzlC1TuqthMeta } from "/www/gamefi/pages/casino/testGame/index.vue?macro=true";
import { default as BoardxlBH2tyYi7Meta } from "/www/gamefi/pages/casino/towerGame/_components/Board.vue?macro=true";
import { default as LevelOptionnqJpFLEdd6Meta } from "/www/gamefi/pages/casino/towerGame/_components/LevelOption.vue?macro=true";
import { default as Result5GUQ3qP6ywMeta } from "/www/gamefi/pages/casino/towerGame/_components/Result.vue?macro=true";
import { default as index4plxwnBQG7Meta } from "/www/gamefi/pages/casino/towerGame/data/index.ts?macro=true";
import { default as indexPN5eYURMH3Meta } from "/www/gamefi/pages/casino/towerGame/index.vue?macro=true";
import { default as indexZrv5b2Jx7jMeta } from "/www/gamefi/pages/casino/tripleGame/_components/gameContent/index.vue?macro=true";
import { default as indexhvuCedM9zKMeta } from "/www/gamefi/pages/casino/tripleGame/_components/gameControls/index.vue?macro=true";
import { default as indexyicjEhRvleMeta } from "/www/gamefi/pages/casino/tripleGame/_components/result/index.vue?macro=true";
import { default as indexY94mXoY9UVMeta } from "/www/gamefi/pages/casino/tripleGame/_components/resultCoef/index.vue?macro=true";
import { default as indexjsjv76NEsDMeta } from "/www/gamefi/pages/casino/tripleGame/data/index.ts?macro=true";
import { default as indexgqGAimBaDjMeta } from "/www/gamefi/pages/casino/tripleGame/index.vue?macro=true";
import { default as index7wzUdrKCl6Meta } from "/www/gamefi/pages/casino/tripleGame/utils/index.ts?macro=true";
import { default as AnamationQMxG8Or1vgMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/Anamation.vue?macro=true";
import { default as cardTyperNNoX6ghc4Meta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/cardType.vue?macro=true";
import { default as CompareDailogW08l7szIwlMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/CompareDailog.vue?macro=true";
import { default as hallCoverRmBZZ0FDwFMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/hallCover.vue?macro=true";
import { default as historyListaRspfQIRaRMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/historyList.vue?macro=true";
import { default as LastDialogpqcBmE4eceMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/LastDialog.vue?macro=true";
import { default as nameTagNeu5MfJLvsMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/nameTag.vue?macro=true";
import { default as player13cUxY3i7bMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/player.vue?macro=true";
import { default as pokerCardhMCtnqZaoNMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/pokerCard.vue?macro=true";
import { default as ScrollingNoticeebjkIcY6sPMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/ScrollingNotice.vue?macro=true";
import { default as TimeDialogKpllyXPs4tMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/TimeDialog.vue?macro=true";
import { default as wagerAmountnPgmmzA7XiMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/_components/wagerAmount.vue?macro=true";
import { default as indexeAmZtBKwvHMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/entrance/index.vue?macro=true";
import { default as index8FA1bNXayrMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/index.vue?macro=true";
import { default as _91id_93bVqp79ecSFMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/indoor/[id].vue?macro=true";
import { default as indexXgaChwOwLmMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/indoor/index.vue?macro=true";
import { default as animationYAT68y1vKKMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/ts/animation.ts?macro=true";
import { default as cardsConstantqD8ya57HCjMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/ts/cardsConstant.ts?macro=true";
import { default as constantspfC0J8NST6Meta } from "/www/gamefi/pages/casino/zhajinhuaGame/ts/constants.ts?macro=true";
import { default as goldenFlowerCommon6ulFEkDRVGMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/ts/goldenFlowerCommon.ts?macro=true";
import { default as loadGSAPRo8pNP6osnMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/ts/loadGSAP.ts?macro=true";
import { default as musicaHEBcnHGpgMeta } from "/www/gamefi/pages/casino/zhajinhuaGame/ts/music.ts?macro=true";
import { default as allGamesCardMQr9sXpHKkMeta } from "/www/gamefi/pages/index/_components/allGamesCard.vue?macro=true";
import { default as carouselJfongjYvSqMeta } from "/www/gamefi/pages/index/_components/carousel.vue?macro=true";
import { default as gameCardiXfoqAg9ngMeta } from "/www/gamefi/pages/index/_components/gameCard.vue?macro=true";
import { default as indexg4RYZ1JsN2Meta } from "/www/gamefi/pages/index/index.vue?macro=true";
import { default as indexQq32q16AHBMeta } from "/www/gamefi/pages/index/ts/index.ts?macro=true";
import { default as indexKDpsshnscXMeta } from "/www/gamefi/pages/information/index.vue?macro=true";
export default [
  {
    name: button96b0EZI4ysMeta?.name ?? "_demoGround-button___en",
    path: button96b0EZI4ysMeta?.path ?? "/_demoGround/button",
    meta: button96b0EZI4ysMeta || {},
    alias: button96b0EZI4ysMeta?.alias || [],
    redirect: button96b0EZI4ysMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/button.vue").then(m => m.default || m)
  },
  {
    name: button96b0EZI4ysMeta?.name ?? "_demoGround-button___cn",
    path: button96b0EZI4ysMeta?.path ?? "/cn/_demoGround/button",
    meta: button96b0EZI4ysMeta || {},
    alias: button96b0EZI4ysMeta?.alias || [],
    redirect: button96b0EZI4ysMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/button.vue").then(m => m.default || m)
  },
  {
    name: iconMi7AtwvQC9Meta?.name ?? "_demoGround-icon___en",
    path: iconMi7AtwvQC9Meta?.path ?? "/_demoGround/icon",
    meta: iconMi7AtwvQC9Meta || {},
    alias: iconMi7AtwvQC9Meta?.alias || [],
    redirect: iconMi7AtwvQC9Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/icon.vue").then(m => m.default || m)
  },
  {
    name: iconMi7AtwvQC9Meta?.name ?? "_demoGround-icon___cn",
    path: iconMi7AtwvQC9Meta?.path ?? "/cn/_demoGround/icon",
    meta: iconMi7AtwvQC9Meta || {},
    alias: iconMi7AtwvQC9Meta?.alias || [],
    redirect: iconMi7AtwvQC9Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/icon.vue").then(m => m.default || m)
  },
  {
    name: inputSpw3Qfk98FMeta?.name ?? "_demoGround-input___en",
    path: inputSpw3Qfk98FMeta?.path ?? "/_demoGround/input",
    meta: inputSpw3Qfk98FMeta || {},
    alias: inputSpw3Qfk98FMeta?.alias || [],
    redirect: inputSpw3Qfk98FMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/input.vue").then(m => m.default || m)
  },
  {
    name: inputSpw3Qfk98FMeta?.name ?? "_demoGround-input___cn",
    path: inputSpw3Qfk98FMeta?.path ?? "/cn/_demoGround/input",
    meta: inputSpw3Qfk98FMeta || {},
    alias: inputSpw3Qfk98FMeta?.alias || [],
    redirect: inputSpw3Qfk98FMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/input.vue").then(m => m.default || m)
  },
  {
    name: navkuiqJ8kfZKMeta?.name ?? "_demoGround-nav___en",
    path: navkuiqJ8kfZKMeta?.path ?? "/_demoGround/nav",
    meta: navkuiqJ8kfZKMeta || {},
    alias: navkuiqJ8kfZKMeta?.alias || [],
    redirect: navkuiqJ8kfZKMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/nav.vue").then(m => m.default || m)
  },
  {
    name: navkuiqJ8kfZKMeta?.name ?? "_demoGround-nav___cn",
    path: navkuiqJ8kfZKMeta?.path ?? "/cn/_demoGround/nav",
    meta: navkuiqJ8kfZKMeta || {},
    alias: navkuiqJ8kfZKMeta?.alias || [],
    redirect: navkuiqJ8kfZKMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/nav.vue").then(m => m.default || m)
  },
  {
    name: others43HYRsb2c3Meta?.name ?? "_demoGround-others___en",
    path: others43HYRsb2c3Meta?.path ?? "/_demoGround/others",
    meta: others43HYRsb2c3Meta || {},
    alias: others43HYRsb2c3Meta?.alias || [],
    redirect: others43HYRsb2c3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/others.vue").then(m => m.default || m)
  },
  {
    name: others43HYRsb2c3Meta?.name ?? "_demoGround-others___cn",
    path: others43HYRsb2c3Meta?.path ?? "/cn/_demoGround/others",
    meta: others43HYRsb2c3Meta || {},
    alias: others43HYRsb2c3Meta?.alias || [],
    redirect: others43HYRsb2c3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/_demoGround/others.vue").then(m => m.default || m)
  },
  {
    name: _404HG0pb9MEqzMeta?.name ?? "404___en",
    path: _404HG0pb9MEqzMeta?.path ?? "/404",
    meta: _404HG0pb9MEqzMeta || {},
    alias: _404HG0pb9MEqzMeta?.alias || [],
    redirect: _404HG0pb9MEqzMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/404.vue").then(m => m.default || m)
  },
  {
    name: _404HG0pb9MEqzMeta?.name ?? "404___cn",
    path: _404HG0pb9MEqzMeta?.path ?? "/cn/404",
    meta: _404HG0pb9MEqzMeta || {},
    alias: _404HG0pb9MEqzMeta?.alias || [],
    redirect: _404HG0pb9MEqzMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/404.vue").then(m => m.default || m)
  },
  {
    name: BetOptionsfCCnRXE8h2Meta?.name ?? "casino-blackjackGame-_components-BetOptions___en",
    path: BetOptionsfCCnRXE8h2Meta?.path ?? "/casino/blackjackGame/_components/BetOptions",
    meta: BetOptionsfCCnRXE8h2Meta || {},
    alias: BetOptionsfCCnRXE8h2Meta?.alias || [],
    redirect: BetOptionsfCCnRXE8h2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/BetOptions.vue").then(m => m.default || m)
  },
  {
    name: BetOptionsfCCnRXE8h2Meta?.name ?? "casino-blackjackGame-_components-BetOptions___cn",
    path: BetOptionsfCCnRXE8h2Meta?.path ?? "/cn/casino/blackjackGame/_components/BetOptions",
    meta: BetOptionsfCCnRXE8h2Meta || {},
    alias: BetOptionsfCCnRXE8h2Meta?.alias || [],
    redirect: BetOptionsfCCnRXE8h2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/BetOptions.vue").then(m => m.default || m)
  },
  {
    name: Card6OSW9tz7PzMeta?.name ?? "casino-blackjackGame-_components-Card___en",
    path: Card6OSW9tz7PzMeta?.path ?? "/casino/blackjackGame/_components/Card",
    meta: Card6OSW9tz7PzMeta || {},
    alias: Card6OSW9tz7PzMeta?.alias || [],
    redirect: Card6OSW9tz7PzMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/Card.vue").then(m => m.default || m)
  },
  {
    name: Card6OSW9tz7PzMeta?.name ?? "casino-blackjackGame-_components-Card___cn",
    path: Card6OSW9tz7PzMeta?.path ?? "/cn/casino/blackjackGame/_components/Card",
    meta: Card6OSW9tz7PzMeta || {},
    alias: Card6OSW9tz7PzMeta?.alias || [],
    redirect: Card6OSW9tz7PzMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/Card.vue").then(m => m.default || m)
  },
  {
    name: GameControls54eoiVazA3Meta?.name ?? "casino-blackjackGame-_components-GameControls___en",
    path: GameControls54eoiVazA3Meta?.path ?? "/casino/blackjackGame/_components/GameControls",
    meta: GameControls54eoiVazA3Meta || {},
    alias: GameControls54eoiVazA3Meta?.alias || [],
    redirect: GameControls54eoiVazA3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/GameControls.vue").then(m => m.default || m)
  },
  {
    name: GameControls54eoiVazA3Meta?.name ?? "casino-blackjackGame-_components-GameControls___cn",
    path: GameControls54eoiVazA3Meta?.path ?? "/cn/casino/blackjackGame/_components/GameControls",
    meta: GameControls54eoiVazA3Meta || {},
    alias: GameControls54eoiVazA3Meta?.alias || [],
    redirect: GameControls54eoiVazA3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/GameControls.vue").then(m => m.default || m)
  },
  {
    name: Point1vOgesi8AjMeta?.name ?? "casino-blackjackGame-_components-Point___en",
    path: Point1vOgesi8AjMeta?.path ?? "/casino/blackjackGame/_components/Point",
    meta: Point1vOgesi8AjMeta || {},
    alias: Point1vOgesi8AjMeta?.alias || [],
    redirect: Point1vOgesi8AjMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/Point.vue").then(m => m.default || m)
  },
  {
    name: Point1vOgesi8AjMeta?.name ?? "casino-blackjackGame-_components-Point___cn",
    path: Point1vOgesi8AjMeta?.path ?? "/cn/casino/blackjackGame/_components/Point",
    meta: Point1vOgesi8AjMeta || {},
    alias: Point1vOgesi8AjMeta?.alias || [],
    redirect: Point1vOgesi8AjMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/Point.vue").then(m => m.default || m)
  },
  {
    name: ProWinYylXQfPhH4Meta?.name ?? "casino-blackjackGame-_components-ProWin___en",
    path: ProWinYylXQfPhH4Meta?.path ?? "/casino/blackjackGame/_components/ProWin",
    meta: ProWinYylXQfPhH4Meta || {},
    alias: ProWinYylXQfPhH4Meta?.alias || [],
    redirect: ProWinYylXQfPhH4Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/ProWin.vue").then(m => m.default || m)
  },
  {
    name: ProWinYylXQfPhH4Meta?.name ?? "casino-blackjackGame-_components-ProWin___cn",
    path: ProWinYylXQfPhH4Meta?.path ?? "/cn/casino/blackjackGame/_components/ProWin",
    meta: ProWinYylXQfPhH4Meta || {},
    alias: ProWinYylXQfPhH4Meta?.alias || [],
    redirect: ProWinYylXQfPhH4Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/ProWin.vue").then(m => m.default || m)
  },
  {
    name: SideBar8MEbsotXRgMeta?.name ?? "casino-blackjackGame-_components-SideBar___en",
    path: SideBar8MEbsotXRgMeta?.path ?? "/casino/blackjackGame/_components/SideBar",
    meta: SideBar8MEbsotXRgMeta || {},
    alias: SideBar8MEbsotXRgMeta?.alias || [],
    redirect: SideBar8MEbsotXRgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/SideBar.vue").then(m => m.default || m)
  },
  {
    name: SideBar8MEbsotXRgMeta?.name ?? "casino-blackjackGame-_components-SideBar___cn",
    path: SideBar8MEbsotXRgMeta?.path ?? "/cn/casino/blackjackGame/_components/SideBar",
    meta: SideBar8MEbsotXRgMeta || {},
    alias: SideBar8MEbsotXRgMeta?.alias || [],
    redirect: SideBar8MEbsotXRgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/SideBar.vue").then(m => m.default || m)
  },
  {
    name: Status5JISlzNnaXMeta?.name ?? "casino-blackjackGame-_components-Status___en",
    path: Status5JISlzNnaXMeta?.path ?? "/casino/blackjackGame/_components/Status",
    meta: Status5JISlzNnaXMeta || {},
    alias: Status5JISlzNnaXMeta?.alias || [],
    redirect: Status5JISlzNnaXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/Status.vue").then(m => m.default || m)
  },
  {
    name: Status5JISlzNnaXMeta?.name ?? "casino-blackjackGame-_components-Status___cn",
    path: Status5JISlzNnaXMeta?.path ?? "/cn/casino/blackjackGame/_components/Status",
    meta: Status5JISlzNnaXMeta || {},
    alias: Status5JISlzNnaXMeta?.alias || [],
    redirect: Status5JISlzNnaXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/Status.vue").then(m => m.default || m)
  },
  {
    name: TableLinenUAdTf9TTcMeta?.name ?? "casino-blackjackGame-_components-TableLine___en",
    path: TableLinenUAdTf9TTcMeta?.path ?? "/casino/blackjackGame/_components/TableLine",
    meta: TableLinenUAdTf9TTcMeta || {},
    alias: TableLinenUAdTf9TTcMeta?.alias || [],
    redirect: TableLinenUAdTf9TTcMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/TableLine.vue").then(m => m.default || m)
  },
  {
    name: TableLinenUAdTf9TTcMeta?.name ?? "casino-blackjackGame-_components-TableLine___cn",
    path: TableLinenUAdTf9TTcMeta?.path ?? "/cn/casino/blackjackGame/_components/TableLine",
    meta: TableLinenUAdTf9TTcMeta || {},
    alias: TableLinenUAdTf9TTcMeta?.alias || [],
    redirect: TableLinenUAdTf9TTcMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/_components/TableLine.vue").then(m => m.default || m)
  },
  {
    name: indexX6oC6ICf6kMeta?.name ?? "casino-blackjackGame___en",
    path: indexX6oC6ICf6kMeta?.path ?? "/casino/blackjackGame",
    meta: indexX6oC6ICf6kMeta || {},
    alias: indexX6oC6ICf6kMeta?.alias || [],
    redirect: indexX6oC6ICf6kMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexX6oC6ICf6kMeta?.name ?? "casino-blackjackGame___cn",
    path: indexX6oC6ICf6kMeta?.path ?? "/cn/casino/blackjackGame",
    meta: indexX6oC6ICf6kMeta || {},
    alias: indexX6oC6ICf6kMeta?.alias || [],
    redirect: indexX6oC6ICf6kMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/index.vue").then(m => m.default || m)
  },
  {
    name: blackjackGameEVudAJo1uKMeta?.name ?? "casino-blackjackGame-ts-blackjackGame___en",
    path: blackjackGameEVudAJo1uKMeta?.path ?? "/casino/blackjackGame/ts/blackjackGame",
    meta: blackjackGameEVudAJo1uKMeta || {},
    alias: blackjackGameEVudAJo1uKMeta?.alias || [],
    redirect: blackjackGameEVudAJo1uKMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/ts/blackjackGame.ts").then(m => m.default || m)
  },
  {
    name: blackjackGameEVudAJo1uKMeta?.name ?? "casino-blackjackGame-ts-blackjackGame___cn",
    path: blackjackGameEVudAJo1uKMeta?.path ?? "/cn/casino/blackjackGame/ts/blackjackGame",
    meta: blackjackGameEVudAJo1uKMeta || {},
    alias: blackjackGameEVudAJo1uKMeta?.alias || [],
    redirect: blackjackGameEVudAJo1uKMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/ts/blackjackGame.ts").then(m => m.default || m)
  },
  {
    name: blackjackRuleWNR7TqqvO1Meta?.name ?? "casino-blackjackGame-ts-blackjackRule___en",
    path: blackjackRuleWNR7TqqvO1Meta?.path ?? "/casino/blackjackGame/ts/blackjackRule",
    meta: blackjackRuleWNR7TqqvO1Meta || {},
    alias: blackjackRuleWNR7TqqvO1Meta?.alias || [],
    redirect: blackjackRuleWNR7TqqvO1Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/ts/blackjackRule.ts").then(m => m.default || m)
  },
  {
    name: blackjackRuleWNR7TqqvO1Meta?.name ?? "casino-blackjackGame-ts-blackjackRule___cn",
    path: blackjackRuleWNR7TqqvO1Meta?.path ?? "/cn/casino/blackjackGame/ts/blackjackRule",
    meta: blackjackRuleWNR7TqqvO1Meta || {},
    alias: blackjackRuleWNR7TqqvO1Meta?.alias || [],
    redirect: blackjackRuleWNR7TqqvO1Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/blackjackGame/ts/blackjackRule.ts").then(m => m.default || m)
  },
  {
    name: indexJS5L4N20uwMeta?.name ?? "casino-circleGame-_components-circleBetHistory___en",
    path: indexJS5L4N20uwMeta?.path ?? "/casino/circleGame/_components/circleBetHistory",
    meta: indexJS5L4N20uwMeta || {},
    alias: indexJS5L4N20uwMeta?.alias || [],
    redirect: indexJS5L4N20uwMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/circleBetHistory/index.vue").then(m => m.default || m)
  },
  {
    name: indexJS5L4N20uwMeta?.name ?? "casino-circleGame-_components-circleBetHistory___cn",
    path: indexJS5L4N20uwMeta?.path ?? "/cn/casino/circleGame/_components/circleBetHistory",
    meta: indexJS5L4N20uwMeta || {},
    alias: indexJS5L4N20uwMeta?.alias || [],
    redirect: indexJS5L4N20uwMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/circleBetHistory/index.vue").then(m => m.default || m)
  },
  {
    name: indexXLjWfGW9CDMeta?.name ?? "casino-circleGame-_components-circleBoard___en",
    path: indexXLjWfGW9CDMeta?.path ?? "/casino/circleGame/_components/circleBoard",
    meta: indexXLjWfGW9CDMeta || {},
    alias: indexXLjWfGW9CDMeta?.alias || [],
    redirect: indexXLjWfGW9CDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/circleBoard/index.vue").then(m => m.default || m)
  },
  {
    name: indexXLjWfGW9CDMeta?.name ?? "casino-circleGame-_components-circleBoard___cn",
    path: indexXLjWfGW9CDMeta?.path ?? "/cn/casino/circleGame/_components/circleBoard",
    meta: indexXLjWfGW9CDMeta || {},
    alias: indexXLjWfGW9CDMeta?.alias || [],
    redirect: indexXLjWfGW9CDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/circleBoard/index.vue").then(m => m.default || m)
  },
  {
    name: indexW3QnY9BJBoMeta?.name ?? "casino-circleGame-_components-circleForm___en",
    path: indexW3QnY9BJBoMeta?.path ?? "/casino/circleGame/_components/circleForm",
    meta: indexW3QnY9BJBoMeta || {},
    alias: indexW3QnY9BJBoMeta?.alias || [],
    redirect: indexW3QnY9BJBoMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/circleForm/index.vue").then(m => m.default || m)
  },
  {
    name: indexW3QnY9BJBoMeta?.name ?? "casino-circleGame-_components-circleForm___cn",
    path: indexW3QnY9BJBoMeta?.path ?? "/cn/casino/circleGame/_components/circleForm",
    meta: indexW3QnY9BJBoMeta || {},
    alias: indexW3QnY9BJBoMeta?.alias || [],
    redirect: indexW3QnY9BJBoMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/circleForm/index.vue").then(m => m.default || m)
  },
  {
    name: indexi47I7nKjJgMeta?.name ?? "casino-circleGame-_components-circleResults___en",
    path: indexi47I7nKjJgMeta?.path ?? "/casino/circleGame/_components/circleResults",
    meta: indexi47I7nKjJgMeta || {},
    alias: indexi47I7nKjJgMeta?.alias || [],
    redirect: indexi47I7nKjJgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/circleResults/index.vue").then(m => m.default || m)
  },
  {
    name: indexi47I7nKjJgMeta?.name ?? "casino-circleGame-_components-circleResults___cn",
    path: indexi47I7nKjJgMeta?.path ?? "/cn/casino/circleGame/_components/circleResults",
    meta: indexi47I7nKjJgMeta || {},
    alias: indexi47I7nKjJgMeta?.alias || [],
    redirect: indexi47I7nKjJgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/circleResults/index.vue").then(m => m.default || m)
  },
  {
    name: index1Gg7s4f6zHMeta?.name ?? "casino-circleGame-_components-jackpot___en",
    path: index1Gg7s4f6zHMeta?.path ?? "/casino/circleGame/_components/jackpot",
    meta: index1Gg7s4f6zHMeta || {},
    alias: index1Gg7s4f6zHMeta?.alias || [],
    redirect: index1Gg7s4f6zHMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/jackpot/index.vue").then(m => m.default || m)
  },
  {
    name: index1Gg7s4f6zHMeta?.name ?? "casino-circleGame-_components-jackpot___cn",
    path: index1Gg7s4f6zHMeta?.path ?? "/cn/casino/circleGame/_components/jackpot",
    meta: index1Gg7s4f6zHMeta || {},
    alias: index1Gg7s4f6zHMeta?.alias || [],
    redirect: index1Gg7s4f6zHMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/jackpot/index.vue").then(m => m.default || m)
  },
  {
    name: indexIvCcwyFp5uMeta?.name ?? "casino-circleGame-_components-resultPopup___en",
    path: indexIvCcwyFp5uMeta?.path ?? "/casino/circleGame/_components/resultPopup",
    meta: indexIvCcwyFp5uMeta || {},
    alias: indexIvCcwyFp5uMeta?.alias || [],
    redirect: indexIvCcwyFp5uMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/resultPopup/index.vue").then(m => m.default || m)
  },
  {
    name: indexIvCcwyFp5uMeta?.name ?? "casino-circleGame-_components-resultPopup___cn",
    path: indexIvCcwyFp5uMeta?.path ?? "/cn/casino/circleGame/_components/resultPopup",
    meta: indexIvCcwyFp5uMeta || {},
    alias: indexIvCcwyFp5uMeta?.alias || [],
    redirect: indexIvCcwyFp5uMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/_components/resultPopup/index.vue").then(m => m.default || m)
  },
  {
    name: indexO8RzDDmh95Meta?.name ?? "casino-circleGame-data___en",
    path: indexO8RzDDmh95Meta?.path ?? "/casino/circleGame/data",
    meta: indexO8RzDDmh95Meta || {},
    alias: indexO8RzDDmh95Meta?.alias || [],
    redirect: indexO8RzDDmh95Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexO8RzDDmh95Meta?.name ?? "casino-circleGame-data___cn",
    path: indexO8RzDDmh95Meta?.path ?? "/cn/casino/circleGame/data",
    meta: indexO8RzDDmh95Meta || {},
    alias: indexO8RzDDmh95Meta?.alias || [],
    redirect: indexO8RzDDmh95Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexXJX8iCZja7Meta?.name ?? "casino-circleGame___en",
    path: indexXJX8iCZja7Meta?.path ?? "/casino/circleGame",
    meta: indexXJX8iCZja7Meta || {},
    alias: indexXJX8iCZja7Meta?.alias || [],
    redirect: indexXJX8iCZja7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexXJX8iCZja7Meta?.name ?? "casino-circleGame___cn",
    path: indexXJX8iCZja7Meta?.path ?? "/cn/casino/circleGame",
    meta: indexXJX8iCZja7Meta || {},
    alias: indexXJX8iCZja7Meta?.alias || [],
    redirect: indexXJX8iCZja7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/circleGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexJgCRPVu0BYMeta?.name ?? "casino-coinflipGame-_components-betBoard___en",
    path: indexJgCRPVu0BYMeta?.path ?? "/casino/coinflipGame/_components/betBoard",
    meta: indexJgCRPVu0BYMeta || {},
    alias: indexJgCRPVu0BYMeta?.alias || [],
    redirect: indexJgCRPVu0BYMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/_components/betBoard/index.vue").then(m => m.default || m)
  },
  {
    name: indexJgCRPVu0BYMeta?.name ?? "casino-coinflipGame-_components-betBoard___cn",
    path: indexJgCRPVu0BYMeta?.path ?? "/cn/casino/coinflipGame/_components/betBoard",
    meta: indexJgCRPVu0BYMeta || {},
    alias: indexJgCRPVu0BYMeta?.alias || [],
    redirect: indexJgCRPVu0BYMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/_components/betBoard/index.vue").then(m => m.default || m)
  },
  {
    name: indexgUCu1g5C8dMeta?.name ?? "casino-coinflipGame-_components-betOptions___en",
    path: indexgUCu1g5C8dMeta?.path ?? "/casino/coinflipGame/_components/betOptions",
    meta: indexgUCu1g5C8dMeta || {},
    alias: indexgUCu1g5C8dMeta?.alias || [],
    redirect: indexgUCu1g5C8dMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/_components/betOptions/index.vue").then(m => m.default || m)
  },
  {
    name: indexgUCu1g5C8dMeta?.name ?? "casino-coinflipGame-_components-betOptions___cn",
    path: indexgUCu1g5C8dMeta?.path ?? "/cn/casino/coinflipGame/_components/betOptions",
    meta: indexgUCu1g5C8dMeta || {},
    alias: indexgUCu1g5C8dMeta?.alias || [],
    redirect: indexgUCu1g5C8dMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/_components/betOptions/index.vue").then(m => m.default || m)
  },
  {
    name: indexhCtf8G4l4qMeta?.name ?? "casino-coinflipGame-_components-betResult___en",
    path: indexhCtf8G4l4qMeta?.path ?? "/casino/coinflipGame/_components/betResult",
    meta: indexhCtf8G4l4qMeta || {},
    alias: indexhCtf8G4l4qMeta?.alias || [],
    redirect: indexhCtf8G4l4qMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/_components/betResult/index.vue").then(m => m.default || m)
  },
  {
    name: indexhCtf8G4l4qMeta?.name ?? "casino-coinflipGame-_components-betResult___cn",
    path: indexhCtf8G4l4qMeta?.path ?? "/cn/casino/coinflipGame/_components/betResult",
    meta: indexhCtf8G4l4qMeta || {},
    alias: indexhCtf8G4l4qMeta?.alias || [],
    redirect: indexhCtf8G4l4qMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/_components/betResult/index.vue").then(m => m.default || m)
  },
  {
    name: index1ivpZTaBDgMeta?.name ?? "casino-coinflipGame-_components-resultHistory___en",
    path: index1ivpZTaBDgMeta?.path ?? "/casino/coinflipGame/_components/resultHistory",
    meta: index1ivpZTaBDgMeta || {},
    alias: index1ivpZTaBDgMeta?.alias || [],
    redirect: index1ivpZTaBDgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/_components/resultHistory/index.vue").then(m => m.default || m)
  },
  {
    name: index1ivpZTaBDgMeta?.name ?? "casino-coinflipGame-_components-resultHistory___cn",
    path: index1ivpZTaBDgMeta?.path ?? "/cn/casino/coinflipGame/_components/resultHistory",
    meta: index1ivpZTaBDgMeta || {},
    alias: index1ivpZTaBDgMeta?.alias || [],
    redirect: index1ivpZTaBDgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/_components/resultHistory/index.vue").then(m => m.default || m)
  },
  {
    name: indexeXhJSB2HoIMeta?.name ?? "casino-coinflipGame-data___en",
    path: indexeXhJSB2HoIMeta?.path ?? "/casino/coinflipGame/data",
    meta: indexeXhJSB2HoIMeta || {},
    alias: indexeXhJSB2HoIMeta?.alias || [],
    redirect: indexeXhJSB2HoIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/data/index.js").then(m => m.default || m)
  },
  {
    name: indexeXhJSB2HoIMeta?.name ?? "casino-coinflipGame-data___cn",
    path: indexeXhJSB2HoIMeta?.path ?? "/cn/casino/coinflipGame/data",
    meta: indexeXhJSB2HoIMeta || {},
    alias: indexeXhJSB2HoIMeta?.alias || [],
    redirect: indexeXhJSB2HoIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/data/index.js").then(m => m.default || m)
  },
  {
    name: indexuVkTJbkC1SMeta?.name ?? "casino-coinflipGame___en",
    path: indexuVkTJbkC1SMeta?.path ?? "/casino/coinflipGame",
    meta: indexuVkTJbkC1SMeta || {},
    alias: indexuVkTJbkC1SMeta?.alias || [],
    redirect: indexuVkTJbkC1SMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexuVkTJbkC1SMeta?.name ?? "casino-coinflipGame___cn",
    path: indexuVkTJbkC1SMeta?.path ?? "/cn/casino/coinflipGame",
    meta: indexuVkTJbkC1SMeta || {},
    alias: indexuVkTJbkC1SMeta?.alias || [],
    redirect: indexuVkTJbkC1SMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/coinflipGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexiA5REVesnVMeta?.name ?? "casino-corgipharaohGame___en",
    path: indexiA5REVesnVMeta?.path ?? "/casino/corgipharaohGame",
    meta: indexiA5REVesnVMeta || {},
    alias: indexiA5REVesnVMeta?.alias || [],
    redirect: indexiA5REVesnVMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexiA5REVesnVMeta?.name ?? "casino-corgipharaohGame___cn",
    path: indexiA5REVesnVMeta?.path ?? "/cn/casino/corgipharaohGame",
    meta: indexiA5REVesnVMeta || {},
    alias: indexiA5REVesnVMeta?.alias || [],
    redirect: indexiA5REVesnVMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/index.vue").then(m => m.default || m)
  },
  {
    name: pharaoh_45anim_4501zqEpSm0wEfMeta?.name ?? "casino-corgipharaohGame-js-pharaoh-anim-01___en",
    path: pharaoh_45anim_4501zqEpSm0wEfMeta?.path ?? "/casino/corgipharaohGame/js/pharaoh-anim-01",
    meta: pharaoh_45anim_4501zqEpSm0wEfMeta || {},
    alias: pharaoh_45anim_4501zqEpSm0wEfMeta?.alias || [],
    redirect: pharaoh_45anim_4501zqEpSm0wEfMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-01.js").then(m => m.default || m)
  },
  {
    name: pharaoh_45anim_4501zqEpSm0wEfMeta?.name ?? "casino-corgipharaohGame-js-pharaoh-anim-01___cn",
    path: pharaoh_45anim_4501zqEpSm0wEfMeta?.path ?? "/cn/casino/corgipharaohGame/js/pharaoh-anim-01",
    meta: pharaoh_45anim_4501zqEpSm0wEfMeta || {},
    alias: pharaoh_45anim_4501zqEpSm0wEfMeta?.alias || [],
    redirect: pharaoh_45anim_4501zqEpSm0wEfMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-01.js").then(m => m.default || m)
  },
  {
    name: pharaoh_45anim_4502OZ3KobvcvIMeta?.name ?? "casino-corgipharaohGame-js-pharaoh-anim-02___en",
    path: pharaoh_45anim_4502OZ3KobvcvIMeta?.path ?? "/casino/corgipharaohGame/js/pharaoh-anim-02",
    meta: pharaoh_45anim_4502OZ3KobvcvIMeta || {},
    alias: pharaoh_45anim_4502OZ3KobvcvIMeta?.alias || [],
    redirect: pharaoh_45anim_4502OZ3KobvcvIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-02.js").then(m => m.default || m)
  },
  {
    name: pharaoh_45anim_4502OZ3KobvcvIMeta?.name ?? "casino-corgipharaohGame-js-pharaoh-anim-02___cn",
    path: pharaoh_45anim_4502OZ3KobvcvIMeta?.path ?? "/cn/casino/corgipharaohGame/js/pharaoh-anim-02",
    meta: pharaoh_45anim_4502OZ3KobvcvIMeta || {},
    alias: pharaoh_45anim_4502OZ3KobvcvIMeta?.alias || [],
    redirect: pharaoh_45anim_4502OZ3KobvcvIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-02.js").then(m => m.default || m)
  },
  {
    name: pharaoh_45anim_45datai9eMwMFyDdMeta?.name ?? "casino-corgipharaohGame-js-pharaoh-anim-data___en",
    path: pharaoh_45anim_45datai9eMwMFyDdMeta?.path ?? "/casino/corgipharaohGame/js/pharaoh-anim-data",
    meta: pharaoh_45anim_45datai9eMwMFyDdMeta || {},
    alias: pharaoh_45anim_45datai9eMwMFyDdMeta?.alias || [],
    redirect: pharaoh_45anim_45datai9eMwMFyDdMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-data.js").then(m => m.default || m)
  },
  {
    name: pharaoh_45anim_45datai9eMwMFyDdMeta?.name ?? "casino-corgipharaohGame-js-pharaoh-anim-data___cn",
    path: pharaoh_45anim_45datai9eMwMFyDdMeta?.path ?? "/cn/casino/corgipharaohGame/js/pharaoh-anim-data",
    meta: pharaoh_45anim_45datai9eMwMFyDdMeta || {},
    alias: pharaoh_45anim_45datai9eMwMFyDdMeta?.alias || [],
    redirect: pharaoh_45anim_45datai9eMwMFyDdMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-anim-data.js").then(m => m.default || m)
  },
  {
    name: pharaoh_45methodscqbgsWAKcgMeta?.name ?? "casino-corgipharaohGame-js-pharaoh-methods___en",
    path: pharaoh_45methodscqbgsWAKcgMeta?.path ?? "/casino/corgipharaohGame/js/pharaoh-methods",
    meta: pharaoh_45methodscqbgsWAKcgMeta || {},
    alias: pharaoh_45methodscqbgsWAKcgMeta?.alias || [],
    redirect: pharaoh_45methodscqbgsWAKcgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-methods.js").then(m => m.default || m)
  },
  {
    name: pharaoh_45methodscqbgsWAKcgMeta?.name ?? "casino-corgipharaohGame-js-pharaoh-methods___cn",
    path: pharaoh_45methodscqbgsWAKcgMeta?.path ?? "/cn/casino/corgipharaohGame/js/pharaoh-methods",
    meta: pharaoh_45methodscqbgsWAKcgMeta || {},
    alias: pharaoh_45methodscqbgsWAKcgMeta?.alias || [],
    redirect: pharaoh_45methodscqbgsWAKcgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaoh-methods.js").then(m => m.default || m)
  },
  {
    name: pharaohRuleGTMLmELliMMeta?.name ?? "casino-corgipharaohGame-js-pharaohRule___en",
    path: pharaohRuleGTMLmELliMMeta?.path ?? "/casino/corgipharaohGame/js/pharaohRule",
    meta: pharaohRuleGTMLmELliMMeta || {},
    alias: pharaohRuleGTMLmELliMMeta?.alias || [],
    redirect: pharaohRuleGTMLmELliMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaohRule.js").then(m => m.default || m)
  },
  {
    name: pharaohRuleGTMLmELliMMeta?.name ?? "casino-corgipharaohGame-js-pharaohRule___cn",
    path: pharaohRuleGTMLmELliMMeta?.path ?? "/cn/casino/corgipharaohGame/js/pharaohRule",
    meta: pharaohRuleGTMLmELliMMeta || {},
    alias: pharaohRuleGTMLmELliMMeta?.alias || [],
    redirect: pharaohRuleGTMLmELliMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgipharaohGame/js/pharaohRule.js").then(m => m.default || m)
  },
  {
    name: indexsMGI4mEBGsMeta?.name ?? "casino-corgiwildGame-_components-board___en",
    path: indexsMGI4mEBGsMeta?.path ?? "/casino/corgiwildGame/_components/board",
    meta: indexsMGI4mEBGsMeta || {},
    alias: indexsMGI4mEBGsMeta?.alias || [],
    redirect: indexsMGI4mEBGsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/board/index.vue").then(m => m.default || m)
  },
  {
    name: indexsMGI4mEBGsMeta?.name ?? "casino-corgiwildGame-_components-board___cn",
    path: indexsMGI4mEBGsMeta?.path ?? "/cn/casino/corgiwildGame/_components/board",
    meta: indexsMGI4mEBGsMeta || {},
    alias: indexsMGI4mEBGsMeta?.alias || [],
    redirect: indexsMGI4mEBGsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/board/index.vue").then(m => m.default || m)
  },
  {
    name: _7OBqe4bjBqDMeta?.name ?? "casino-corgiwildGame-_components-cards-7___en",
    path: _7OBqe4bjBqDMeta?.path ?? "/casino/corgiwildGame/_components/cards/7",
    meta: _7OBqe4bjBqDMeta || {},
    alias: _7OBqe4bjBqDMeta?.alias || [],
    redirect: _7OBqe4bjBqDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/7.vue").then(m => m.default || m)
  },
  {
    name: _7OBqe4bjBqDMeta?.name ?? "casino-corgiwildGame-_components-cards-7___cn",
    path: _7OBqe4bjBqDMeta?.path ?? "/cn/casino/corgiwildGame/_components/cards/7",
    meta: _7OBqe4bjBqDMeta || {},
    alias: _7OBqe4bjBqDMeta?.alias || [],
    redirect: _7OBqe4bjBqDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/7.vue").then(m => m.default || m)
  },
  {
    name: cherrytEzRSfqhSpMeta?.name ?? "casino-corgiwildGame-_components-cards-cherry___en",
    path: cherrytEzRSfqhSpMeta?.path ?? "/casino/corgiwildGame/_components/cards/cherry",
    meta: cherrytEzRSfqhSpMeta || {},
    alias: cherrytEzRSfqhSpMeta?.alias || [],
    redirect: cherrytEzRSfqhSpMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/cherry.vue").then(m => m.default || m)
  },
  {
    name: cherrytEzRSfqhSpMeta?.name ?? "casino-corgiwildGame-_components-cards-cherry___cn",
    path: cherrytEzRSfqhSpMeta?.path ?? "/cn/casino/corgiwildGame/_components/cards/cherry",
    meta: cherrytEzRSfqhSpMeta || {},
    alias: cherrytEzRSfqhSpMeta?.alias || [],
    redirect: cherrytEzRSfqhSpMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/cherry.vue").then(m => m.default || m)
  },
  {
    name: doubleK59EoLhRVbMeta?.name ?? "casino-corgiwildGame-_components-cards-double___en",
    path: doubleK59EoLhRVbMeta?.path ?? "/casino/corgiwildGame/_components/cards/double",
    meta: doubleK59EoLhRVbMeta || {},
    alias: doubleK59EoLhRVbMeta?.alias || [],
    redirect: doubleK59EoLhRVbMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/double.vue").then(m => m.default || m)
  },
  {
    name: doubleK59EoLhRVbMeta?.name ?? "casino-corgiwildGame-_components-cards-double___cn",
    path: doubleK59EoLhRVbMeta?.path ?? "/cn/casino/corgiwildGame/_components/cards/double",
    meta: doubleK59EoLhRVbMeta || {},
    alias: doubleK59EoLhRVbMeta?.alias || [],
    redirect: doubleK59EoLhRVbMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/double.vue").then(m => m.default || m)
  },
  {
    name: indexKxll6zldlmMeta?.name ?? "casino-corgiwildGame-_components-cards___en",
    path: indexKxll6zldlmMeta?.path ?? "/casino/corgiwildGame/_components/cards",
    meta: indexKxll6zldlmMeta || {},
    alias: indexKxll6zldlmMeta?.alias || [],
    redirect: indexKxll6zldlmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/index.vue").then(m => m.default || m)
  },
  {
    name: indexKxll6zldlmMeta?.name ?? "casino-corgiwildGame-_components-cards___cn",
    path: indexKxll6zldlmMeta?.path ?? "/cn/casino/corgiwildGame/_components/cards",
    meta: indexKxll6zldlmMeta || {},
    alias: indexKxll6zldlmMeta?.alias || [],
    redirect: indexKxll6zldlmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/index.vue").then(m => m.default || m)
  },
  {
    name: singlesAvkwnJIZ0Meta?.name ?? "casino-corgiwildGame-_components-cards-single___en",
    path: singlesAvkwnJIZ0Meta?.path ?? "/casino/corgiwildGame/_components/cards/single",
    meta: singlesAvkwnJIZ0Meta || {},
    alias: singlesAvkwnJIZ0Meta?.alias || [],
    redirect: singlesAvkwnJIZ0Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/single.vue").then(m => m.default || m)
  },
  {
    name: singlesAvkwnJIZ0Meta?.name ?? "casino-corgiwildGame-_components-cards-single___cn",
    path: singlesAvkwnJIZ0Meta?.path ?? "/cn/casino/corgiwildGame/_components/cards/single",
    meta: singlesAvkwnJIZ0Meta || {},
    alias: singlesAvkwnJIZ0Meta?.alias || [],
    redirect: singlesAvkwnJIZ0Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/single.vue").then(m => m.default || m)
  },
  {
    name: tripleS0St4QG4BWMeta?.name ?? "casino-corgiwildGame-_components-cards-triple___en",
    path: tripleS0St4QG4BWMeta?.path ?? "/casino/corgiwildGame/_components/cards/triple",
    meta: tripleS0St4QG4BWMeta || {},
    alias: tripleS0St4QG4BWMeta?.alias || [],
    redirect: tripleS0St4QG4BWMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/triple.vue").then(m => m.default || m)
  },
  {
    name: tripleS0St4QG4BWMeta?.name ?? "casino-corgiwildGame-_components-cards-triple___cn",
    path: tripleS0St4QG4BWMeta?.path ?? "/cn/casino/corgiwildGame/_components/cards/triple",
    meta: tripleS0St4QG4BWMeta || {},
    alias: tripleS0St4QG4BWMeta?.alias || [],
    redirect: tripleS0St4QG4BWMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/triple.vue").then(m => m.default || m)
  },
  {
    name: wildhMk3tCZC4nMeta?.name ?? "casino-corgiwildGame-_components-cards-wild___en",
    path: wildhMk3tCZC4nMeta?.path ?? "/casino/corgiwildGame/_components/cards/wild",
    meta: wildhMk3tCZC4nMeta || {},
    alias: wildhMk3tCZC4nMeta?.alias || [],
    redirect: wildhMk3tCZC4nMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/wild.vue").then(m => m.default || m)
  },
  {
    name: wildhMk3tCZC4nMeta?.name ?? "casino-corgiwildGame-_components-cards-wild___cn",
    path: wildhMk3tCZC4nMeta?.path ?? "/cn/casino/corgiwildGame/_components/cards/wild",
    meta: wildhMk3tCZC4nMeta || {},
    alias: wildhMk3tCZC4nMeta?.alias || [],
    redirect: wildhMk3tCZC4nMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/cards/wild.vue").then(m => m.default || m)
  },
  {
    name: indexR3zkWltYBOMeta?.name ?? "casino-corgiwildGame-_components-result___en",
    path: indexR3zkWltYBOMeta?.path ?? "/casino/corgiwildGame/_components/result",
    meta: indexR3zkWltYBOMeta || {},
    alias: indexR3zkWltYBOMeta?.alias || [],
    redirect: indexR3zkWltYBOMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/result/index.vue").then(m => m.default || m)
  },
  {
    name: indexR3zkWltYBOMeta?.name ?? "casino-corgiwildGame-_components-result___cn",
    path: indexR3zkWltYBOMeta?.path ?? "/cn/casino/corgiwildGame/_components/result",
    meta: indexR3zkWltYBOMeta || {},
    alias: indexR3zkWltYBOMeta?.alias || [],
    redirect: indexR3zkWltYBOMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/result/index.vue").then(m => m.default || m)
  },
  {
    name: dialogPaylinesfzYpaXn0F6Meta?.name ?? "casino-corgiwildGame-_components-rules-_components-dialogPaylines___en",
    path: dialogPaylinesfzYpaXn0F6Meta?.path ?? "/casino/corgiwildGame/_components/rules/_components/dialogPaylines",
    meta: dialogPaylinesfzYpaXn0F6Meta || {},
    alias: dialogPaylinesfzYpaXn0F6Meta?.alias || [],
    redirect: dialogPaylinesfzYpaXn0F6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogPaylines.vue").then(m => m.default || m)
  },
  {
    name: dialogPaylinesfzYpaXn0F6Meta?.name ?? "casino-corgiwildGame-_components-rules-_components-dialogPaylines___cn",
    path: dialogPaylinesfzYpaXn0F6Meta?.path ?? "/cn/casino/corgiwildGame/_components/rules/_components/dialogPaylines",
    meta: dialogPaylinesfzYpaXn0F6Meta || {},
    alias: dialogPaylinesfzYpaXn0F6Meta?.alias || [],
    redirect: dialogPaylinesfzYpaXn0F6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogPaylines.vue").then(m => m.default || m)
  },
  {
    name: dialogPayTablevNumoiYU3TMeta?.name ?? "casino-corgiwildGame-_components-rules-_components-dialogPayTable___en",
    path: dialogPayTablevNumoiYU3TMeta?.path ?? "/casino/corgiwildGame/_components/rules/_components/dialogPayTable",
    meta: dialogPayTablevNumoiYU3TMeta || {},
    alias: dialogPayTablevNumoiYU3TMeta?.alias || [],
    redirect: dialogPayTablevNumoiYU3TMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogPayTable.vue").then(m => m.default || m)
  },
  {
    name: dialogPayTablevNumoiYU3TMeta?.name ?? "casino-corgiwildGame-_components-rules-_components-dialogPayTable___cn",
    path: dialogPayTablevNumoiYU3TMeta?.path ?? "/cn/casino/corgiwildGame/_components/rules/_components/dialogPayTable",
    meta: dialogPayTablevNumoiYU3TMeta || {},
    alias: dialogPayTablevNumoiYU3TMeta?.alias || [],
    redirect: dialogPayTablevNumoiYU3TMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogPayTable.vue").then(m => m.default || m)
  },
  {
    name: dialogRulesRvPgeRF9xAMeta?.name ?? "casino-corgiwildGame-_components-rules-_components-dialogRules___en",
    path: dialogRulesRvPgeRF9xAMeta?.path ?? "/casino/corgiwildGame/_components/rules/_components/dialogRules",
    meta: dialogRulesRvPgeRF9xAMeta || {},
    alias: dialogRulesRvPgeRF9xAMeta?.alias || [],
    redirect: dialogRulesRvPgeRF9xAMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogRules.vue").then(m => m.default || m)
  },
  {
    name: dialogRulesRvPgeRF9xAMeta?.name ?? "casino-corgiwildGame-_components-rules-_components-dialogRules___cn",
    path: dialogRulesRvPgeRF9xAMeta?.path ?? "/cn/casino/corgiwildGame/_components/rules/_components/dialogRules",
    meta: dialogRulesRvPgeRF9xAMeta || {},
    alias: dialogRulesRvPgeRF9xAMeta?.alias || [],
    redirect: dialogRulesRvPgeRF9xAMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/dialogRules.vue").then(m => m.default || m)
  },
  {
    name: ruleDialog5GtNdZOhr2Meta?.name ?? "casino-corgiwildGame-_components-rules-_components-ruleDialog___en",
    path: ruleDialog5GtNdZOhr2Meta?.path ?? "/casino/corgiwildGame/_components/rules/_components/ruleDialog",
    meta: ruleDialog5GtNdZOhr2Meta || {},
    alias: ruleDialog5GtNdZOhr2Meta?.alias || [],
    redirect: ruleDialog5GtNdZOhr2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/ruleDialog.vue").then(m => m.default || m)
  },
  {
    name: ruleDialog5GtNdZOhr2Meta?.name ?? "casino-corgiwildGame-_components-rules-_components-ruleDialog___cn",
    path: ruleDialog5GtNdZOhr2Meta?.path ?? "/cn/casino/corgiwildGame/_components/rules/_components/ruleDialog",
    meta: ruleDialog5GtNdZOhr2Meta || {},
    alias: ruleDialog5GtNdZOhr2Meta?.alias || [],
    redirect: ruleDialog5GtNdZOhr2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/ruleDialog.vue").then(m => m.default || m)
  },
  {
    name: ruleDialogTabs0bFrq3kkf7Meta?.name ?? "casino-corgiwildGame-_components-rules-_components-ruleDialogTabs___en",
    path: ruleDialogTabs0bFrq3kkf7Meta?.path ?? "/casino/corgiwildGame/_components/rules/_components/ruleDialogTabs",
    meta: ruleDialogTabs0bFrq3kkf7Meta || {},
    alias: ruleDialogTabs0bFrq3kkf7Meta?.alias || [],
    redirect: ruleDialogTabs0bFrq3kkf7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/ruleDialogTabs.vue").then(m => m.default || m)
  },
  {
    name: ruleDialogTabs0bFrq3kkf7Meta?.name ?? "casino-corgiwildGame-_components-rules-_components-ruleDialogTabs___cn",
    path: ruleDialogTabs0bFrq3kkf7Meta?.path ?? "/cn/casino/corgiwildGame/_components/rules/_components/ruleDialogTabs",
    meta: ruleDialogTabs0bFrq3kkf7Meta || {},
    alias: ruleDialogTabs0bFrq3kkf7Meta?.alias || [],
    redirect: ruleDialogTabs0bFrq3kkf7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/_components/ruleDialogTabs.vue").then(m => m.default || m)
  },
  {
    name: indexwIsvvarPBSMeta?.name ?? "casino-corgiwildGame-_components-rules___en",
    path: indexwIsvvarPBSMeta?.path ?? "/casino/corgiwildGame/_components/rules",
    meta: indexwIsvvarPBSMeta || {},
    alias: indexwIsvvarPBSMeta?.alias || [],
    redirect: indexwIsvvarPBSMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/index.vue").then(m => m.default || m)
  },
  {
    name: indexwIsvvarPBSMeta?.name ?? "casino-corgiwildGame-_components-rules___cn",
    path: indexwIsvvarPBSMeta?.path ?? "/cn/casino/corgiwildGame/_components/rules",
    meta: indexwIsvvarPBSMeta || {},
    alias: indexwIsvvarPBSMeta?.alias || [],
    redirect: indexwIsvvarPBSMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/_components/rules/index.vue").then(m => m.default || m)
  },
  {
    name: index8LY8oA21RWMeta?.name ?? "casino-corgiwildGame-data___en",
    path: index8LY8oA21RWMeta?.path ?? "/casino/corgiwildGame/data",
    meta: index8LY8oA21RWMeta || {},
    alias: index8LY8oA21RWMeta?.alias || [],
    redirect: index8LY8oA21RWMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: index8LY8oA21RWMeta?.name ?? "casino-corgiwildGame-data___cn",
    path: index8LY8oA21RWMeta?.path ?? "/cn/casino/corgiwildGame/data",
    meta: index8LY8oA21RWMeta || {},
    alias: index8LY8oA21RWMeta?.alias || [],
    redirect: index8LY8oA21RWMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: index5ywX2YEukzMeta?.name ?? "casino-corgiwildGame___en",
    path: index5ywX2YEukzMeta?.path ?? "/casino/corgiwildGame",
    meta: index5ywX2YEukzMeta || {},
    alias: index5ywX2YEukzMeta?.alias || [],
    redirect: index5ywX2YEukzMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/index.vue").then(m => m.default || m)
  },
  {
    name: index5ywX2YEukzMeta?.name ?? "casino-corgiwildGame___cn",
    path: index5ywX2YEukzMeta?.path ?? "/cn/casino/corgiwildGame",
    meta: index5ywX2YEukzMeta || {},
    alias: index5ywX2YEukzMeta?.alias || [],
    redirect: index5ywX2YEukzMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/corgiwildGame/index.vue").then(m => m.default || m)
  },
  {
    name: _countDown7Ywf3WvzuZMeta?.name ?? "casino-crashGame-compo-_countDown___en",
    path: _countDown7Ywf3WvzuZMeta?.path ?? "/casino/crashGame/compo/_countDown",
    meta: _countDown7Ywf3WvzuZMeta || {},
    alias: _countDown7Ywf3WvzuZMeta?.alias || [],
    redirect: _countDown7Ywf3WvzuZMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/compo/_countDown.vue").then(m => m.default || m)
  },
  {
    name: _countDown7Ywf3WvzuZMeta?.name ?? "casino-crashGame-compo-_countDown___cn",
    path: _countDown7Ywf3WvzuZMeta?.path ?? "/cn/casino/crashGame/compo/_countDown",
    meta: _countDown7Ywf3WvzuZMeta || {},
    alias: _countDown7Ywf3WvzuZMeta?.alias || [],
    redirect: _countDown7Ywf3WvzuZMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/compo/_countDown.vue").then(m => m.default || m)
  },
  {
    name: _jackpotjz4KUmwe3yMeta?.name ?? "casino-crashGame-compo-_jackpot___en",
    path: _jackpotjz4KUmwe3yMeta?.path ?? "/casino/crashGame/compo/_jackpot",
    meta: _jackpotjz4KUmwe3yMeta || {},
    alias: _jackpotjz4KUmwe3yMeta?.alias || [],
    redirect: _jackpotjz4KUmwe3yMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/compo/_jackpot.vue").then(m => m.default || m)
  },
  {
    name: _jackpotjz4KUmwe3yMeta?.name ?? "casino-crashGame-compo-_jackpot___cn",
    path: _jackpotjz4KUmwe3yMeta?.path ?? "/cn/casino/crashGame/compo/_jackpot",
    meta: _jackpotjz4KUmwe3yMeta || {},
    alias: _jackpotjz4KUmwe3yMeta?.alias || [],
    redirect: _jackpotjz4KUmwe3yMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/compo/_jackpot.vue").then(m => m.default || m)
  },
  {
    name: _placeBetBtnm7qDhvx0YMMeta?.name ?? "casino-crashGame-compo-_placeBetBtn___en",
    path: _placeBetBtnm7qDhvx0YMMeta?.path ?? "/casino/crashGame/compo/_placeBetBtn",
    meta: _placeBetBtnm7qDhvx0YMMeta || {},
    alias: _placeBetBtnm7qDhvx0YMMeta?.alias || [],
    redirect: _placeBetBtnm7qDhvx0YMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/compo/_placeBetBtn.vue").then(m => m.default || m)
  },
  {
    name: _placeBetBtnm7qDhvx0YMMeta?.name ?? "casino-crashGame-compo-_placeBetBtn___cn",
    path: _placeBetBtnm7qDhvx0YMMeta?.path ?? "/cn/casino/crashGame/compo/_placeBetBtn",
    meta: _placeBetBtnm7qDhvx0YMMeta || {},
    alias: _placeBetBtnm7qDhvx0YMMeta?.alias || [],
    redirect: _placeBetBtnm7qDhvx0YMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/compo/_placeBetBtn.vue").then(m => m.default || m)
  },
  {
    name: _smokeDwd4SlghK5Meta?.name ?? "casino-crashGame-compo-_smoke___en",
    path: _smokeDwd4SlghK5Meta?.path ?? "/casino/crashGame/compo/_smoke",
    meta: _smokeDwd4SlghK5Meta || {},
    alias: _smokeDwd4SlghK5Meta?.alias || [],
    redirect: _smokeDwd4SlghK5Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/compo/_smoke.vue").then(m => m.default || m)
  },
  {
    name: _smokeDwd4SlghK5Meta?.name ?? "casino-crashGame-compo-_smoke___cn",
    path: _smokeDwd4SlghK5Meta?.path ?? "/cn/casino/crashGame/compo/_smoke",
    meta: _smokeDwd4SlghK5Meta || {},
    alias: _smokeDwd4SlghK5Meta?.alias || [],
    redirect: _smokeDwd4SlghK5Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/compo/_smoke.vue").then(m => m.default || m)
  },
  {
    name: indexpN6syZXcIqMeta?.name ?? "casino-crashGame___en",
    path: indexpN6syZXcIqMeta?.path ?? "/casino/crashGame",
    meta: indexpN6syZXcIqMeta || {},
    alias: indexpN6syZXcIqMeta?.alias || [],
    redirect: indexpN6syZXcIqMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexpN6syZXcIqMeta?.name ?? "casino-crashGame___cn",
    path: indexpN6syZXcIqMeta?.path ?? "/cn/casino/crashGame",
    meta: indexpN6syZXcIqMeta || {},
    alias: indexpN6syZXcIqMeta?.alias || [],
    redirect: indexpN6syZXcIqMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/index.vue").then(m => m.default || m)
  },
  {
    name: crashGameRgJ7uYEwTEMeta?.name ?? "casino-crashGame-js-crashGame___en",
    path: crashGameRgJ7uYEwTEMeta?.path ?? "/casino/crashGame/js/crashGame",
    meta: crashGameRgJ7uYEwTEMeta || {},
    alias: crashGameRgJ7uYEwTEMeta?.alias || [],
    redirect: crashGameRgJ7uYEwTEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/js/crashGame.js").then(m => m.default || m)
  },
  {
    name: crashGameRgJ7uYEwTEMeta?.name ?? "casino-crashGame-js-crashGame___cn",
    path: crashGameRgJ7uYEwTEMeta?.path ?? "/cn/casino/crashGame/js/crashGame",
    meta: crashGameRgJ7uYEwTEMeta || {},
    alias: crashGameRgJ7uYEwTEMeta?.alias || [],
    redirect: crashGameRgJ7uYEwTEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/js/crashGame.js").then(m => m.default || m)
  },
  {
    name: crashRuleseOnemql5zMeta?.name ?? "casino-crashGame-js-crashRule___en",
    path: crashRuleseOnemql5zMeta?.path ?? "/casino/crashGame/js/crashRule",
    meta: crashRuleseOnemql5zMeta || {},
    alias: crashRuleseOnemql5zMeta?.alias || [],
    redirect: crashRuleseOnemql5zMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/js/crashRule.js").then(m => m.default || m)
  },
  {
    name: crashRuleseOnemql5zMeta?.name ?? "casino-crashGame-js-crashRule___cn",
    path: crashRuleseOnemql5zMeta?.path ?? "/cn/casino/crashGame/js/crashRule",
    meta: crashRuleseOnemql5zMeta || {},
    alias: crashRuleseOnemql5zMeta?.alias || [],
    redirect: crashRuleseOnemql5zMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/crashGame/js/crashRule.js").then(m => m.default || m)
  },
  {
    name: CoefficientsidrI0l7AwtMeta?.name ?? "casino-cryptosGame-_components-Coefficients___en",
    path: CoefficientsidrI0l7AwtMeta?.path ?? "/casino/cryptosGame/_components/Coefficients",
    meta: CoefficientsidrI0l7AwtMeta || {},
    alias: CoefficientsidrI0l7AwtMeta?.alias || [],
    redirect: CoefficientsidrI0l7AwtMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/cryptosGame/_components/Coefficients.vue").then(m => m.default || m)
  },
  {
    name: CoefficientsidrI0l7AwtMeta?.name ?? "casino-cryptosGame-_components-Coefficients___cn",
    path: CoefficientsidrI0l7AwtMeta?.path ?? "/cn/casino/cryptosGame/_components/Coefficients",
    meta: CoefficientsidrI0l7AwtMeta || {},
    alias: CoefficientsidrI0l7AwtMeta?.alias || [],
    redirect: CoefficientsidrI0l7AwtMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/cryptosGame/_components/Coefficients.vue").then(m => m.default || m)
  },
  {
    name: CryptosBoardwP7uVgv7J7Meta?.name ?? "casino-cryptosGame-_components-CryptosBoard___en",
    path: CryptosBoardwP7uVgv7J7Meta?.path ?? "/casino/cryptosGame/_components/CryptosBoard",
    meta: CryptosBoardwP7uVgv7J7Meta || {},
    alias: CryptosBoardwP7uVgv7J7Meta?.alias || [],
    redirect: CryptosBoardwP7uVgv7J7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/cryptosGame/_components/CryptosBoard.vue").then(m => m.default || m)
  },
  {
    name: CryptosBoardwP7uVgv7J7Meta?.name ?? "casino-cryptosGame-_components-CryptosBoard___cn",
    path: CryptosBoardwP7uVgv7J7Meta?.path ?? "/cn/casino/cryptosGame/_components/CryptosBoard",
    meta: CryptosBoardwP7uVgv7J7Meta || {},
    alias: CryptosBoardwP7uVgv7J7Meta?.alias || [],
    redirect: CryptosBoardwP7uVgv7J7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/cryptosGame/_components/CryptosBoard.vue").then(m => m.default || m)
  },
  {
    name: indexptjgNd2XukMeta?.name ?? "casino-cryptosGame-datas___en",
    path: indexptjgNd2XukMeta?.path ?? "/casino/cryptosGame/datas",
    meta: indexptjgNd2XukMeta || {},
    alias: indexptjgNd2XukMeta?.alias || [],
    redirect: indexptjgNd2XukMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/cryptosGame/datas/index.ts").then(m => m.default || m)
  },
  {
    name: indexptjgNd2XukMeta?.name ?? "casino-cryptosGame-datas___cn",
    path: indexptjgNd2XukMeta?.path ?? "/cn/casino/cryptosGame/datas",
    meta: indexptjgNd2XukMeta || {},
    alias: indexptjgNd2XukMeta?.alias || [],
    redirect: indexptjgNd2XukMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/cryptosGame/datas/index.ts").then(m => m.default || m)
  },
  {
    name: indexMVILR5SPeSMeta?.name ?? "casino-cryptosGame___en",
    path: indexMVILR5SPeSMeta?.path ?? "/casino/cryptosGame",
    meta: indexMVILR5SPeSMeta || {},
    alias: indexMVILR5SPeSMeta?.alias || [],
    redirect: indexMVILR5SPeSMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/cryptosGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexMVILR5SPeSMeta?.name ?? "casino-cryptosGame___cn",
    path: indexMVILR5SPeSMeta?.path ?? "/cn/casino/cryptosGame",
    meta: indexMVILR5SPeSMeta || {},
    alias: indexMVILR5SPeSMeta?.alias || [],
    redirect: indexMVILR5SPeSMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/cryptosGame/index.vue").then(m => m.default || m)
  },
  {
    name: Board4wX5MplBfVMeta?.name ?? "casino-diceGame-_components-Board___en",
    path: Board4wX5MplBfVMeta?.path ?? "/casino/diceGame/_components/Board",
    meta: Board4wX5MplBfVMeta || {},
    alias: Board4wX5MplBfVMeta?.alias || [],
    redirect: Board4wX5MplBfVMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/_components/Board.vue").then(m => m.default || m)
  },
  {
    name: Board4wX5MplBfVMeta?.name ?? "casino-diceGame-_components-Board___cn",
    path: Board4wX5MplBfVMeta?.path ?? "/cn/casino/diceGame/_components/Board",
    meta: Board4wX5MplBfVMeta || {},
    alias: Board4wX5MplBfVMeta?.alias || [],
    redirect: Board4wX5MplBfVMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/_components/Board.vue").then(m => m.default || m)
  },
  {
    name: ControlsvvJyprQZk3Meta?.name ?? "casino-diceGame-_components-Controls___en",
    path: ControlsvvJyprQZk3Meta?.path ?? "/casino/diceGame/_components/Controls",
    meta: ControlsvvJyprQZk3Meta || {},
    alias: ControlsvvJyprQZk3Meta?.alias || [],
    redirect: ControlsvvJyprQZk3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/_components/Controls.vue").then(m => m.default || m)
  },
  {
    name: ControlsvvJyprQZk3Meta?.name ?? "casino-diceGame-_components-Controls___cn",
    path: ControlsvvJyprQZk3Meta?.path ?? "/cn/casino/diceGame/_components/Controls",
    meta: ControlsvvJyprQZk3Meta || {},
    alias: ControlsvvJyprQZk3Meta?.alias || [],
    redirect: ControlsvvJyprQZk3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/_components/Controls.vue").then(m => m.default || m)
  },
  {
    name: HistoryBarOBSov7D1xDMeta?.name ?? "casino-diceGame-_components-HistoryBar___en",
    path: HistoryBarOBSov7D1xDMeta?.path ?? "/casino/diceGame/_components/HistoryBar",
    meta: HistoryBarOBSov7D1xDMeta || {},
    alias: HistoryBarOBSov7D1xDMeta?.alias || [],
    redirect: HistoryBarOBSov7D1xDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/_components/HistoryBar.vue").then(m => m.default || m)
  },
  {
    name: HistoryBarOBSov7D1xDMeta?.name ?? "casino-diceGame-_components-HistoryBar___cn",
    path: HistoryBarOBSov7D1xDMeta?.path ?? "/cn/casino/diceGame/_components/HistoryBar",
    meta: HistoryBarOBSov7D1xDMeta || {},
    alias: HistoryBarOBSov7D1xDMeta?.alias || [],
    redirect: HistoryBarOBSov7D1xDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/_components/HistoryBar.vue").then(m => m.default || m)
  },
  {
    name: SliderHzON2xZxEeMeta?.name ?? "casino-diceGame-_components-Slider___en",
    path: SliderHzON2xZxEeMeta?.path ?? "/casino/diceGame/_components/Slider",
    meta: SliderHzON2xZxEeMeta || {},
    alias: SliderHzON2xZxEeMeta?.alias || [],
    redirect: SliderHzON2xZxEeMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/_components/Slider.vue").then(m => m.default || m)
  },
  {
    name: SliderHzON2xZxEeMeta?.name ?? "casino-diceGame-_components-Slider___cn",
    path: SliderHzON2xZxEeMeta?.path ?? "/cn/casino/diceGame/_components/Slider",
    meta: SliderHzON2xZxEeMeta || {},
    alias: SliderHzON2xZxEeMeta?.alias || [],
    redirect: SliderHzON2xZxEeMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/_components/Slider.vue").then(m => m.default || m)
  },
  {
    name: indexWljfxnPQ55Meta?.name ?? "casino-diceGame___en",
    path: indexWljfxnPQ55Meta?.path ?? "/casino/diceGame",
    meta: indexWljfxnPQ55Meta || {},
    alias: indexWljfxnPQ55Meta?.alias || [],
    redirect: indexWljfxnPQ55Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexWljfxnPQ55Meta?.name ?? "casino-diceGame___cn",
    path: indexWljfxnPQ55Meta?.path ?? "/cn/casino/diceGame",
    meta: indexWljfxnPQ55Meta || {},
    alias: indexWljfxnPQ55Meta?.alias || [],
    redirect: indexWljfxnPQ55Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/diceGame/index.vue").then(m => m.default || m)
  },
  {
    name: confirmMXGQzfhqoWMeta?.name ?? "casino-futuresGame-_components-confirm___en",
    path: confirmMXGQzfhqoWMeta?.path ?? "/casino/futuresGame/_components/confirm",
    meta: confirmMXGQzfhqoWMeta || {},
    alias: confirmMXGQzfhqoWMeta?.alias || [],
    redirect: confirmMXGQzfhqoWMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmMXGQzfhqoWMeta?.name ?? "casino-futuresGame-_components-confirm___cn",
    path: confirmMXGQzfhqoWMeta?.path ?? "/cn/casino/futuresGame/_components/confirm",
    meta: confirmMXGQzfhqoWMeta || {},
    alias: confirmMXGQzfhqoWMeta?.alias || [],
    redirect: confirmMXGQzfhqoWMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/confirm.vue").then(m => m.default || m)
  },
  {
    name: contractStateUM9FX4NxZAMeta?.name ?? "casino-futuresGame-_components-contractState___en",
    path: contractStateUM9FX4NxZAMeta?.path ?? "/casino/futuresGame/_components/contractState",
    meta: contractStateUM9FX4NxZAMeta || {},
    alias: contractStateUM9FX4NxZAMeta?.alias || [],
    redirect: contractStateUM9FX4NxZAMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/contractState.vue").then(m => m.default || m)
  },
  {
    name: contractStateUM9FX4NxZAMeta?.name ?? "casino-futuresGame-_components-contractState___cn",
    path: contractStateUM9FX4NxZAMeta?.path ?? "/cn/casino/futuresGame/_components/contractState",
    meta: contractStateUM9FX4NxZAMeta || {},
    alias: contractStateUM9FX4NxZAMeta?.alias || [],
    redirect: contractStateUM9FX4NxZAMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/contractState.vue").then(m => m.default || m)
  },
  {
    name: durationPickerXulr2Bfy4wMeta?.name ?? "casino-futuresGame-_components-durationPicker___en",
    path: durationPickerXulr2Bfy4wMeta?.path ?? "/casino/futuresGame/_components/durationPicker",
    meta: durationPickerXulr2Bfy4wMeta || {},
    alias: durationPickerXulr2Bfy4wMeta?.alias || [],
    redirect: durationPickerXulr2Bfy4wMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/durationPicker.vue").then(m => m.default || m)
  },
  {
    name: durationPickerXulr2Bfy4wMeta?.name ?? "casino-futuresGame-_components-durationPicker___cn",
    path: durationPickerXulr2Bfy4wMeta?.path ?? "/cn/casino/futuresGame/_components/durationPicker",
    meta: durationPickerXulr2Bfy4wMeta || {},
    alias: durationPickerXulr2Bfy4wMeta?.alias || [],
    redirect: durationPickerXulr2Bfy4wMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/durationPicker.vue").then(m => m.default || m)
  },
  {
    name: fairnessT93nXu57iEMeta?.name ?? "casino-futuresGame-_components-fairness___en",
    path: fairnessT93nXu57iEMeta?.path ?? "/casino/futuresGame/_components/fairness",
    meta: fairnessT93nXu57iEMeta || {},
    alias: fairnessT93nXu57iEMeta?.alias || [],
    redirect: fairnessT93nXu57iEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/fairness.vue").then(m => m.default || m)
  },
  {
    name: fairnessT93nXu57iEMeta?.name ?? "casino-futuresGame-_components-fairness___cn",
    path: fairnessT93nXu57iEMeta?.path ?? "/cn/casino/futuresGame/_components/fairness",
    meta: fairnessT93nXu57iEMeta || {},
    alias: fairnessT93nXu57iEMeta?.alias || [],
    redirect: fairnessT93nXu57iEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/fairness.vue").then(m => m.default || m)
  },
  {
    name: feeTypeRadioB35DtZaeCfMeta?.name ?? "casino-futuresGame-_components-feeTypeRadio___en",
    path: feeTypeRadioB35DtZaeCfMeta?.path ?? "/casino/futuresGame/_components/feeTypeRadio",
    meta: feeTypeRadioB35DtZaeCfMeta || {},
    alias: feeTypeRadioB35DtZaeCfMeta?.alias || [],
    redirect: feeTypeRadioB35DtZaeCfMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/feeTypeRadio.vue").then(m => m.default || m)
  },
  {
    name: feeTypeRadioB35DtZaeCfMeta?.name ?? "casino-futuresGame-_components-feeTypeRadio___cn",
    path: feeTypeRadioB35DtZaeCfMeta?.path ?? "/cn/casino/futuresGame/_components/feeTypeRadio",
    meta: feeTypeRadioB35DtZaeCfMeta || {},
    alias: feeTypeRadioB35DtZaeCfMeta?.alias || [],
    redirect: feeTypeRadioB35DtZaeCfMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/feeTypeRadio.vue").then(m => m.default || m)
  },
  {
    name: hashBarhCD24qH90PMeta?.name ?? "casino-futuresGame-_components-hashBar___en",
    path: hashBarhCD24qH90PMeta?.path ?? "/casino/futuresGame/_components/hashBar",
    meta: hashBarhCD24qH90PMeta || {},
    alias: hashBarhCD24qH90PMeta?.alias || [],
    redirect: hashBarhCD24qH90PMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/hashBar.vue").then(m => m.default || m)
  },
  {
    name: hashBarhCD24qH90PMeta?.name ?? "casino-futuresGame-_components-hashBar___cn",
    path: hashBarhCD24qH90PMeta?.path ?? "/cn/casino/futuresGame/_components/hashBar",
    meta: hashBarhCD24qH90PMeta || {},
    alias: hashBarhCD24qH90PMeta?.alias || [],
    redirect: hashBarhCD24qH90PMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/hashBar.vue").then(m => m.default || m)
  },
  {
    name: howItWorksWJGxjhhRlLMeta?.name ?? "casino-futuresGame-_components-howItWorks___en",
    path: howItWorksWJGxjhhRlLMeta?.path ?? "/casino/futuresGame/_components/howItWorks",
    meta: howItWorksWJGxjhhRlLMeta || {},
    alias: howItWorksWJGxjhhRlLMeta?.alias || [],
    redirect: howItWorksWJGxjhhRlLMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/howItWorks.vue").then(m => m.default || m)
  },
  {
    name: howItWorksWJGxjhhRlLMeta?.name ?? "casino-futuresGame-_components-howItWorks___cn",
    path: howItWorksWJGxjhhRlLMeta?.path ?? "/cn/casino/futuresGame/_components/howItWorks",
    meta: howItWorksWJGxjhhRlLMeta || {},
    alias: howItWorksWJGxjhhRlLMeta?.alias || [],
    redirect: howItWorksWJGxjhhRlLMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/howItWorks.vue").then(m => m.default || m)
  },
  {
    name: profitLossSetting7PIq3xg8pbMeta?.name ?? "casino-futuresGame-_components-profitLossSetting___en",
    path: profitLossSetting7PIq3xg8pbMeta?.path ?? "/casino/futuresGame/_components/profitLossSetting",
    meta: profitLossSetting7PIq3xg8pbMeta || {},
    alias: profitLossSetting7PIq3xg8pbMeta?.alias || [],
    redirect: profitLossSetting7PIq3xg8pbMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/profitLossSetting.vue").then(m => m.default || m)
  },
  {
    name: profitLossSetting7PIq3xg8pbMeta?.name ?? "casino-futuresGame-_components-profitLossSetting___cn",
    path: profitLossSetting7PIq3xg8pbMeta?.path ?? "/cn/casino/futuresGame/_components/profitLossSetting",
    meta: profitLossSetting7PIq3xg8pbMeta || {},
    alias: profitLossSetting7PIq3xg8pbMeta?.alias || [],
    redirect: profitLossSetting7PIq3xg8pbMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/profitLossSetting.vue").then(m => m.default || m)
  },
  {
    name: rangeBarEGOoaz9cciMeta?.name ?? "casino-futuresGame-_components-rangeBar___en",
    path: rangeBarEGOoaz9cciMeta?.path ?? "/casino/futuresGame/_components/rangeBar",
    meta: rangeBarEGOoaz9cciMeta || {},
    alias: rangeBarEGOoaz9cciMeta?.alias || [],
    redirect: rangeBarEGOoaz9cciMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/rangeBar.vue").then(m => m.default || m)
  },
  {
    name: rangeBarEGOoaz9cciMeta?.name ?? "casino-futuresGame-_components-rangeBar___cn",
    path: rangeBarEGOoaz9cciMeta?.path ?? "/cn/casino/futuresGame/_components/rangeBar",
    meta: rangeBarEGOoaz9cciMeta || {},
    alias: rangeBarEGOoaz9cciMeta?.alias || [],
    redirect: rangeBarEGOoaz9cciMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/rangeBar.vue").then(m => m.default || m)
  },
  {
    name: RoiCalculatorkq2ULJ23liMeta?.name ?? "casino-futuresGame-_components-RoiCalculator___en",
    path: RoiCalculatorkq2ULJ23liMeta?.path ?? "/casino/futuresGame/_components/RoiCalculator",
    meta: RoiCalculatorkq2ULJ23liMeta || {},
    alias: RoiCalculatorkq2ULJ23liMeta?.alias || [],
    redirect: RoiCalculatorkq2ULJ23liMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/RoiCalculator.vue").then(m => m.default || m)
  },
  {
    name: RoiCalculatorkq2ULJ23liMeta?.name ?? "casino-futuresGame-_components-RoiCalculator___cn",
    path: RoiCalculatorkq2ULJ23liMeta?.path ?? "/cn/casino/futuresGame/_components/RoiCalculator",
    meta: RoiCalculatorkq2ULJ23liMeta || {},
    alias: RoiCalculatorkq2ULJ23liMeta?.alias || [],
    redirect: RoiCalculatorkq2ULJ23liMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/RoiCalculator.vue").then(m => m.default || m)
  },
  {
    name: TheWaveChart7oBzZIsnXXMeta?.name ?? "casino-futuresGame-_components-TheWaveChart___en",
    path: TheWaveChart7oBzZIsnXXMeta?.path ?? "/casino/futuresGame/_components/TheWaveChart",
    meta: TheWaveChart7oBzZIsnXXMeta || {},
    alias: TheWaveChart7oBzZIsnXXMeta?.alias || [],
    redirect: TheWaveChart7oBzZIsnXXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/TheWaveChart.vue").then(m => m.default || m)
  },
  {
    name: TheWaveChart7oBzZIsnXXMeta?.name ?? "casino-futuresGame-_components-TheWaveChart___cn",
    path: TheWaveChart7oBzZIsnXXMeta?.path ?? "/cn/casino/futuresGame/_components/TheWaveChart",
    meta: TheWaveChart7oBzZIsnXXMeta || {},
    alias: TheWaveChart7oBzZIsnXXMeta?.alias || [],
    redirect: TheWaveChart7oBzZIsnXXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/TheWaveChart.vue").then(m => m.default || m)
  },
  {
    name: wagerSettero9ovIQMIsmMeta?.name ?? "casino-futuresGame-_components-wagerSetter___en",
    path: wagerSettero9ovIQMIsmMeta?.path ?? "/casino/futuresGame/_components/wagerSetter",
    meta: wagerSettero9ovIQMIsmMeta || {},
    alias: wagerSettero9ovIQMIsmMeta?.alias || [],
    redirect: wagerSettero9ovIQMIsmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/wagerSetter.vue").then(m => m.default || m)
  },
  {
    name: wagerSettero9ovIQMIsmMeta?.name ?? "casino-futuresGame-_components-wagerSetter___cn",
    path: wagerSettero9ovIQMIsmMeta?.path ?? "/cn/casino/futuresGame/_components/wagerSetter",
    meta: wagerSettero9ovIQMIsmMeta || {},
    alias: wagerSettero9ovIQMIsmMeta?.alias || [],
    redirect: wagerSettero9ovIQMIsmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/wagerSetter.vue").then(m => m.default || m)
  },
  {
    name: wavesCoinMenu3FzrB9cq4pMeta?.name ?? "casino-futuresGame-_components-wavesCoinMenu___en",
    path: wavesCoinMenu3FzrB9cq4pMeta?.path ?? "/casino/futuresGame/_components/wavesCoinMenu",
    meta: wavesCoinMenu3FzrB9cq4pMeta || {},
    alias: wavesCoinMenu3FzrB9cq4pMeta?.alias || [],
    redirect: wavesCoinMenu3FzrB9cq4pMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/wavesCoinMenu.vue").then(m => m.default || m)
  },
  {
    name: wavesCoinMenu3FzrB9cq4pMeta?.name ?? "casino-futuresGame-_components-wavesCoinMenu___cn",
    path: wavesCoinMenu3FzrB9cq4pMeta?.path ?? "/cn/casino/futuresGame/_components/wavesCoinMenu",
    meta: wavesCoinMenu3FzrB9cq4pMeta || {},
    alias: wavesCoinMenu3FzrB9cq4pMeta?.alias || [],
    redirect: wavesCoinMenu3FzrB9cq4pMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/wavesCoinMenu.vue").then(m => m.default || m)
  },
  {
    name: wavesValueWIARkwhRqZMeta?.name ?? "casino-futuresGame-_components-wavesValue___en",
    path: wavesValueWIARkwhRqZMeta?.path ?? "/casino/futuresGame/_components/wavesValue",
    meta: wavesValueWIARkwhRqZMeta || {},
    alias: wavesValueWIARkwhRqZMeta?.alias || [],
    redirect: wavesValueWIARkwhRqZMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/wavesValue.vue").then(m => m.default || m)
  },
  {
    name: wavesValueWIARkwhRqZMeta?.name ?? "casino-futuresGame-_components-wavesValue___cn",
    path: wavesValueWIARkwhRqZMeta?.path ?? "/cn/casino/futuresGame/_components/wavesValue",
    meta: wavesValueWIARkwhRqZMeta || {},
    alias: wavesValueWIARkwhRqZMeta?.alias || [],
    redirect: wavesValueWIARkwhRqZMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/_components/wavesValue.vue").then(m => m.default || m)
  },
  {
    name: _91id_93lS88449YgHMeta?.name ?? "casino-futuresGame-id___en",
    path: _91id_93lS88449YgHMeta?.path ?? "/casino/futuresGame/:id()",
    meta: _91id_93lS88449YgHMeta || {},
    alias: _91id_93lS88449YgHMeta?.alias || [],
    redirect: _91id_93lS88449YgHMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93lS88449YgHMeta?.name ?? "casino-futuresGame-id___cn",
    path: _91id_93lS88449YgHMeta?.path ?? "/cn/casino/futuresGame/:id()",
    meta: _91id_93lS88449YgHMeta || {},
    alias: _91id_93lS88449YgHMeta?.alias || [],
    redirect: _91id_93lS88449YgHMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/[id].vue").then(m => m.default || m)
  },
  {
    name: index1heMkfix9OMeta?.name ?? "casino-futuresGame___en",
    path: index1heMkfix9OMeta?.path ?? "/casino/futuresGame",
    meta: index1heMkfix9OMeta || {},
    alias: index1heMkfix9OMeta?.alias || [],
    redirect: index1heMkfix9OMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/index.vue").then(m => m.default || m)
  },
  {
    name: index1heMkfix9OMeta?.name ?? "casino-futuresGame___cn",
    path: index1heMkfix9OMeta?.path ?? "/cn/casino/futuresGame",
    meta: index1heMkfix9OMeta || {},
    alias: index1heMkfix9OMeta?.alias || [],
    redirect: index1heMkfix9OMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexgOONNE1pgMMeta?.name ?? "casino-futuresGame-priceFormulation___en",
    path: indexgOONNE1pgMMeta?.path ?? "/casino/futuresGame/priceFormulation",
    meta: indexgOONNE1pgMMeta || {},
    alias: indexgOONNE1pgMMeta?.alias || [],
    redirect: indexgOONNE1pgMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/priceFormulation/index.vue").then(m => m.default || m)
  },
  {
    name: indexgOONNE1pgMMeta?.name ?? "casino-futuresGame-priceFormulation___cn",
    path: indexgOONNE1pgMMeta?.path ?? "/cn/casino/futuresGame/priceFormulation",
    meta: indexgOONNE1pgMMeta || {},
    alias: indexgOONNE1pgMMeta?.alias || [],
    redirect: indexgOONNE1pgMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/priceFormulation/index.vue").then(m => m.default || m)
  },
  {
    name: wave_45chart_45about0a3HHhm5tNMeta?.name ?? "casino-futuresGame-ts-wave-chart-about___en",
    path: wave_45chart_45about0a3HHhm5tNMeta?.path ?? "/casino/futuresGame/ts/wave-chart-about",
    meta: wave_45chart_45about0a3HHhm5tNMeta || {},
    alias: wave_45chart_45about0a3HHhm5tNMeta?.alias || [],
    redirect: wave_45chart_45about0a3HHhm5tNMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wave-chart-about.ts").then(m => m.default || m)
  },
  {
    name: wave_45chart_45about0a3HHhm5tNMeta?.name ?? "casino-futuresGame-ts-wave-chart-about___cn",
    path: wave_45chart_45about0a3HHhm5tNMeta?.path ?? "/cn/casino/futuresGame/ts/wave-chart-about",
    meta: wave_45chart_45about0a3HHhm5tNMeta || {},
    alias: wave_45chart_45about0a3HHhm5tNMeta?.alias || [],
    redirect: wave_45chart_45about0a3HHhm5tNMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wave-chart-about.ts").then(m => m.default || m)
  },
  {
    name: wavesControlCenterYzdyXFi4e4Meta?.name ?? "casino-futuresGame-ts-wavesControlCenter___en",
    path: wavesControlCenterYzdyXFi4e4Meta?.path ?? "/casino/futuresGame/ts/wavesControlCenter",
    meta: wavesControlCenterYzdyXFi4e4Meta || {},
    alias: wavesControlCenterYzdyXFi4e4Meta?.alias || [],
    redirect: wavesControlCenterYzdyXFi4e4Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wavesControlCenter.ts").then(m => m.default || m)
  },
  {
    name: wavesControlCenterYzdyXFi4e4Meta?.name ?? "casino-futuresGame-ts-wavesControlCenter___cn",
    path: wavesControlCenterYzdyXFi4e4Meta?.path ?? "/cn/casino/futuresGame/ts/wavesControlCenter",
    meta: wavesControlCenterYzdyXFi4e4Meta || {},
    alias: wavesControlCenterYzdyXFi4e4Meta?.alias || [],
    redirect: wavesControlCenterYzdyXFi4e4Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wavesControlCenter.ts").then(m => m.default || m)
  },
  {
    name: wavesDataCpSTsvVfxSMeta?.name ?? "casino-futuresGame-ts-wavesData___en",
    path: wavesDataCpSTsvVfxSMeta?.path ?? "/casino/futuresGame/ts/wavesData",
    meta: wavesDataCpSTsvVfxSMeta || {},
    alias: wavesDataCpSTsvVfxSMeta?.alias || [],
    redirect: wavesDataCpSTsvVfxSMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wavesData.ts").then(m => m.default || m)
  },
  {
    name: wavesDataCpSTsvVfxSMeta?.name ?? "casino-futuresGame-ts-wavesData___cn",
    path: wavesDataCpSTsvVfxSMeta?.path ?? "/cn/casino/futuresGame/ts/wavesData",
    meta: wavesDataCpSTsvVfxSMeta || {},
    alias: wavesDataCpSTsvVfxSMeta?.alias || [],
    redirect: wavesDataCpSTsvVfxSMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wavesData.ts").then(m => m.default || m)
  },
  {
    name: wavesFnWzOY9r0qgfMeta?.name ?? "casino-futuresGame-ts-wavesFn___en",
    path: wavesFnWzOY9r0qgfMeta?.path ?? "/casino/futuresGame/ts/wavesFn",
    meta: wavesFnWzOY9r0qgfMeta || {},
    alias: wavesFnWzOY9r0qgfMeta?.alias || [],
    redirect: wavesFnWzOY9r0qgfMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wavesFn.ts").then(m => m.default || m)
  },
  {
    name: wavesFnWzOY9r0qgfMeta?.name ?? "casino-futuresGame-ts-wavesFn___cn",
    path: wavesFnWzOY9r0qgfMeta?.path ?? "/cn/casino/futuresGame/ts/wavesFn",
    meta: wavesFnWzOY9r0qgfMeta || {},
    alias: wavesFnWzOY9r0qgfMeta?.alias || [],
    redirect: wavesFnWzOY9r0qgfMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wavesFn.ts").then(m => m.default || m)
  },
  {
    name: wavesMethodsw9YUubZzVkMeta?.name ?? "casino-futuresGame-ts-wavesMethods___en",
    path: wavesMethodsw9YUubZzVkMeta?.path ?? "/casino/futuresGame/ts/wavesMethods",
    meta: wavesMethodsw9YUubZzVkMeta || {},
    alias: wavesMethodsw9YUubZzVkMeta?.alias || [],
    redirect: wavesMethodsw9YUubZzVkMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wavesMethods.ts").then(m => m.default || m)
  },
  {
    name: wavesMethodsw9YUubZzVkMeta?.name ?? "casino-futuresGame-ts-wavesMethods___cn",
    path: wavesMethodsw9YUubZzVkMeta?.path ?? "/cn/casino/futuresGame/ts/wavesMethods",
    meta: wavesMethodsw9YUubZzVkMeta || {},
    alias: wavesMethodsw9YUubZzVkMeta?.alias || [],
    redirect: wavesMethodsw9YUubZzVkMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/futuresGame/ts/wavesMethods.ts").then(m => m.default || m)
  },
  {
    name: btn_45for_45chosinge7cN6M0V2KMeta?.name ?? "casino-hiloGame-_components-btn-for-chosing___en",
    path: btn_45for_45chosinge7cN6M0V2KMeta?.path ?? "/casino/hiloGame/_components/btn-for-chosing",
    meta: btn_45for_45chosinge7cN6M0V2KMeta || {},
    alias: btn_45for_45chosinge7cN6M0V2KMeta?.alias || [],
    redirect: btn_45for_45chosinge7cN6M0V2KMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/_components/btn-for-chosing.vue").then(m => m.default || m)
  },
  {
    name: btn_45for_45chosinge7cN6M0V2KMeta?.name ?? "casino-hiloGame-_components-btn-for-chosing___cn",
    path: btn_45for_45chosinge7cN6M0V2KMeta?.path ?? "/cn/casino/hiloGame/_components/btn-for-chosing",
    meta: btn_45for_45chosinge7cN6M0V2KMeta || {},
    alias: btn_45for_45chosinge7cN6M0V2KMeta?.alias || [],
    redirect: btn_45for_45chosinge7cN6M0V2KMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/_components/btn-for-chosing.vue").then(m => m.default || m)
  },
  {
    name: card_45listdlvD16tV8BMeta?.name ?? "casino-hiloGame-_components-card-list___en",
    path: card_45listdlvD16tV8BMeta?.path ?? "/casino/hiloGame/_components/card-list",
    meta: card_45listdlvD16tV8BMeta || {},
    alias: card_45listdlvD16tV8BMeta?.alias || [],
    redirect: card_45listdlvD16tV8BMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/_components/card-list.vue").then(m => m.default || m)
  },
  {
    name: card_45listdlvD16tV8BMeta?.name ?? "casino-hiloGame-_components-card-list___cn",
    path: card_45listdlvD16tV8BMeta?.path ?? "/cn/casino/hiloGame/_components/card-list",
    meta: card_45listdlvD16tV8BMeta || {},
    alias: card_45listdlvD16tV8BMeta?.alias || [],
    redirect: card_45listdlvD16tV8BMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/_components/card-list.vue").then(m => m.default || m)
  },
  {
    name: pokerLTGqGutdbpMeta?.name ?? "casino-hiloGame-_components-poker___en",
    path: pokerLTGqGutdbpMeta?.path ?? "/casino/hiloGame/_components/poker",
    meta: pokerLTGqGutdbpMeta || {},
    alias: pokerLTGqGutdbpMeta?.alias || [],
    redirect: pokerLTGqGutdbpMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/_components/poker.vue").then(m => m.default || m)
  },
  {
    name: pokerLTGqGutdbpMeta?.name ?? "casino-hiloGame-_components-poker___cn",
    path: pokerLTGqGutdbpMeta?.path ?? "/cn/casino/hiloGame/_components/poker",
    meta: pokerLTGqGutdbpMeta || {},
    alias: pokerLTGqGutdbpMeta?.alias || [],
    redirect: pokerLTGqGutdbpMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/_components/poker.vue").then(m => m.default || m)
  },
  {
    name: indexyjl3J2dL6eMeta?.name ?? "casino-hiloGame___en",
    path: indexyjl3J2dL6eMeta?.path ?? "/casino/hiloGame",
    meta: indexyjl3J2dL6eMeta || {},
    alias: indexyjl3J2dL6eMeta?.alias || [],
    redirect: indexyjl3J2dL6eMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexyjl3J2dL6eMeta?.name ?? "casino-hiloGame___cn",
    path: indexyjl3J2dL6eMeta?.path ?? "/cn/casino/hiloGame",
    meta: indexyjl3J2dL6eMeta || {},
    alias: indexyjl3J2dL6eMeta?.alias || [],
    redirect: indexyjl3J2dL6eMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/index.vue").then(m => m.default || m)
  },
  {
    name: hiloConstantY7IZSHE92zMeta?.name ?? "casino-hiloGame-js-hiloConstant___en",
    path: hiloConstantY7IZSHE92zMeta?.path ?? "/casino/hiloGame/js/hiloConstant",
    meta: hiloConstantY7IZSHE92zMeta || {},
    alias: hiloConstantY7IZSHE92zMeta?.alias || [],
    redirect: hiloConstantY7IZSHE92zMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/js/hiloConstant.js").then(m => m.default || m)
  },
  {
    name: hiloConstantY7IZSHE92zMeta?.name ?? "casino-hiloGame-js-hiloConstant___cn",
    path: hiloConstantY7IZSHE92zMeta?.path ?? "/cn/casino/hiloGame/js/hiloConstant",
    meta: hiloConstantY7IZSHE92zMeta || {},
    alias: hiloConstantY7IZSHE92zMeta?.alias || [],
    redirect: hiloConstantY7IZSHE92zMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/js/hiloConstant.js").then(m => m.default || m)
  },
  {
    name: hiloGameI8mKmwegOFMeta?.name ?? "casino-hiloGame-js-hiloGame___en",
    path: hiloGameI8mKmwegOFMeta?.path ?? "/casino/hiloGame/js/hiloGame",
    meta: hiloGameI8mKmwegOFMeta || {},
    alias: hiloGameI8mKmwegOFMeta?.alias || [],
    redirect: hiloGameI8mKmwegOFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/js/hiloGame.js").then(m => m.default || m)
  },
  {
    name: hiloGameI8mKmwegOFMeta?.name ?? "casino-hiloGame-js-hiloGame___cn",
    path: hiloGameI8mKmwegOFMeta?.path ?? "/cn/casino/hiloGame/js/hiloGame",
    meta: hiloGameI8mKmwegOFMeta || {},
    alias: hiloGameI8mKmwegOFMeta?.alias || [],
    redirect: hiloGameI8mKmwegOFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/js/hiloGame.js").then(m => m.default || m)
  },
  {
    name: HiloRule9y2K9kgiZHMeta?.name ?? "casino-hiloGame-js-HiloRule___en",
    path: HiloRule9y2K9kgiZHMeta?.path ?? "/casino/hiloGame/js/HiloRule",
    meta: HiloRule9y2K9kgiZHMeta || {},
    alias: HiloRule9y2K9kgiZHMeta?.alias || [],
    redirect: HiloRule9y2K9kgiZHMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/js/HiloRule.js").then(m => m.default || m)
  },
  {
    name: HiloRule9y2K9kgiZHMeta?.name ?? "casino-hiloGame-js-HiloRule___cn",
    path: HiloRule9y2K9kgiZHMeta?.path ?? "/cn/casino/hiloGame/js/HiloRule",
    meta: HiloRule9y2K9kgiZHMeta || {},
    alias: HiloRule9y2K9kgiZHMeta?.alias || [],
    redirect: HiloRule9y2K9kgiZHMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/hiloGame/js/HiloRule.js").then(m => m.default || m)
  },
  {
    name: cardTypeDXeBjL6zx8Meta?.name ?? "casino-jisuzhajinhuaGame-_components-cardType___en",
    path: cardTypeDXeBjL6zx8Meta?.path ?? "/casino/jisuzhajinhuaGame/_components/cardType",
    meta: cardTypeDXeBjL6zx8Meta || {},
    alias: cardTypeDXeBjL6zx8Meta?.alias || [],
    redirect: cardTypeDXeBjL6zx8Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/cardType.vue").then(m => m.default || m)
  },
  {
    name: cardTypeDXeBjL6zx8Meta?.name ?? "casino-jisuzhajinhuaGame-_components-cardType___cn",
    path: cardTypeDXeBjL6zx8Meta?.path ?? "/cn/casino/jisuzhajinhuaGame/_components/cardType",
    meta: cardTypeDXeBjL6zx8Meta || {},
    alias: cardTypeDXeBjL6zx8Meta?.alias || [],
    redirect: cardTypeDXeBjL6zx8Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/cardType.vue").then(m => m.default || m)
  },
  {
    name: GameRulesModalOx0VQiFJ6VMeta?.name ?? "casino-jisuzhajinhuaGame-_components-GameRulesModal___en",
    path: GameRulesModalOx0VQiFJ6VMeta?.path ?? "/casino/jisuzhajinhuaGame/_components/GameRulesModal",
    meta: GameRulesModalOx0VQiFJ6VMeta || {},
    alias: GameRulesModalOx0VQiFJ6VMeta?.alias || [],
    redirect: GameRulesModalOx0VQiFJ6VMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/GameRulesModal.vue").then(m => m.default || m)
  },
  {
    name: GameRulesModalOx0VQiFJ6VMeta?.name ?? "casino-jisuzhajinhuaGame-_components-GameRulesModal___cn",
    path: GameRulesModalOx0VQiFJ6VMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/_components/GameRulesModal",
    meta: GameRulesModalOx0VQiFJ6VMeta || {},
    alias: GameRulesModalOx0VQiFJ6VMeta?.alias || [],
    redirect: GameRulesModalOx0VQiFJ6VMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/GameRulesModal.vue").then(m => m.default || m)
  },
  {
    name: hallCoverxFgI3xtlWQMeta?.name ?? "casino-jisuzhajinhuaGame-_components-hallCover___en",
    path: hallCoverxFgI3xtlWQMeta?.path ?? "/casino/jisuzhajinhuaGame/_components/hallCover",
    meta: hallCoverxFgI3xtlWQMeta || {},
    alias: hallCoverxFgI3xtlWQMeta?.alias || [],
    redirect: hallCoverxFgI3xtlWQMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/hallCover.vue").then(m => m.default || m)
  },
  {
    name: hallCoverxFgI3xtlWQMeta?.name ?? "casino-jisuzhajinhuaGame-_components-hallCover___cn",
    path: hallCoverxFgI3xtlWQMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/_components/hallCover",
    meta: hallCoverxFgI3xtlWQMeta || {},
    alias: hallCoverxFgI3xtlWQMeta?.alias || [],
    redirect: hallCoverxFgI3xtlWQMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/hallCover.vue").then(m => m.default || m)
  },
  {
    name: historyListSxhoe3hdr6Meta?.name ?? "casino-jisuzhajinhuaGame-_components-historyList___en",
    path: historyListSxhoe3hdr6Meta?.path ?? "/casino/jisuzhajinhuaGame/_components/historyList",
    meta: historyListSxhoe3hdr6Meta || {},
    alias: historyListSxhoe3hdr6Meta?.alias || [],
    redirect: historyListSxhoe3hdr6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/historyList.vue").then(m => m.default || m)
  },
  {
    name: historyListSxhoe3hdr6Meta?.name ?? "casino-jisuzhajinhuaGame-_components-historyList___cn",
    path: historyListSxhoe3hdr6Meta?.path ?? "/cn/casino/jisuzhajinhuaGame/_components/historyList",
    meta: historyListSxhoe3hdr6Meta || {},
    alias: historyListSxhoe3hdr6Meta?.alias || [],
    redirect: historyListSxhoe3hdr6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/historyList.vue").then(m => m.default || m)
  },
  {
    name: nameTagYZERMrEH7yMeta?.name ?? "casino-jisuzhajinhuaGame-_components-nameTag___en",
    path: nameTagYZERMrEH7yMeta?.path ?? "/casino/jisuzhajinhuaGame/_components/nameTag",
    meta: nameTagYZERMrEH7yMeta || {},
    alias: nameTagYZERMrEH7yMeta?.alias || [],
    redirect: nameTagYZERMrEH7yMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/nameTag.vue").then(m => m.default || m)
  },
  {
    name: nameTagYZERMrEH7yMeta?.name ?? "casino-jisuzhajinhuaGame-_components-nameTag___cn",
    path: nameTagYZERMrEH7yMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/_components/nameTag",
    meta: nameTagYZERMrEH7yMeta || {},
    alias: nameTagYZERMrEH7yMeta?.alias || [],
    redirect: nameTagYZERMrEH7yMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/nameTag.vue").then(m => m.default || m)
  },
  {
    name: playerF01Gg98k0mMeta?.name ?? "casino-jisuzhajinhuaGame-_components-player___en",
    path: playerF01Gg98k0mMeta?.path ?? "/casino/jisuzhajinhuaGame/_components/player",
    meta: playerF01Gg98k0mMeta || {},
    alias: playerF01Gg98k0mMeta?.alias || [],
    redirect: playerF01Gg98k0mMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/player.vue").then(m => m.default || m)
  },
  {
    name: playerF01Gg98k0mMeta?.name ?? "casino-jisuzhajinhuaGame-_components-player___cn",
    path: playerF01Gg98k0mMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/_components/player",
    meta: playerF01Gg98k0mMeta || {},
    alias: playerF01Gg98k0mMeta?.alias || [],
    redirect: playerF01Gg98k0mMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/player.vue").then(m => m.default || m)
  },
  {
    name: pokerCardswuBFD3CB2Meta?.name ?? "casino-jisuzhajinhuaGame-_components-pokerCard___en",
    path: pokerCardswuBFD3CB2Meta?.path ?? "/casino/jisuzhajinhuaGame/_components/pokerCard",
    meta: pokerCardswuBFD3CB2Meta || {},
    alias: pokerCardswuBFD3CB2Meta?.alias || [],
    redirect: pokerCardswuBFD3CB2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/pokerCard.vue").then(m => m.default || m)
  },
  {
    name: pokerCardswuBFD3CB2Meta?.name ?? "casino-jisuzhajinhuaGame-_components-pokerCard___cn",
    path: pokerCardswuBFD3CB2Meta?.path ?? "/cn/casino/jisuzhajinhuaGame/_components/pokerCard",
    meta: pokerCardswuBFD3CB2Meta || {},
    alias: pokerCardswuBFD3CB2Meta?.alias || [],
    redirect: pokerCardswuBFD3CB2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/pokerCard.vue").then(m => m.default || m)
  },
  {
    name: wagerAmountEKAhh1tOmIMeta?.name ?? "casino-jisuzhajinhuaGame-_components-wagerAmount___en",
    path: wagerAmountEKAhh1tOmIMeta?.path ?? "/casino/jisuzhajinhuaGame/_components/wagerAmount",
    meta: wagerAmountEKAhh1tOmIMeta || {},
    alias: wagerAmountEKAhh1tOmIMeta?.alias || [],
    redirect: wagerAmountEKAhh1tOmIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/wagerAmount.vue").then(m => m.default || m)
  },
  {
    name: wagerAmountEKAhh1tOmIMeta?.name ?? "casino-jisuzhajinhuaGame-_components-wagerAmount___cn",
    path: wagerAmountEKAhh1tOmIMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/_components/wagerAmount",
    meta: wagerAmountEKAhh1tOmIMeta || {},
    alias: wagerAmountEKAhh1tOmIMeta?.alias || [],
    redirect: wagerAmountEKAhh1tOmIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/_components/wagerAmount.vue").then(m => m.default || m)
  },
  {
    name: indexE2aLdWItmiMeta?.name ?? "casino-jisuzhajinhuaGame-entrance___en",
    path: indexE2aLdWItmiMeta?.path ?? "/casino/jisuzhajinhuaGame/entrance",
    meta: indexE2aLdWItmiMeta || {},
    alias: indexE2aLdWItmiMeta?.alias || [],
    redirect: indexE2aLdWItmiMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexE2aLdWItmiMeta?.name ?? "casino-jisuzhajinhuaGame-entrance___cn",
    path: indexE2aLdWItmiMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/entrance",
    meta: indexE2aLdWItmiMeta || {},
    alias: indexE2aLdWItmiMeta?.alias || [],
    redirect: indexE2aLdWItmiMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6jTLuSzYsMeta?.name ?? "casino-jisuzhajinhuaGame___en",
    path: indexN6jTLuSzYsMeta?.path ?? "/casino/jisuzhajinhuaGame",
    meta: indexN6jTLuSzYsMeta || {},
    alias: indexN6jTLuSzYsMeta?.alias || [],
    redirect: indexN6jTLuSzYsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6jTLuSzYsMeta?.name ?? "casino-jisuzhajinhuaGame___cn",
    path: indexN6jTLuSzYsMeta?.path ?? "/cn/casino/jisuzhajinhuaGame",
    meta: indexN6jTLuSzYsMeta || {},
    alias: indexN6jTLuSzYsMeta?.alias || [],
    redirect: indexN6jTLuSzYsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_9379KAziR3OxMeta?.name ?? "casino-jisuzhajinhuaGame-indoor-id___en",
    path: _91id_9379KAziR3OxMeta?.path ?? "/casino/jisuzhajinhuaGame/indoor/:id()",
    meta: _91id_9379KAziR3OxMeta || {},
    alias: _91id_9379KAziR3OxMeta?.alias || [],
    redirect: _91id_9379KAziR3OxMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/indoor/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_9379KAziR3OxMeta?.name ?? "casino-jisuzhajinhuaGame-indoor-id___cn",
    path: _91id_9379KAziR3OxMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/indoor/:id()",
    meta: _91id_9379KAziR3OxMeta || {},
    alias: _91id_9379KAziR3OxMeta?.alias || [],
    redirect: _91id_9379KAziR3OxMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/indoor/[id].vue").then(m => m.default || m)
  },
  {
    name: index7KmZaSTr8VMeta?.name ?? "casino-jisuzhajinhuaGame-indoor___en",
    path: index7KmZaSTr8VMeta?.path ?? "/casino/jisuzhajinhuaGame/indoor",
    meta: index7KmZaSTr8VMeta || {},
    alias: index7KmZaSTr8VMeta?.alias || [],
    redirect: index7KmZaSTr8VMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/indoor/index.vue").then(m => m.default || m)
  },
  {
    name: index7KmZaSTr8VMeta?.name ?? "casino-jisuzhajinhuaGame-indoor___cn",
    path: index7KmZaSTr8VMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/indoor",
    meta: index7KmZaSTr8VMeta || {},
    alias: index7KmZaSTr8VMeta?.alias || [],
    redirect: index7KmZaSTr8VMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/indoor/index.vue").then(m => m.default || m)
  },
  {
    name: cardsConstant8IkRk9vQgFMeta?.name ?? "casino-jisuzhajinhuaGame-ts-cardsConstant___en",
    path: cardsConstant8IkRk9vQgFMeta?.path ?? "/casino/jisuzhajinhuaGame/ts/cardsConstant",
    meta: cardsConstant8IkRk9vQgFMeta || {},
    alias: cardsConstant8IkRk9vQgFMeta?.alias || [],
    redirect: cardsConstant8IkRk9vQgFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/cardsConstant.ts").then(m => m.default || m)
  },
  {
    name: cardsConstant8IkRk9vQgFMeta?.name ?? "casino-jisuzhajinhuaGame-ts-cardsConstant___cn",
    path: cardsConstant8IkRk9vQgFMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/ts/cardsConstant",
    meta: cardsConstant8IkRk9vQgFMeta || {},
    alias: cardsConstant8IkRk9vQgFMeta?.alias || [],
    redirect: cardsConstant8IkRk9vQgFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/cardsConstant.ts").then(m => m.default || m)
  },
  {
    name: constantstffwNUmhW2Meta?.name ?? "casino-jisuzhajinhuaGame-ts-constants___en",
    path: constantstffwNUmhW2Meta?.path ?? "/casino/jisuzhajinhuaGame/ts/constants",
    meta: constantstffwNUmhW2Meta || {},
    alias: constantstffwNUmhW2Meta?.alias || [],
    redirect: constantstffwNUmhW2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/constants.ts").then(m => m.default || m)
  },
  {
    name: constantstffwNUmhW2Meta?.name ?? "casino-jisuzhajinhuaGame-ts-constants___cn",
    path: constantstffwNUmhW2Meta?.path ?? "/cn/casino/jisuzhajinhuaGame/ts/constants",
    meta: constantstffwNUmhW2Meta || {},
    alias: constantstffwNUmhW2Meta?.alias || [],
    redirect: constantstffwNUmhW2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/constants.ts").then(m => m.default || m)
  },
  {
    name: goldenFlowerCommonKHtT3GND5lMeta?.name ?? "casino-jisuzhajinhuaGame-ts-goldenFlowerCommon___en",
    path: goldenFlowerCommonKHtT3GND5lMeta?.path ?? "/casino/jisuzhajinhuaGame/ts/goldenFlowerCommon",
    meta: goldenFlowerCommonKHtT3GND5lMeta || {},
    alias: goldenFlowerCommonKHtT3GND5lMeta?.alias || [],
    redirect: goldenFlowerCommonKHtT3GND5lMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/goldenFlowerCommon.ts").then(m => m.default || m)
  },
  {
    name: goldenFlowerCommonKHtT3GND5lMeta?.name ?? "casino-jisuzhajinhuaGame-ts-goldenFlowerCommon___cn",
    path: goldenFlowerCommonKHtT3GND5lMeta?.path ?? "/cn/casino/jisuzhajinhuaGame/ts/goldenFlowerCommon",
    meta: goldenFlowerCommonKHtT3GND5lMeta || {},
    alias: goldenFlowerCommonKHtT3GND5lMeta?.alias || [],
    redirect: goldenFlowerCommonKHtT3GND5lMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/jisuzhajinhuaGame/ts/goldenFlowerCommon.ts").then(m => m.default || m)
  },
  {
    name: indexrPgLmdFBAIMeta?.name ?? "casino-kenoGame___en",
    path: indexrPgLmdFBAIMeta?.path ?? "/casino/kenoGame",
    meta: indexrPgLmdFBAIMeta || {},
    alias: indexrPgLmdFBAIMeta?.alias || [],
    redirect: indexrPgLmdFBAIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/kenoGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexrPgLmdFBAIMeta?.name ?? "casino-kenoGame___cn",
    path: indexrPgLmdFBAIMeta?.path ?? "/cn/casino/kenoGame",
    meta: indexrPgLmdFBAIMeta || {},
    alias: indexrPgLmdFBAIMeta?.alias || [],
    redirect: indexrPgLmdFBAIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/kenoGame/index.vue").then(m => m.default || m)
  },
  {
    name: kenou9pSCH7jvMMeta?.name ?? "casino-kenoGame-js-keno___en",
    path: kenou9pSCH7jvMMeta?.path ?? "/casino/kenoGame/js/keno",
    meta: kenou9pSCH7jvMMeta || {},
    alias: kenou9pSCH7jvMMeta?.alias || [],
    redirect: kenou9pSCH7jvMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/kenoGame/js/keno.js").then(m => m.default || m)
  },
  {
    name: kenou9pSCH7jvMMeta?.name ?? "casino-kenoGame-js-keno___cn",
    path: kenou9pSCH7jvMMeta?.path ?? "/cn/casino/kenoGame/js/keno",
    meta: kenou9pSCH7jvMMeta || {},
    alias: kenou9pSCH7jvMMeta?.alias || [],
    redirect: kenou9pSCH7jvMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/kenoGame/js/keno.js").then(m => m.default || m)
  },
  {
    name: kenoRuledFwgImJ1NDMeta?.name ?? "casino-kenoGame-js-kenoRule___en",
    path: kenoRuledFwgImJ1NDMeta?.path ?? "/casino/kenoGame/js/kenoRule",
    meta: kenoRuledFwgImJ1NDMeta || {},
    alias: kenoRuledFwgImJ1NDMeta?.alias || [],
    redirect: kenoRuledFwgImJ1NDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/kenoGame/js/kenoRule.js").then(m => m.default || m)
  },
  {
    name: kenoRuledFwgImJ1NDMeta?.name ?? "casino-kenoGame-js-kenoRule___cn",
    path: kenoRuledFwgImJ1NDMeta?.path ?? "/cn/casino/kenoGame/js/kenoRule",
    meta: kenoRuledFwgImJ1NDMeta || {},
    alias: kenoRuledFwgImJ1NDMeta?.alias || [],
    redirect: kenoRuledFwgImJ1NDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/kenoGame/js/kenoRule.js").then(m => m.default || m)
  },
  {
    name: betTargetOption8raUcT9hKhMeta?.name ?? "casino-limboGame-_components-betOptions-betTargetOption___en",
    path: betTargetOption8raUcT9hKhMeta?.path ?? "/casino/limboGame/_components/betOptions/betTargetOption",
    meta: betTargetOption8raUcT9hKhMeta || {},
    alias: betTargetOption8raUcT9hKhMeta?.alias || [],
    redirect: betTargetOption8raUcT9hKhMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/_components/betOptions/betTargetOption.vue").then(m => m.default || m)
  },
  {
    name: betTargetOption8raUcT9hKhMeta?.name ?? "casino-limboGame-_components-betOptions-betTargetOption___cn",
    path: betTargetOption8raUcT9hKhMeta?.path ?? "/cn/casino/limboGame/_components/betOptions/betTargetOption",
    meta: betTargetOption8raUcT9hKhMeta || {},
    alias: betTargetOption8raUcT9hKhMeta?.alias || [],
    redirect: betTargetOption8raUcT9hKhMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/_components/betOptions/betTargetOption.vue").then(m => m.default || m)
  },
  {
    name: index0isOmtDx92Meta?.name ?? "casino-limboGame-_components-betOptions___en",
    path: index0isOmtDx92Meta?.path ?? "/casino/limboGame/_components/betOptions",
    meta: index0isOmtDx92Meta || {},
    alias: index0isOmtDx92Meta?.alias || [],
    redirect: index0isOmtDx92Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/_components/betOptions/index.vue").then(m => m.default || m)
  },
  {
    name: index0isOmtDx92Meta?.name ?? "casino-limboGame-_components-betOptions___cn",
    path: index0isOmtDx92Meta?.path ?? "/cn/casino/limboGame/_components/betOptions",
    meta: index0isOmtDx92Meta || {},
    alias: index0isOmtDx92Meta?.alias || [],
    redirect: index0isOmtDx92Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/_components/betOptions/index.vue").then(m => m.default || m)
  },
  {
    name: indextYqgPtrSa0Meta?.name ?? "casino-limboGame-_components-historyResult___en",
    path: indextYqgPtrSa0Meta?.path ?? "/casino/limboGame/_components/historyResult",
    meta: indextYqgPtrSa0Meta || {},
    alias: indextYqgPtrSa0Meta?.alias || [],
    redirect: indextYqgPtrSa0Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/_components/historyResult/index.vue").then(m => m.default || m)
  },
  {
    name: indextYqgPtrSa0Meta?.name ?? "casino-limboGame-_components-historyResult___cn",
    path: indextYqgPtrSa0Meta?.path ?? "/cn/casino/limboGame/_components/historyResult",
    meta: indextYqgPtrSa0Meta || {},
    alias: indextYqgPtrSa0Meta?.alias || [],
    redirect: indextYqgPtrSa0Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/_components/historyResult/index.vue").then(m => m.default || m)
  },
  {
    name: indexcIChxu3PcoMeta?.name ?? "casino-limboGame-data___en",
    path: indexcIChxu3PcoMeta?.path ?? "/casino/limboGame/data",
    meta: indexcIChxu3PcoMeta || {},
    alias: indexcIChxu3PcoMeta?.alias || [],
    redirect: indexcIChxu3PcoMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/data/index.js").then(m => m.default || m)
  },
  {
    name: indexcIChxu3PcoMeta?.name ?? "casino-limboGame-data___cn",
    path: indexcIChxu3PcoMeta?.path ?? "/cn/casino/limboGame/data",
    meta: indexcIChxu3PcoMeta || {},
    alias: indexcIChxu3PcoMeta?.alias || [],
    redirect: indexcIChxu3PcoMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/data/index.js").then(m => m.default || m)
  },
  {
    name: indexKXyhXltRW2Meta?.name ?? "casino-limboGame___en",
    path: indexKXyhXltRW2Meta?.path ?? "/casino/limboGame",
    meta: indexKXyhXltRW2Meta || {},
    alias: indexKXyhXltRW2Meta?.alias || [],
    redirect: indexKXyhXltRW2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexKXyhXltRW2Meta?.name ?? "casino-limboGame___cn",
    path: indexKXyhXltRW2Meta?.path ?? "/cn/casino/limboGame",
    meta: indexKXyhXltRW2Meta || {},
    alias: indexKXyhXltRW2Meta?.alias || [],
    redirect: indexKXyhXltRW2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/index.vue").then(m => m.default || m)
  },
  {
    name: starsSOxk5s0w6bMeta?.name ?? "casino-limboGame-js-stars___en",
    path: starsSOxk5s0w6bMeta?.path ?? "/casino/limboGame/js/stars",
    meta: starsSOxk5s0w6bMeta || {},
    alias: starsSOxk5s0w6bMeta?.alias || [],
    redirect: starsSOxk5s0w6bMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/js/stars.ts").then(m => m.default || m)
  },
  {
    name: starsSOxk5s0w6bMeta?.name ?? "casino-limboGame-js-stars___cn",
    path: starsSOxk5s0w6bMeta?.path ?? "/cn/casino/limboGame/js/stars",
    meta: starsSOxk5s0w6bMeta || {},
    alias: starsSOxk5s0w6bMeta?.alias || [],
    redirect: starsSOxk5s0w6bMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/js/stars.ts").then(m => m.default || m)
  },
  {
    name: util5L9wgrsq8EMeta?.name ?? "casino-limboGame-js-util___en",
    path: util5L9wgrsq8EMeta?.path ?? "/casino/limboGame/js/util",
    meta: util5L9wgrsq8EMeta || {},
    alias: util5L9wgrsq8EMeta?.alias || [],
    redirect: util5L9wgrsq8EMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/js/util.js").then(m => m.default || m)
  },
  {
    name: util5L9wgrsq8EMeta?.name ?? "casino-limboGame-js-util___cn",
    path: util5L9wgrsq8EMeta?.path ?? "/cn/casino/limboGame/js/util",
    meta: util5L9wgrsq8EMeta || {},
    alias: util5L9wgrsq8EMeta?.alias || [],
    redirect: util5L9wgrsq8EMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/limboGame/js/util.js").then(m => m.default || m)
  },
  {
    name: indexhhGSehXYJkMeta?.name ?? "casino-minesGame___en",
    path: indexhhGSehXYJkMeta?.path ?? "/casino/minesGame",
    meta: indexhhGSehXYJkMeta || {},
    alias: indexhhGSehXYJkMeta?.alias || [],
    redirect: indexhhGSehXYJkMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/minesGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexhhGSehXYJkMeta?.name ?? "casino-minesGame___cn",
    path: indexhhGSehXYJkMeta?.path ?? "/cn/casino/minesGame",
    meta: indexhhGSehXYJkMeta || {},
    alias: indexhhGSehXYJkMeta?.alias || [],
    redirect: indexhhGSehXYJkMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/minesGame/index.vue").then(m => m.default || m)
  },
  {
    name: mines_45methodsBFDRw5TLEUMeta?.name ?? "casino-minesGame-js-mines-methods___en",
    path: mines_45methodsBFDRw5TLEUMeta?.path ?? "/casino/minesGame/js/mines-methods",
    meta: mines_45methodsBFDRw5TLEUMeta || {},
    alias: mines_45methodsBFDRw5TLEUMeta?.alias || [],
    redirect: mines_45methodsBFDRw5TLEUMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/minesGame/js/mines-methods.js").then(m => m.default || m)
  },
  {
    name: mines_45methodsBFDRw5TLEUMeta?.name ?? "casino-minesGame-js-mines-methods___cn",
    path: mines_45methodsBFDRw5TLEUMeta?.path ?? "/cn/casino/minesGame/js/mines-methods",
    meta: mines_45methodsBFDRw5TLEUMeta || {},
    alias: mines_45methodsBFDRw5TLEUMeta?.alias || [],
    redirect: mines_45methodsBFDRw5TLEUMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/minesGame/js/mines-methods.js").then(m => m.default || m)
  },
  {
    name: mines_45ruleya5PSiLX57Meta?.name ?? "casino-minesGame-js-mines-rule___en",
    path: mines_45ruleya5PSiLX57Meta?.path ?? "/casino/minesGame/js/mines-rule",
    meta: mines_45ruleya5PSiLX57Meta || {},
    alias: mines_45ruleya5PSiLX57Meta?.alias || [],
    redirect: mines_45ruleya5PSiLX57Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/minesGame/js/mines-rule.js").then(m => m.default || m)
  },
  {
    name: mines_45ruleya5PSiLX57Meta?.name ?? "casino-minesGame-js-mines-rule___cn",
    path: mines_45ruleya5PSiLX57Meta?.path ?? "/cn/casino/minesGame/js/mines-rule",
    meta: mines_45ruleya5PSiLX57Meta || {},
    alias: mines_45ruleya5PSiLX57Meta?.alias || [],
    redirect: mines_45ruleya5PSiLX57Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/minesGame/js/mines-rule.js").then(m => m.default || m)
  },
  {
    name: MinesBackgroundStepsov5PTFaSdNMeta?.name ?? "casino-minesGame-js-MinesBackgroundSteps___en",
    path: MinesBackgroundStepsov5PTFaSdNMeta?.path ?? "/casino/minesGame/js/MinesBackgroundSteps",
    meta: MinesBackgroundStepsov5PTFaSdNMeta || {},
    alias: MinesBackgroundStepsov5PTFaSdNMeta?.alias || [],
    redirect: MinesBackgroundStepsov5PTFaSdNMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/minesGame/js/MinesBackgroundSteps.js").then(m => m.default || m)
  },
  {
    name: MinesBackgroundStepsov5PTFaSdNMeta?.name ?? "casino-minesGame-js-MinesBackgroundSteps___cn",
    path: MinesBackgroundStepsov5PTFaSdNMeta?.path ?? "/cn/casino/minesGame/js/MinesBackgroundSteps",
    meta: MinesBackgroundStepsov5PTFaSdNMeta || {},
    alias: MinesBackgroundStepsov5PTFaSdNMeta?.alias || [],
    redirect: MinesBackgroundStepsov5PTFaSdNMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/minesGame/js/MinesBackgroundSteps.js").then(m => m.default || m)
  },
  {
    name: CanvasTextCMTakCQM5EMeta?.name ?? "casino-niuniuGame-_components-CanvasText___en",
    path: CanvasTextCMTakCQM5EMeta?.path ?? "/casino/niuniuGame/_components/CanvasText",
    meta: CanvasTextCMTakCQM5EMeta || {},
    alias: CanvasTextCMTakCQM5EMeta?.alias || [],
    redirect: CanvasTextCMTakCQM5EMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/CanvasText.vue").then(m => m.default || m)
  },
  {
    name: CanvasTextCMTakCQM5EMeta?.name ?? "casino-niuniuGame-_components-CanvasText___cn",
    path: CanvasTextCMTakCQM5EMeta?.path ?? "/cn/casino/niuniuGame/_components/CanvasText",
    meta: CanvasTextCMTakCQM5EMeta || {},
    alias: CanvasTextCMTakCQM5EMeta?.alias || [],
    redirect: CanvasTextCMTakCQM5EMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/CanvasText.vue").then(m => m.default || m)
  },
  {
    name: HallCardk45M7XB3kmMeta?.name ?? "casino-niuniuGame-_components-HallCard___en",
    path: HallCardk45M7XB3kmMeta?.path ?? "/casino/niuniuGame/_components/HallCard",
    meta: HallCardk45M7XB3kmMeta || {},
    alias: HallCardk45M7XB3kmMeta?.alias || [],
    redirect: HallCardk45M7XB3kmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/HallCard.vue").then(m => m.default || m)
  },
  {
    name: HallCardk45M7XB3kmMeta?.name ?? "casino-niuniuGame-_components-HallCard___cn",
    path: HallCardk45M7XB3kmMeta?.path ?? "/cn/casino/niuniuGame/_components/HallCard",
    meta: HallCardk45M7XB3kmMeta || {},
    alias: HallCardk45M7XB3kmMeta?.alias || [],
    redirect: HallCardk45M7XB3kmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/HallCard.vue").then(m => m.default || m)
  },
  {
    name: HallCoverDm7b3R14BJMeta?.name ?? "casino-niuniuGame-_components-HallCover___en",
    path: HallCoverDm7b3R14BJMeta?.path ?? "/casino/niuniuGame/_components/HallCover",
    meta: HallCoverDm7b3R14BJMeta || {},
    alias: HallCoverDm7b3R14BJMeta?.alias || [],
    redirect: HallCoverDm7b3R14BJMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/HallCover.vue").then(m => m.default || m)
  },
  {
    name: HallCoverDm7b3R14BJMeta?.name ?? "casino-niuniuGame-_components-HallCover___cn",
    path: HallCoverDm7b3R14BJMeta?.path ?? "/cn/casino/niuniuGame/_components/HallCover",
    meta: HallCoverDm7b3R14BJMeta || {},
    alias: HallCoverDm7b3R14BJMeta?.alias || [],
    redirect: HallCoverDm7b3R14BJMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/HallCover.vue").then(m => m.default || m)
  },
  {
    name: HallFooterqN3RyOljsTMeta?.name ?? "casino-niuniuGame-_components-HallFooter___en",
    path: HallFooterqN3RyOljsTMeta?.path ?? "/casino/niuniuGame/_components/HallFooter",
    meta: HallFooterqN3RyOljsTMeta || {},
    alias: HallFooterqN3RyOljsTMeta?.alias || [],
    redirect: HallFooterqN3RyOljsTMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/HallFooter.vue").then(m => m.default || m)
  },
  {
    name: HallFooterqN3RyOljsTMeta?.name ?? "casino-niuniuGame-_components-HallFooter___cn",
    path: HallFooterqN3RyOljsTMeta?.path ?? "/cn/casino/niuniuGame/_components/HallFooter",
    meta: HallFooterqN3RyOljsTMeta || {},
    alias: HallFooterqN3RyOljsTMeta?.alias || [],
    redirect: HallFooterqN3RyOljsTMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/HallFooter.vue").then(m => m.default || m)
  },
  {
    name: HallHeadertToKMwgBVlMeta?.name ?? "casino-niuniuGame-_components-HallHeader___en",
    path: HallHeadertToKMwgBVlMeta?.path ?? "/casino/niuniuGame/_components/HallHeader",
    meta: HallHeadertToKMwgBVlMeta || {},
    alias: HallHeadertToKMwgBVlMeta?.alias || [],
    redirect: HallHeadertToKMwgBVlMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/HallHeader.vue").then(m => m.default || m)
  },
  {
    name: HallHeadertToKMwgBVlMeta?.name ?? "casino-niuniuGame-_components-HallHeader___cn",
    path: HallHeadertToKMwgBVlMeta?.path ?? "/cn/casino/niuniuGame/_components/HallHeader",
    meta: HallHeadertToKMwgBVlMeta || {},
    alias: HallHeadertToKMwgBVlMeta?.alias || [],
    redirect: HallHeadertToKMwgBVlMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/HallHeader.vue").then(m => m.default || m)
  },
  {
    name: historyListlctpImRDyNMeta?.name ?? "casino-niuniuGame-_components-historyList___en",
    path: historyListlctpImRDyNMeta?.path ?? "/casino/niuniuGame/_components/historyList",
    meta: historyListlctpImRDyNMeta || {},
    alias: historyListlctpImRDyNMeta?.alias || [],
    redirect: historyListlctpImRDyNMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/historyList.vue").then(m => m.default || m)
  },
  {
    name: historyListlctpImRDyNMeta?.name ?? "casino-niuniuGame-_components-historyList___cn",
    path: historyListlctpImRDyNMeta?.path ?? "/cn/casino/niuniuGame/_components/historyList",
    meta: historyListlctpImRDyNMeta || {},
    alias: historyListlctpImRDyNMeta?.alias || [],
    redirect: historyListlctpImRDyNMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/historyList.vue").then(m => m.default || m)
  },
  {
    name: IndoorHeaderoW1Q4OBKYpMeta?.name ?? "casino-niuniuGame-_components-IndoorHeader___en",
    path: IndoorHeaderoW1Q4OBKYpMeta?.path ?? "/casino/niuniuGame/_components/IndoorHeader",
    meta: IndoorHeaderoW1Q4OBKYpMeta || {},
    alias: IndoorHeaderoW1Q4OBKYpMeta?.alias || [],
    redirect: IndoorHeaderoW1Q4OBKYpMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/IndoorHeader.vue").then(m => m.default || m)
  },
  {
    name: IndoorHeaderoW1Q4OBKYpMeta?.name ?? "casino-niuniuGame-_components-IndoorHeader___cn",
    path: IndoorHeaderoW1Q4OBKYpMeta?.path ?? "/cn/casino/niuniuGame/_components/IndoorHeader",
    meta: IndoorHeaderoW1Q4OBKYpMeta || {},
    alias: IndoorHeaderoW1Q4OBKYpMeta?.alias || [],
    redirect: IndoorHeaderoW1Q4OBKYpMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/IndoorHeader.vue").then(m => m.default || m)
  },
  {
    name: PlayerListJf9x4KKX4nMeta?.name ?? "casino-niuniuGame-_components-PlayerList___en",
    path: PlayerListJf9x4KKX4nMeta?.path ?? "/casino/niuniuGame/_components/PlayerList",
    meta: PlayerListJf9x4KKX4nMeta || {},
    alias: PlayerListJf9x4KKX4nMeta?.alias || [],
    redirect: PlayerListJf9x4KKX4nMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/PlayerList.vue").then(m => m.default || m)
  },
  {
    name: PlayerListJf9x4KKX4nMeta?.name ?? "casino-niuniuGame-_components-PlayerList___cn",
    path: PlayerListJf9x4KKX4nMeta?.path ?? "/cn/casino/niuniuGame/_components/PlayerList",
    meta: PlayerListJf9x4KKX4nMeta || {},
    alias: PlayerListJf9x4KKX4nMeta?.alias || [],
    redirect: PlayerListJf9x4KKX4nMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/PlayerList.vue").then(m => m.default || m)
  },
  {
    name: playStatuszcqZAYyLdaMeta?.name ?? "casino-niuniuGame-_components-playStatus___en",
    path: playStatuszcqZAYyLdaMeta?.path ?? "/casino/niuniuGame/_components/playStatus",
    meta: playStatuszcqZAYyLdaMeta || {},
    alias: playStatuszcqZAYyLdaMeta?.alias || [],
    redirect: playStatuszcqZAYyLdaMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/playStatus.vue").then(m => m.default || m)
  },
  {
    name: playStatuszcqZAYyLdaMeta?.name ?? "casino-niuniuGame-_components-playStatus___cn",
    path: playStatuszcqZAYyLdaMeta?.path ?? "/cn/casino/niuniuGame/_components/playStatus",
    meta: playStatuszcqZAYyLdaMeta || {},
    alias: playStatuszcqZAYyLdaMeta?.alias || [],
    redirect: playStatuszcqZAYyLdaMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/playStatus.vue").then(m => m.default || m)
  },
  {
    name: PokerCard_32copyBOt4kAWXFtMeta?.name ?? "casino-niuniuGame-_components-PokerCard copy___en",
    path: PokerCard_32copyBOt4kAWXFtMeta?.path ?? "/casino/niuniuGame/_components/PokerCard%20copy",
    meta: PokerCard_32copyBOt4kAWXFtMeta || {},
    alias: PokerCard_32copyBOt4kAWXFtMeta?.alias || [],
    redirect: PokerCard_32copyBOt4kAWXFtMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/PokerCard copy.vue").then(m => m.default || m)
  },
  {
    name: PokerCard_32copyBOt4kAWXFtMeta?.name ?? "casino-niuniuGame-_components-PokerCard copy___cn",
    path: PokerCard_32copyBOt4kAWXFtMeta?.path ?? "/cn/casino/niuniuGame/_components/PokerCard%20copy",
    meta: PokerCard_32copyBOt4kAWXFtMeta || {},
    alias: PokerCard_32copyBOt4kAWXFtMeta?.alias || [],
    redirect: PokerCard_32copyBOt4kAWXFtMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/PokerCard copy.vue").then(m => m.default || m)
  },
  {
    name: PokerCardDqtXr9TX9CMeta?.name ?? "casino-niuniuGame-_components-PokerCard___en",
    path: PokerCardDqtXr9TX9CMeta?.path ?? "/casino/niuniuGame/_components/PokerCard",
    meta: PokerCardDqtXr9TX9CMeta || {},
    alias: PokerCardDqtXr9TX9CMeta?.alias || [],
    redirect: PokerCardDqtXr9TX9CMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/PokerCard.vue").then(m => m.default || m)
  },
  {
    name: PokerCardDqtXr9TX9CMeta?.name ?? "casino-niuniuGame-_components-PokerCard___cn",
    path: PokerCardDqtXr9TX9CMeta?.path ?? "/cn/casino/niuniuGame/_components/PokerCard",
    meta: PokerCardDqtXr9TX9CMeta || {},
    alias: PokerCardDqtXr9TX9CMeta?.alias || [],
    redirect: PokerCardDqtXr9TX9CMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/PokerCard.vue").then(m => m.default || m)
  },
  {
    name: SelectRoomN4mGyvzNK4Meta?.name ?? "casino-niuniuGame-_components-SelectRoom___en",
    path: SelectRoomN4mGyvzNK4Meta?.path ?? "/casino/niuniuGame/_components/SelectRoom",
    meta: SelectRoomN4mGyvzNK4Meta || {},
    alias: SelectRoomN4mGyvzNK4Meta?.alias || [],
    redirect: SelectRoomN4mGyvzNK4Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/SelectRoom.vue").then(m => m.default || m)
  },
  {
    name: SelectRoomN4mGyvzNK4Meta?.name ?? "casino-niuniuGame-_components-SelectRoom___cn",
    path: SelectRoomN4mGyvzNK4Meta?.path ?? "/cn/casino/niuniuGame/_components/SelectRoom",
    meta: SelectRoomN4mGyvzNK4Meta || {},
    alias: SelectRoomN4mGyvzNK4Meta?.alias || [],
    redirect: SelectRoomN4mGyvzNK4Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/SelectRoom.vue").then(m => m.default || m)
  },
  {
    name: TrendChartwgF2rldNWmMeta?.name ?? "casino-niuniuGame-_components-TrendChart___en",
    path: TrendChartwgF2rldNWmMeta?.path ?? "/casino/niuniuGame/_components/TrendChart",
    meta: TrendChartwgF2rldNWmMeta || {},
    alias: TrendChartwgF2rldNWmMeta?.alias || [],
    redirect: TrendChartwgF2rldNWmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/TrendChart.vue").then(m => m.default || m)
  },
  {
    name: TrendChartwgF2rldNWmMeta?.name ?? "casino-niuniuGame-_components-TrendChart___cn",
    path: TrendChartwgF2rldNWmMeta?.path ?? "/cn/casino/niuniuGame/_components/TrendChart",
    meta: TrendChartwgF2rldNWmMeta || {},
    alias: TrendChartwgF2rldNWmMeta?.alias || [],
    redirect: TrendChartwgF2rldNWmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/_components/TrendChart.vue").then(m => m.default || m)
  },
  {
    name: indexj06FmqhUfMMeta?.name ?? "casino-niuniuGame-entrance___en",
    path: indexj06FmqhUfMMeta?.path ?? "/casino/niuniuGame/entrance",
    meta: indexj06FmqhUfMMeta || {},
    alias: indexj06FmqhUfMMeta?.alias || [],
    redirect: indexj06FmqhUfMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexj06FmqhUfMMeta?.name ?? "casino-niuniuGame-entrance___cn",
    path: indexj06FmqhUfMMeta?.path ?? "/cn/casino/niuniuGame/entrance",
    meta: indexj06FmqhUfMMeta || {},
    alias: indexj06FmqhUfMMeta?.alias || [],
    redirect: indexj06FmqhUfMMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexYHyKc4kDk6Meta?.name ?? "casino-niuniuGame___en",
    path: indexYHyKc4kDk6Meta?.path ?? "/casino/niuniuGame",
    meta: indexYHyKc4kDk6Meta || {},
    alias: indexYHyKc4kDk6Meta?.alias || [],
    redirect: indexYHyKc4kDk6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexYHyKc4kDk6Meta?.name ?? "casino-niuniuGame___cn",
    path: indexYHyKc4kDk6Meta?.path ?? "/cn/casino/niuniuGame",
    meta: indexYHyKc4kDk6Meta || {},
    alias: indexYHyKc4kDk6Meta?.alias || [],
    redirect: indexYHyKc4kDk6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93SlZ1T6xombMeta?.name ?? "casino-niuniuGame-indoor-id___en",
    path: _91id_93SlZ1T6xombMeta?.path ?? "/casino/niuniuGame/indoor/:id()",
    meta: _91id_93SlZ1T6xombMeta || {},
    alias: _91id_93SlZ1T6xombMeta?.alias || [],
    redirect: _91id_93SlZ1T6xombMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/indoor/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93SlZ1T6xombMeta?.name ?? "casino-niuniuGame-indoor-id___cn",
    path: _91id_93SlZ1T6xombMeta?.path ?? "/cn/casino/niuniuGame/indoor/:id()",
    meta: _91id_93SlZ1T6xombMeta || {},
    alias: _91id_93SlZ1T6xombMeta?.alias || [],
    redirect: _91id_93SlZ1T6xombMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/indoor/[id].vue").then(m => m.default || m)
  },
  {
    name: index10n6YXcm6SMeta?.name ?? "casino-niuniuGame-indoor___en",
    path: index10n6YXcm6SMeta?.path ?? "/casino/niuniuGame/indoor",
    meta: index10n6YXcm6SMeta || {},
    alias: index10n6YXcm6SMeta?.alias || [],
    redirect: index10n6YXcm6SMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/indoor/index.vue").then(m => m.default || m)
  },
  {
    name: index10n6YXcm6SMeta?.name ?? "casino-niuniuGame-indoor___cn",
    path: index10n6YXcm6SMeta?.path ?? "/cn/casino/niuniuGame/indoor",
    meta: index10n6YXcm6SMeta || {},
    alias: index10n6YXcm6SMeta?.alias || [],
    redirect: index10n6YXcm6SMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/indoor/index.vue").then(m => m.default || m)
  },
  {
    name: bettingAnimationGFYDC1lP2DMeta?.name ?? "casino-niuniuGame-ts-bettingAnimation___en",
    path: bettingAnimationGFYDC1lP2DMeta?.path ?? "/casino/niuniuGame/ts/bettingAnimation",
    meta: bettingAnimationGFYDC1lP2DMeta || {},
    alias: bettingAnimationGFYDC1lP2DMeta?.alias || [],
    redirect: bettingAnimationGFYDC1lP2DMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/bettingAnimation.ts").then(m => m.default || m)
  },
  {
    name: bettingAnimationGFYDC1lP2DMeta?.name ?? "casino-niuniuGame-ts-bettingAnimation___cn",
    path: bettingAnimationGFYDC1lP2DMeta?.path ?? "/cn/casino/niuniuGame/ts/bettingAnimation",
    meta: bettingAnimationGFYDC1lP2DMeta || {},
    alias: bettingAnimationGFYDC1lP2DMeta?.alias || [],
    redirect: bettingAnimationGFYDC1lP2DMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/bettingAnimation.ts").then(m => m.default || m)
  },
  {
    name: cardAnimationNBuOhZLZ6dMeta?.name ?? "casino-niuniuGame-ts-cardAnimation___en",
    path: cardAnimationNBuOhZLZ6dMeta?.path ?? "/casino/niuniuGame/ts/cardAnimation",
    meta: cardAnimationNBuOhZLZ6dMeta || {},
    alias: cardAnimationNBuOhZLZ6dMeta?.alias || [],
    redirect: cardAnimationNBuOhZLZ6dMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/cardAnimation.ts").then(m => m.default || m)
  },
  {
    name: cardAnimationNBuOhZLZ6dMeta?.name ?? "casino-niuniuGame-ts-cardAnimation___cn",
    path: cardAnimationNBuOhZLZ6dMeta?.path ?? "/cn/casino/niuniuGame/ts/cardAnimation",
    meta: cardAnimationNBuOhZLZ6dMeta || {},
    alias: cardAnimationNBuOhZLZ6dMeta?.alias || [],
    redirect: cardAnimationNBuOhZLZ6dMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/cardAnimation.ts").then(m => m.default || m)
  },
  {
    name: cardConstantsLfJeXXugoXMeta?.name ?? "casino-niuniuGame-ts-cardConstants___en",
    path: cardConstantsLfJeXXugoXMeta?.path ?? "/casino/niuniuGame/ts/cardConstants",
    meta: cardConstantsLfJeXXugoXMeta || {},
    alias: cardConstantsLfJeXXugoXMeta?.alias || [],
    redirect: cardConstantsLfJeXXugoXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/cardConstants.ts").then(m => m.default || m)
  },
  {
    name: cardConstantsLfJeXXugoXMeta?.name ?? "casino-niuniuGame-ts-cardConstants___cn",
    path: cardConstantsLfJeXXugoXMeta?.path ?? "/cn/casino/niuniuGame/ts/cardConstants",
    meta: cardConstantsLfJeXXugoXMeta || {},
    alias: cardConstantsLfJeXXugoXMeta?.alias || [],
    redirect: cardConstantsLfJeXXugoXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/cardConstants.ts").then(m => m.default || m)
  },
  {
    name: chipFlowAnimationIzhxwWrHjlMeta?.name ?? "casino-niuniuGame-ts-chipFlowAnimation___en",
    path: chipFlowAnimationIzhxwWrHjlMeta?.path ?? "/casino/niuniuGame/ts/chipFlowAnimation",
    meta: chipFlowAnimationIzhxwWrHjlMeta || {},
    alias: chipFlowAnimationIzhxwWrHjlMeta?.alias || [],
    redirect: chipFlowAnimationIzhxwWrHjlMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/chipFlowAnimation.ts").then(m => m.default || m)
  },
  {
    name: chipFlowAnimationIzhxwWrHjlMeta?.name ?? "casino-niuniuGame-ts-chipFlowAnimation___cn",
    path: chipFlowAnimationIzhxwWrHjlMeta?.path ?? "/cn/casino/niuniuGame/ts/chipFlowAnimation",
    meta: chipFlowAnimationIzhxwWrHjlMeta || {},
    alias: chipFlowAnimationIzhxwWrHjlMeta?.alias || [],
    redirect: chipFlowAnimationIzhxwWrHjlMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/chipFlowAnimation.ts").then(m => m.default || m)
  },
  {
    name: chipSettlementAnimation5WlilG21ScMeta?.name ?? "casino-niuniuGame-ts-chipSettlementAnimation___en",
    path: chipSettlementAnimation5WlilG21ScMeta?.path ?? "/casino/niuniuGame/ts/chipSettlementAnimation",
    meta: chipSettlementAnimation5WlilG21ScMeta || {},
    alias: chipSettlementAnimation5WlilG21ScMeta?.alias || [],
    redirect: chipSettlementAnimation5WlilG21ScMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/chipSettlementAnimation.ts").then(m => m.default || m)
  },
  {
    name: chipSettlementAnimation5WlilG21ScMeta?.name ?? "casino-niuniuGame-ts-chipSettlementAnimation___cn",
    path: chipSettlementAnimation5WlilG21ScMeta?.path ?? "/cn/casino/niuniuGame/ts/chipSettlementAnimation",
    meta: chipSettlementAnimation5WlilG21ScMeta || {},
    alias: chipSettlementAnimation5WlilG21ScMeta?.alias || [],
    redirect: chipSettlementAnimation5WlilG21ScMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/chipSettlementAnimation.ts").then(m => m.default || m)
  },
  {
    name: gameAudio2pN4ZawuTdMeta?.name ?? "casino-niuniuGame-ts-gameAudio___en",
    path: gameAudio2pN4ZawuTdMeta?.path ?? "/casino/niuniuGame/ts/gameAudio",
    meta: gameAudio2pN4ZawuTdMeta || {},
    alias: gameAudio2pN4ZawuTdMeta?.alias || [],
    redirect: gameAudio2pN4ZawuTdMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/gameAudio.ts").then(m => m.default || m)
  },
  {
    name: gameAudio2pN4ZawuTdMeta?.name ?? "casino-niuniuGame-ts-gameAudio___cn",
    path: gameAudio2pN4ZawuTdMeta?.path ?? "/cn/casino/niuniuGame/ts/gameAudio",
    meta: gameAudio2pN4ZawuTdMeta || {},
    alias: gameAudio2pN4ZawuTdMeta?.alias || [],
    redirect: gameAudio2pN4ZawuTdMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/gameAudio.ts").then(m => m.default || m)
  },
  {
    name: gameTpslHoFvK9pnVMeta?.name ?? "casino-niuniuGame-ts-gameTps___en",
    path: gameTpslHoFvK9pnVMeta?.path ?? "/casino/niuniuGame/ts/gameTps",
    meta: gameTpslHoFvK9pnVMeta || {},
    alias: gameTpslHoFvK9pnVMeta?.alias || [],
    redirect: gameTpslHoFvK9pnVMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/gameTps.ts").then(m => m.default || m)
  },
  {
    name: gameTpslHoFvK9pnVMeta?.name ?? "casino-niuniuGame-ts-gameTps___cn",
    path: gameTpslHoFvK9pnVMeta?.path ?? "/cn/casino/niuniuGame/ts/gameTps",
    meta: gameTpslHoFvK9pnVMeta || {},
    alias: gameTpslHoFvK9pnVMeta?.alias || [],
    redirect: gameTpslHoFvK9pnVMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/gameTps.ts").then(m => m.default || m)
  },
  {
    name: niuniuCommonzY5HUQYPAwMeta?.name ?? "casino-niuniuGame-ts-niuniuCommon___en",
    path: niuniuCommonzY5HUQYPAwMeta?.path ?? "/casino/niuniuGame/ts/niuniuCommon",
    meta: niuniuCommonzY5HUQYPAwMeta || {},
    alias: niuniuCommonzY5HUQYPAwMeta?.alias || [],
    redirect: niuniuCommonzY5HUQYPAwMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/niuniuCommon.ts").then(m => m.default || m)
  },
  {
    name: niuniuCommonzY5HUQYPAwMeta?.name ?? "casino-niuniuGame-ts-niuniuCommon___cn",
    path: niuniuCommonzY5HUQYPAwMeta?.path ?? "/cn/casino/niuniuGame/ts/niuniuCommon",
    meta: niuniuCommonzY5HUQYPAwMeta || {},
    alias: niuniuCommonzY5HUQYPAwMeta?.alias || [],
    redirect: niuniuCommonzY5HUQYPAwMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/niuniuCommon.ts").then(m => m.default || m)
  },
  {
    name: roundResultHelpers5xKdl3aQiQMeta?.name ?? "casino-niuniuGame-ts-roundResultHelpers___en",
    path: roundResultHelpers5xKdl3aQiQMeta?.path ?? "/casino/niuniuGame/ts/roundResultHelpers",
    meta: roundResultHelpers5xKdl3aQiQMeta || {},
    alias: roundResultHelpers5xKdl3aQiQMeta?.alias || [],
    redirect: roundResultHelpers5xKdl3aQiQMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/roundResultHelpers.ts").then(m => m.default || m)
  },
  {
    name: roundResultHelpers5xKdl3aQiQMeta?.name ?? "casino-niuniuGame-ts-roundResultHelpers___cn",
    path: roundResultHelpers5xKdl3aQiQMeta?.path ?? "/cn/casino/niuniuGame/ts/roundResultHelpers",
    meta: roundResultHelpers5xKdl3aQiQMeta || {},
    alias: roundResultHelpers5xKdl3aQiQMeta?.alias || [],
    redirect: roundResultHelpers5xKdl3aQiQMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/roundResultHelpers.ts").then(m => m.default || m)
  },
  {
    name: visibilityHandlerkcQvNq7WiZMeta?.name ?? "casino-niuniuGame-ts-visibilityHandler___en",
    path: visibilityHandlerkcQvNq7WiZMeta?.path ?? "/casino/niuniuGame/ts/visibilityHandler",
    meta: visibilityHandlerkcQvNq7WiZMeta || {},
    alias: visibilityHandlerkcQvNq7WiZMeta?.alias || [],
    redirect: visibilityHandlerkcQvNq7WiZMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/visibilityHandler.ts").then(m => m.default || m)
  },
  {
    name: visibilityHandlerkcQvNq7WiZMeta?.name ?? "casino-niuniuGame-ts-visibilityHandler___cn",
    path: visibilityHandlerkcQvNq7WiZMeta?.path ?? "/cn/casino/niuniuGame/ts/visibilityHandler",
    meta: visibilityHandlerkcQvNq7WiZMeta || {},
    alias: visibilityHandlerkcQvNq7WiZMeta?.alias || [],
    redirect: visibilityHandlerkcQvNq7WiZMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/niuniuGame/ts/visibilityHandler.ts").then(m => m.default || m)
  },
  {
    name: index7OH0FM8S5hMeta?.name ?? "casino-plinkoGame-_components-jackpot___en",
    path: index7OH0FM8S5hMeta?.path ?? "/casino/plinkoGame/_components/jackpot",
    meta: index7OH0FM8S5hMeta || {},
    alias: index7OH0FM8S5hMeta?.alias || [],
    redirect: index7OH0FM8S5hMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/_components/jackpot/index.vue").then(m => m.default || m)
  },
  {
    name: index7OH0FM8S5hMeta?.name ?? "casino-plinkoGame-_components-jackpot___cn",
    path: index7OH0FM8S5hMeta?.path ?? "/cn/casino/plinkoGame/_components/jackpot",
    meta: index7OH0FM8S5hMeta || {},
    alias: index7OH0FM8S5hMeta?.alias || [],
    redirect: index7OH0FM8S5hMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/_components/jackpot/index.vue").then(m => m.default || m)
  },
  {
    name: indexlVOWdHuTDtMeta?.name ?? "casino-plinkoGame-_components-multiRows___en",
    path: indexlVOWdHuTDtMeta?.path ?? "/casino/plinkoGame/_components/multiRows",
    meta: indexlVOWdHuTDtMeta || {},
    alias: indexlVOWdHuTDtMeta?.alias || [],
    redirect: indexlVOWdHuTDtMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/_components/multiRows/index.vue").then(m => m.default || m)
  },
  {
    name: indexlVOWdHuTDtMeta?.name ?? "casino-plinkoGame-_components-multiRows___cn",
    path: indexlVOWdHuTDtMeta?.path ?? "/cn/casino/plinkoGame/_components/multiRows",
    meta: indexlVOWdHuTDtMeta || {},
    alias: indexlVOWdHuTDtMeta?.alias || [],
    redirect: indexlVOWdHuTDtMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/_components/multiRows/index.vue").then(m => m.default || m)
  },
  {
    name: indexy6QTNZrieEMeta?.name ?? "casino-plinkoGame-_components-resultHistory___en",
    path: indexy6QTNZrieEMeta?.path ?? "/casino/plinkoGame/_components/resultHistory",
    meta: indexy6QTNZrieEMeta || {},
    alias: indexy6QTNZrieEMeta?.alias || [],
    redirect: indexy6QTNZrieEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/_components/resultHistory/index.vue").then(m => m.default || m)
  },
  {
    name: indexy6QTNZrieEMeta?.name ?? "casino-plinkoGame-_components-resultHistory___cn",
    path: indexy6QTNZrieEMeta?.path ?? "/cn/casino/plinkoGame/_components/resultHistory",
    meta: indexy6QTNZrieEMeta || {},
    alias: indexy6QTNZrieEMeta?.alias || [],
    redirect: indexy6QTNZrieEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/_components/resultHistory/index.vue").then(m => m.default || m)
  },
  {
    name: oddsDataZvu086qJCBMeta?.name ?? "casino-plinkoGame-data-oddsData___en",
    path: oddsDataZvu086qJCBMeta?.path ?? "/casino/plinkoGame/data/oddsData",
    meta: oddsDataZvu086qJCBMeta || {},
    alias: oddsDataZvu086qJCBMeta?.alias || [],
    redirect: oddsDataZvu086qJCBMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/oddsData.ts").then(m => m.default || m)
  },
  {
    name: oddsDataZvu086qJCBMeta?.name ?? "casino-plinkoGame-data-oddsData___cn",
    path: oddsDataZvu086qJCBMeta?.path ?? "/cn/casino/plinkoGame/data/oddsData",
    meta: oddsDataZvu086qJCBMeta || {},
    alias: oddsDataZvu086qJCBMeta?.alias || [],
    redirect: oddsDataZvu086qJCBMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/oddsData.ts").then(m => m.default || m)
  },
  {
    name: rows10_big0EjLp1fzb5Meta?.name ?? "casino-plinkoGame-data-rows10_big___en",
    path: rows10_big0EjLp1fzb5Meta?.path ?? "/casino/plinkoGame/data/rows10_big",
    meta: rows10_big0EjLp1fzb5Meta || {},
    alias: rows10_big0EjLp1fzb5Meta?.alias || [],
    redirect: rows10_big0EjLp1fzb5Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows10_big.js").then(m => m.default || m)
  },
  {
    name: rows10_big0EjLp1fzb5Meta?.name ?? "casino-plinkoGame-data-rows10_big___cn",
    path: rows10_big0EjLp1fzb5Meta?.path ?? "/cn/casino/plinkoGame/data/rows10_big",
    meta: rows10_big0EjLp1fzb5Meta || {},
    alias: rows10_big0EjLp1fzb5Meta?.alias || [],
    redirect: rows10_big0EjLp1fzb5Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows10_big.js").then(m => m.default || m)
  },
  {
    name: rows10_mobOjYTslzaCIMeta?.name ?? "casino-plinkoGame-data-rows10_mob___en",
    path: rows10_mobOjYTslzaCIMeta?.path ?? "/casino/plinkoGame/data/rows10_mob",
    meta: rows10_mobOjYTslzaCIMeta || {},
    alias: rows10_mobOjYTslzaCIMeta?.alias || [],
    redirect: rows10_mobOjYTslzaCIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows10_mob.js").then(m => m.default || m)
  },
  {
    name: rows10_mobOjYTslzaCIMeta?.name ?? "casino-plinkoGame-data-rows10_mob___cn",
    path: rows10_mobOjYTslzaCIMeta?.path ?? "/cn/casino/plinkoGame/data/rows10_mob",
    meta: rows10_mobOjYTslzaCIMeta || {},
    alias: rows10_mobOjYTslzaCIMeta?.alias || [],
    redirect: rows10_mobOjYTslzaCIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows10_mob.js").then(m => m.default || m)
  },
  {
    name: rows11_bighSjXq9qV1NMeta?.name ?? "casino-plinkoGame-data-rows11_big___en",
    path: rows11_bighSjXq9qV1NMeta?.path ?? "/casino/plinkoGame/data/rows11_big",
    meta: rows11_bighSjXq9qV1NMeta || {},
    alias: rows11_bighSjXq9qV1NMeta?.alias || [],
    redirect: rows11_bighSjXq9qV1NMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows11_big.js").then(m => m.default || m)
  },
  {
    name: rows11_bighSjXq9qV1NMeta?.name ?? "casino-plinkoGame-data-rows11_big___cn",
    path: rows11_bighSjXq9qV1NMeta?.path ?? "/cn/casino/plinkoGame/data/rows11_big",
    meta: rows11_bighSjXq9qV1NMeta || {},
    alias: rows11_bighSjXq9qV1NMeta?.alias || [],
    redirect: rows11_bighSjXq9qV1NMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows11_big.js").then(m => m.default || m)
  },
  {
    name: rows11_mobXDJO2vYp1lMeta?.name ?? "casino-plinkoGame-data-rows11_mob___en",
    path: rows11_mobXDJO2vYp1lMeta?.path ?? "/casino/plinkoGame/data/rows11_mob",
    meta: rows11_mobXDJO2vYp1lMeta || {},
    alias: rows11_mobXDJO2vYp1lMeta?.alias || [],
    redirect: rows11_mobXDJO2vYp1lMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows11_mob.js").then(m => m.default || m)
  },
  {
    name: rows11_mobXDJO2vYp1lMeta?.name ?? "casino-plinkoGame-data-rows11_mob___cn",
    path: rows11_mobXDJO2vYp1lMeta?.path ?? "/cn/casino/plinkoGame/data/rows11_mob",
    meta: rows11_mobXDJO2vYp1lMeta || {},
    alias: rows11_mobXDJO2vYp1lMeta?.alias || [],
    redirect: rows11_mobXDJO2vYp1lMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows11_mob.js").then(m => m.default || m)
  },
  {
    name: rows12_bigcVr59vFvUnMeta?.name ?? "casino-plinkoGame-data-rows12_big___en",
    path: rows12_bigcVr59vFvUnMeta?.path ?? "/casino/plinkoGame/data/rows12_big",
    meta: rows12_bigcVr59vFvUnMeta || {},
    alias: rows12_bigcVr59vFvUnMeta?.alias || [],
    redirect: rows12_bigcVr59vFvUnMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows12_big.js").then(m => m.default || m)
  },
  {
    name: rows12_bigcVr59vFvUnMeta?.name ?? "casino-plinkoGame-data-rows12_big___cn",
    path: rows12_bigcVr59vFvUnMeta?.path ?? "/cn/casino/plinkoGame/data/rows12_big",
    meta: rows12_bigcVr59vFvUnMeta || {},
    alias: rows12_bigcVr59vFvUnMeta?.alias || [],
    redirect: rows12_bigcVr59vFvUnMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows12_big.js").then(m => m.default || m)
  },
  {
    name: rows12_mobgVAoCaKUYBMeta?.name ?? "casino-plinkoGame-data-rows12_mob___en",
    path: rows12_mobgVAoCaKUYBMeta?.path ?? "/casino/plinkoGame/data/rows12_mob",
    meta: rows12_mobgVAoCaKUYBMeta || {},
    alias: rows12_mobgVAoCaKUYBMeta?.alias || [],
    redirect: rows12_mobgVAoCaKUYBMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows12_mob.js").then(m => m.default || m)
  },
  {
    name: rows12_mobgVAoCaKUYBMeta?.name ?? "casino-plinkoGame-data-rows12_mob___cn",
    path: rows12_mobgVAoCaKUYBMeta?.path ?? "/cn/casino/plinkoGame/data/rows12_mob",
    meta: rows12_mobgVAoCaKUYBMeta || {},
    alias: rows12_mobgVAoCaKUYBMeta?.alias || [],
    redirect: rows12_mobgVAoCaKUYBMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows12_mob.js").then(m => m.default || m)
  },
  {
    name: rows13_bigQDKBOV3tJIMeta?.name ?? "casino-plinkoGame-data-rows13_big___en",
    path: rows13_bigQDKBOV3tJIMeta?.path ?? "/casino/plinkoGame/data/rows13_big",
    meta: rows13_bigQDKBOV3tJIMeta || {},
    alias: rows13_bigQDKBOV3tJIMeta?.alias || [],
    redirect: rows13_bigQDKBOV3tJIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows13_big.js").then(m => m.default || m)
  },
  {
    name: rows13_bigQDKBOV3tJIMeta?.name ?? "casino-plinkoGame-data-rows13_big___cn",
    path: rows13_bigQDKBOV3tJIMeta?.path ?? "/cn/casino/plinkoGame/data/rows13_big",
    meta: rows13_bigQDKBOV3tJIMeta || {},
    alias: rows13_bigQDKBOV3tJIMeta?.alias || [],
    redirect: rows13_bigQDKBOV3tJIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows13_big.js").then(m => m.default || m)
  },
  {
    name: rows13_mobRd2un6YFp1Meta?.name ?? "casino-plinkoGame-data-rows13_mob___en",
    path: rows13_mobRd2un6YFp1Meta?.path ?? "/casino/plinkoGame/data/rows13_mob",
    meta: rows13_mobRd2un6YFp1Meta || {},
    alias: rows13_mobRd2un6YFp1Meta?.alias || [],
    redirect: rows13_mobRd2un6YFp1Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows13_mob.js").then(m => m.default || m)
  },
  {
    name: rows13_mobRd2un6YFp1Meta?.name ?? "casino-plinkoGame-data-rows13_mob___cn",
    path: rows13_mobRd2un6YFp1Meta?.path ?? "/cn/casino/plinkoGame/data/rows13_mob",
    meta: rows13_mobRd2un6YFp1Meta || {},
    alias: rows13_mobRd2un6YFp1Meta?.alias || [],
    redirect: rows13_mobRd2un6YFp1Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows13_mob.js").then(m => m.default || m)
  },
  {
    name: rows14_bigCtHUz2QgIxMeta?.name ?? "casino-plinkoGame-data-rows14_big___en",
    path: rows14_bigCtHUz2QgIxMeta?.path ?? "/casino/plinkoGame/data/rows14_big",
    meta: rows14_bigCtHUz2QgIxMeta || {},
    alias: rows14_bigCtHUz2QgIxMeta?.alias || [],
    redirect: rows14_bigCtHUz2QgIxMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows14_big.js").then(m => m.default || m)
  },
  {
    name: rows14_bigCtHUz2QgIxMeta?.name ?? "casino-plinkoGame-data-rows14_big___cn",
    path: rows14_bigCtHUz2QgIxMeta?.path ?? "/cn/casino/plinkoGame/data/rows14_big",
    meta: rows14_bigCtHUz2QgIxMeta || {},
    alias: rows14_bigCtHUz2QgIxMeta?.alias || [],
    redirect: rows14_bigCtHUz2QgIxMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows14_big.js").then(m => m.default || m)
  },
  {
    name: rows14_mobhkkcoY9UEZMeta?.name ?? "casino-plinkoGame-data-rows14_mob___en",
    path: rows14_mobhkkcoY9UEZMeta?.path ?? "/casino/plinkoGame/data/rows14_mob",
    meta: rows14_mobhkkcoY9UEZMeta || {},
    alias: rows14_mobhkkcoY9UEZMeta?.alias || [],
    redirect: rows14_mobhkkcoY9UEZMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows14_mob.js").then(m => m.default || m)
  },
  {
    name: rows14_mobhkkcoY9UEZMeta?.name ?? "casino-plinkoGame-data-rows14_mob___cn",
    path: rows14_mobhkkcoY9UEZMeta?.path ?? "/cn/casino/plinkoGame/data/rows14_mob",
    meta: rows14_mobhkkcoY9UEZMeta || {},
    alias: rows14_mobhkkcoY9UEZMeta?.alias || [],
    redirect: rows14_mobhkkcoY9UEZMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows14_mob.js").then(m => m.default || m)
  },
  {
    name: rows15_bigEp2oLH36NsMeta?.name ?? "casino-plinkoGame-data-rows15_big___en",
    path: rows15_bigEp2oLH36NsMeta?.path ?? "/casino/plinkoGame/data/rows15_big",
    meta: rows15_bigEp2oLH36NsMeta || {},
    alias: rows15_bigEp2oLH36NsMeta?.alias || [],
    redirect: rows15_bigEp2oLH36NsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows15_big.js").then(m => m.default || m)
  },
  {
    name: rows15_bigEp2oLH36NsMeta?.name ?? "casino-plinkoGame-data-rows15_big___cn",
    path: rows15_bigEp2oLH36NsMeta?.path ?? "/cn/casino/plinkoGame/data/rows15_big",
    meta: rows15_bigEp2oLH36NsMeta || {},
    alias: rows15_bigEp2oLH36NsMeta?.alias || [],
    redirect: rows15_bigEp2oLH36NsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows15_big.js").then(m => m.default || m)
  },
  {
    name: rows15_mobKDsLpIfzZjMeta?.name ?? "casino-plinkoGame-data-rows15_mob___en",
    path: rows15_mobKDsLpIfzZjMeta?.path ?? "/casino/plinkoGame/data/rows15_mob",
    meta: rows15_mobKDsLpIfzZjMeta || {},
    alias: rows15_mobKDsLpIfzZjMeta?.alias || [],
    redirect: rows15_mobKDsLpIfzZjMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows15_mob.js").then(m => m.default || m)
  },
  {
    name: rows15_mobKDsLpIfzZjMeta?.name ?? "casino-plinkoGame-data-rows15_mob___cn",
    path: rows15_mobKDsLpIfzZjMeta?.path ?? "/cn/casino/plinkoGame/data/rows15_mob",
    meta: rows15_mobKDsLpIfzZjMeta || {},
    alias: rows15_mobKDsLpIfzZjMeta?.alias || [],
    redirect: rows15_mobKDsLpIfzZjMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows15_mob.js").then(m => m.default || m)
  },
  {
    name: rows16_bigap9UT1Q3FoMeta?.name ?? "casino-plinkoGame-data-rows16_big___en",
    path: rows16_bigap9UT1Q3FoMeta?.path ?? "/casino/plinkoGame/data/rows16_big",
    meta: rows16_bigap9UT1Q3FoMeta || {},
    alias: rows16_bigap9UT1Q3FoMeta?.alias || [],
    redirect: rows16_bigap9UT1Q3FoMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows16_big.js").then(m => m.default || m)
  },
  {
    name: rows16_bigap9UT1Q3FoMeta?.name ?? "casino-plinkoGame-data-rows16_big___cn",
    path: rows16_bigap9UT1Q3FoMeta?.path ?? "/cn/casino/plinkoGame/data/rows16_big",
    meta: rows16_bigap9UT1Q3FoMeta || {},
    alias: rows16_bigap9UT1Q3FoMeta?.alias || [],
    redirect: rows16_bigap9UT1Q3FoMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows16_big.js").then(m => m.default || m)
  },
  {
    name: rows16_mob0iy9SEvA9AMeta?.name ?? "casino-plinkoGame-data-rows16_mob___en",
    path: rows16_mob0iy9SEvA9AMeta?.path ?? "/casino/plinkoGame/data/rows16_mob",
    meta: rows16_mob0iy9SEvA9AMeta || {},
    alias: rows16_mob0iy9SEvA9AMeta?.alias || [],
    redirect: rows16_mob0iy9SEvA9AMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows16_mob.js").then(m => m.default || m)
  },
  {
    name: rows16_mob0iy9SEvA9AMeta?.name ?? "casino-plinkoGame-data-rows16_mob___cn",
    path: rows16_mob0iy9SEvA9AMeta?.path ?? "/cn/casino/plinkoGame/data/rows16_mob",
    meta: rows16_mob0iy9SEvA9AMeta || {},
    alias: rows16_mob0iy9SEvA9AMeta?.alias || [],
    redirect: rows16_mob0iy9SEvA9AMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows16_mob.js").then(m => m.default || m)
  },
  {
    name: rows8_bigQDU1n4JAS1Meta?.name ?? "casino-plinkoGame-data-rows8_big___en",
    path: rows8_bigQDU1n4JAS1Meta?.path ?? "/casino/plinkoGame/data/rows8_big",
    meta: rows8_bigQDU1n4JAS1Meta || {},
    alias: rows8_bigQDU1n4JAS1Meta?.alias || [],
    redirect: rows8_bigQDU1n4JAS1Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows8_big.js").then(m => m.default || m)
  },
  {
    name: rows8_bigQDU1n4JAS1Meta?.name ?? "casino-plinkoGame-data-rows8_big___cn",
    path: rows8_bigQDU1n4JAS1Meta?.path ?? "/cn/casino/plinkoGame/data/rows8_big",
    meta: rows8_bigQDU1n4JAS1Meta || {},
    alias: rows8_bigQDU1n4JAS1Meta?.alias || [],
    redirect: rows8_bigQDU1n4JAS1Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows8_big.js").then(m => m.default || m)
  },
  {
    name: rows8_mob3xMCnlZr69Meta?.name ?? "casino-plinkoGame-data-rows8_mob___en",
    path: rows8_mob3xMCnlZr69Meta?.path ?? "/casino/plinkoGame/data/rows8_mob",
    meta: rows8_mob3xMCnlZr69Meta || {},
    alias: rows8_mob3xMCnlZr69Meta?.alias || [],
    redirect: rows8_mob3xMCnlZr69Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows8_mob.js").then(m => m.default || m)
  },
  {
    name: rows8_mob3xMCnlZr69Meta?.name ?? "casino-plinkoGame-data-rows8_mob___cn",
    path: rows8_mob3xMCnlZr69Meta?.path ?? "/cn/casino/plinkoGame/data/rows8_mob",
    meta: rows8_mob3xMCnlZr69Meta || {},
    alias: rows8_mob3xMCnlZr69Meta?.alias || [],
    redirect: rows8_mob3xMCnlZr69Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows8_mob.js").then(m => m.default || m)
  },
  {
    name: rows9_bigaWGXPChoT3Meta?.name ?? "casino-plinkoGame-data-rows9_big___en",
    path: rows9_bigaWGXPChoT3Meta?.path ?? "/casino/plinkoGame/data/rows9_big",
    meta: rows9_bigaWGXPChoT3Meta || {},
    alias: rows9_bigaWGXPChoT3Meta?.alias || [],
    redirect: rows9_bigaWGXPChoT3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows9_big.js").then(m => m.default || m)
  },
  {
    name: rows9_bigaWGXPChoT3Meta?.name ?? "casino-plinkoGame-data-rows9_big___cn",
    path: rows9_bigaWGXPChoT3Meta?.path ?? "/cn/casino/plinkoGame/data/rows9_big",
    meta: rows9_bigaWGXPChoT3Meta || {},
    alias: rows9_bigaWGXPChoT3Meta?.alias || [],
    redirect: rows9_bigaWGXPChoT3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows9_big.js").then(m => m.default || m)
  },
  {
    name: rows9_mobcHPMIAgBctMeta?.name ?? "casino-plinkoGame-data-rows9_mob___en",
    path: rows9_mobcHPMIAgBctMeta?.path ?? "/casino/plinkoGame/data/rows9_mob",
    meta: rows9_mobcHPMIAgBctMeta || {},
    alias: rows9_mobcHPMIAgBctMeta?.alias || [],
    redirect: rows9_mobcHPMIAgBctMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows9_mob.js").then(m => m.default || m)
  },
  {
    name: rows9_mobcHPMIAgBctMeta?.name ?? "casino-plinkoGame-data-rows9_mob___cn",
    path: rows9_mobcHPMIAgBctMeta?.path ?? "/cn/casino/plinkoGame/data/rows9_mob",
    meta: rows9_mobcHPMIAgBctMeta || {},
    alias: rows9_mobcHPMIAgBctMeta?.alias || [],
    redirect: rows9_mobcHPMIAgBctMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/data/rows9_mob.js").then(m => m.default || m)
  },
  {
    name: index1jUMMqFBnXMeta?.name ?? "casino-plinkoGame___en",
    path: index1jUMMqFBnXMeta?.path ?? "/casino/plinkoGame",
    meta: index1jUMMqFBnXMeta || {},
    alias: index1jUMMqFBnXMeta?.alias || [],
    redirect: index1jUMMqFBnXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/index.vue").then(m => m.default || m)
  },
  {
    name: index1jUMMqFBnXMeta?.name ?? "casino-plinkoGame___cn",
    path: index1jUMMqFBnXMeta?.path ?? "/cn/casino/plinkoGame",
    meta: index1jUMMqFBnXMeta || {},
    alias: index1jUMMqFBnXMeta?.alias || [],
    redirect: index1jUMMqFBnXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/index.vue").then(m => m.default || m)
  },
  {
    name: autoBetfGf6mZq2c8Meta?.name ?? "casino-plinkoGame-js-autoBet___en",
    path: autoBetfGf6mZq2c8Meta?.path ?? "/casino/plinkoGame/js/autoBet",
    meta: autoBetfGf6mZq2c8Meta || {},
    alias: autoBetfGf6mZq2c8Meta?.alias || [],
    redirect: autoBetfGf6mZq2c8Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/js/autoBet.ts").then(m => m.default || m)
  },
  {
    name: autoBetfGf6mZq2c8Meta?.name ?? "casino-plinkoGame-js-autoBet___cn",
    path: autoBetfGf6mZq2c8Meta?.path ?? "/cn/casino/plinkoGame/js/autoBet",
    meta: autoBetfGf6mZq2c8Meta || {},
    alias: autoBetfGf6mZq2c8Meta?.alias || [],
    redirect: autoBetfGf6mZq2c8Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/js/autoBet.ts").then(m => m.default || m)
  },
  {
    name: module85Cy41ag75Meta?.name ?? "casino-plinkoGame-js-module___en",
    path: module85Cy41ag75Meta?.path ?? "/casino/plinkoGame/js/module",
    meta: module85Cy41ag75Meta || {},
    alias: module85Cy41ag75Meta?.alias || [],
    redirect: module85Cy41ag75Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/js/module.js").then(m => m.default || m)
  },
  {
    name: module85Cy41ag75Meta?.name ?? "casino-plinkoGame-js-module___cn",
    path: module85Cy41ag75Meta?.path ?? "/cn/casino/plinkoGame/js/module",
    meta: module85Cy41ag75Meta || {},
    alias: module85Cy41ag75Meta?.alias || [],
    redirect: module85Cy41ag75Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/js/module.js").then(m => m.default || m)
  },
  {
    name: plinkoGameTohQlurRSSMeta?.name ?? "casino-plinkoGame-js-plinkoGame___en",
    path: plinkoGameTohQlurRSSMeta?.path ?? "/casino/plinkoGame/js/plinkoGame",
    meta: plinkoGameTohQlurRSSMeta || {},
    alias: plinkoGameTohQlurRSSMeta?.alias || [],
    redirect: plinkoGameTohQlurRSSMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/js/plinkoGame.js").then(m => m.default || m)
  },
  {
    name: plinkoGameTohQlurRSSMeta?.name ?? "casino-plinkoGame-js-plinkoGame___cn",
    path: plinkoGameTohQlurRSSMeta?.path ?? "/cn/casino/plinkoGame/js/plinkoGame",
    meta: plinkoGameTohQlurRSSMeta || {},
    alias: plinkoGameTohQlurRSSMeta?.alias || [],
    redirect: plinkoGameTohQlurRSSMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/js/plinkoGame.js").then(m => m.default || m)
  },
  {
    name: indexlzalHV6y0lMeta?.name ?? "casino-plinkoGame-utils___en",
    path: indexlzalHV6y0lMeta?.path ?? "/casino/plinkoGame/utils",
    meta: indexlzalHV6y0lMeta || {},
    alias: indexlzalHV6y0lMeta?.alias || [],
    redirect: indexlzalHV6y0lMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/utils/index.ts").then(m => m.default || m)
  },
  {
    name: indexlzalHV6y0lMeta?.name ?? "casino-plinkoGame-utils___cn",
    path: indexlzalHV6y0lMeta?.path ?? "/cn/casino/plinkoGame/utils",
    meta: indexlzalHV6y0lMeta || {},
    alias: indexlzalHV6y0lMeta?.alias || [],
    redirect: indexlzalHV6y0lMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/plinkoGame/utils/index.ts").then(m => m.default || m)
  },
  {
    name: hallCovereh5DZBxda9Meta?.name ?? "casino-redpacketGame-_components-hallCover___en",
    path: hallCovereh5DZBxda9Meta?.path ?? "/casino/redpacketGame/_components/hallCover",
    meta: hallCovereh5DZBxda9Meta || {},
    alias: hallCovereh5DZBxda9Meta?.alias || [],
    redirect: hallCovereh5DZBxda9Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/_components/hallCover.vue").then(m => m.default || m)
  },
  {
    name: hallCovereh5DZBxda9Meta?.name ?? "casino-redpacketGame-_components-hallCover___cn",
    path: hallCovereh5DZBxda9Meta?.path ?? "/cn/casino/redpacketGame/_components/hallCover",
    meta: hallCovereh5DZBxda9Meta || {},
    alias: hallCovereh5DZBxda9Meta?.alias || [],
    redirect: hallCovereh5DZBxda9Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/_components/hallCover.vue").then(m => m.default || m)
  },
  {
    name: historyList3ADP5CySvYMeta?.name ?? "casino-redpacketGame-_components-historyList___en",
    path: historyList3ADP5CySvYMeta?.path ?? "/casino/redpacketGame/_components/historyList",
    meta: historyList3ADP5CySvYMeta || {},
    alias: historyList3ADP5CySvYMeta?.alias || [],
    redirect: historyList3ADP5CySvYMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/_components/historyList.vue").then(m => m.default || m)
  },
  {
    name: historyList3ADP5CySvYMeta?.name ?? "casino-redpacketGame-_components-historyList___cn",
    path: historyList3ADP5CySvYMeta?.path ?? "/cn/casino/redpacketGame/_components/historyList",
    meta: historyList3ADP5CySvYMeta || {},
    alias: historyList3ADP5CySvYMeta?.alias || [],
    redirect: historyList3ADP5CySvYMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/_components/historyList.vue").then(m => m.default || m)
  },
  {
    name: packetOJuiShBiLEMeta?.name ?? "casino-redpacketGame-_components-packet___en",
    path: packetOJuiShBiLEMeta?.path ?? "/casino/redpacketGame/_components/packet",
    meta: packetOJuiShBiLEMeta || {},
    alias: packetOJuiShBiLEMeta?.alias || [],
    redirect: packetOJuiShBiLEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/_components/packet.vue").then(m => m.default || m)
  },
  {
    name: packetOJuiShBiLEMeta?.name ?? "casino-redpacketGame-_components-packet___cn",
    path: packetOJuiShBiLEMeta?.path ?? "/cn/casino/redpacketGame/_components/packet",
    meta: packetOJuiShBiLEMeta || {},
    alias: packetOJuiShBiLEMeta?.alias || [],
    redirect: packetOJuiShBiLEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/_components/packet.vue").then(m => m.default || m)
  },
  {
    name: index7yGgHsk8ozMeta?.name ?? "casino-redpacketGame-entrance___en",
    path: index7yGgHsk8ozMeta?.path ?? "/casino/redpacketGame/entrance",
    meta: index7yGgHsk8ozMeta || {},
    alias: index7yGgHsk8ozMeta?.alias || [],
    redirect: index7yGgHsk8ozMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: index7yGgHsk8ozMeta?.name ?? "casino-redpacketGame-entrance___cn",
    path: index7yGgHsk8ozMeta?.path ?? "/cn/casino/redpacketGame/entrance",
    meta: index7yGgHsk8ozMeta || {},
    alias: index7yGgHsk8ozMeta?.alias || [],
    redirect: index7yGgHsk8ozMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexw5nLLhIQEBMeta?.name ?? "casino-redpacketGame___en",
    path: indexw5nLLhIQEBMeta?.path ?? "/casino/redpacketGame",
    meta: indexw5nLLhIQEBMeta || {},
    alias: indexw5nLLhIQEBMeta?.alias || [],
    redirect: indexw5nLLhIQEBMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexw5nLLhIQEBMeta?.name ?? "casino-redpacketGame___cn",
    path: indexw5nLLhIQEBMeta?.path ?? "/cn/casino/redpacketGame",
    meta: indexw5nLLhIQEBMeta || {},
    alias: indexw5nLLhIQEBMeta?.alias || [],
    redirect: indexw5nLLhIQEBMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93elALhyAAIRMeta?.name ?? "casino-redpacketGame-indoor-id___en",
    path: _91id_93elALhyAAIRMeta?.path ?? "/casino/redpacketGame/indoor/:id()",
    meta: _91id_93elALhyAAIRMeta || {},
    alias: _91id_93elALhyAAIRMeta?.alias || [],
    redirect: _91id_93elALhyAAIRMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/indoor/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93elALhyAAIRMeta?.name ?? "casino-redpacketGame-indoor-id___cn",
    path: _91id_93elALhyAAIRMeta?.path ?? "/cn/casino/redpacketGame/indoor/:id()",
    meta: _91id_93elALhyAAIRMeta || {},
    alias: _91id_93elALhyAAIRMeta?.alias || [],
    redirect: _91id_93elALhyAAIRMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/indoor/[id].vue").then(m => m.default || m)
  },
  {
    name: indexHeEmnAZaG7Meta?.name ?? "casino-redpacketGame-indoor___en",
    path: indexHeEmnAZaG7Meta?.path ?? "/casino/redpacketGame/indoor",
    meta: indexHeEmnAZaG7Meta || {},
    alias: indexHeEmnAZaG7Meta?.alias || [],
    redirect: indexHeEmnAZaG7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/indoor/index.vue").then(m => m.default || m)
  },
  {
    name: indexHeEmnAZaG7Meta?.name ?? "casino-redpacketGame-indoor___cn",
    path: indexHeEmnAZaG7Meta?.path ?? "/cn/casino/redpacketGame/indoor",
    meta: indexHeEmnAZaG7Meta || {},
    alias: indexHeEmnAZaG7Meta?.alias || [],
    redirect: indexHeEmnAZaG7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/indoor/index.vue").then(m => m.default || m)
  },
  {
    name: redPacketCommonNMe6iBL156Meta?.name ?? "casino-redpacketGame-ts-redPacketCommon___en",
    path: redPacketCommonNMe6iBL156Meta?.path ?? "/casino/redpacketGame/ts/redPacketCommon",
    meta: redPacketCommonNMe6iBL156Meta || {},
    alias: redPacketCommonNMe6iBL156Meta?.alias || [],
    redirect: redPacketCommonNMe6iBL156Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/ts/redPacketCommon.ts").then(m => m.default || m)
  },
  {
    name: redPacketCommonNMe6iBL156Meta?.name ?? "casino-redpacketGame-ts-redPacketCommon___cn",
    path: redPacketCommonNMe6iBL156Meta?.path ?? "/cn/casino/redpacketGame/ts/redPacketCommon",
    meta: redPacketCommonNMe6iBL156Meta || {},
    alias: redPacketCommonNMe6iBL156Meta?.alias || [],
    redirect: redPacketCommonNMe6iBL156Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/redpacketGame/ts/redPacketCommon.ts").then(m => m.default || m)
  },
  {
    name: PickersZG5tRmdXGwMeta?.name ?? "casino-ringGame-_components-Pickers___en",
    path: PickersZG5tRmdXGwMeta?.path ?? "/casino/ringGame/_components/Pickers",
    meta: PickersZG5tRmdXGwMeta || {},
    alias: PickersZG5tRmdXGwMeta?.alias || [],
    redirect: PickersZG5tRmdXGwMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/_components/Pickers.vue").then(m => m.default || m)
  },
  {
    name: PickersZG5tRmdXGwMeta?.name ?? "casino-ringGame-_components-Pickers___cn",
    path: PickersZG5tRmdXGwMeta?.path ?? "/cn/casino/ringGame/_components/Pickers",
    meta: PickersZG5tRmdXGwMeta || {},
    alias: PickersZG5tRmdXGwMeta?.alias || [],
    redirect: PickersZG5tRmdXGwMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/_components/Pickers.vue").then(m => m.default || m)
  },
  {
    name: indexNVZfvveX6mMeta?.name ?? "casino-ringGame-_components-Rings___en",
    path: indexNVZfvveX6mMeta?.path ?? "/casino/ringGame/_components/Rings",
    meta: indexNVZfvveX6mMeta || {},
    alias: indexNVZfvveX6mMeta?.alias || [],
    redirect: indexNVZfvveX6mMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/_components/Rings/index.vue").then(m => m.default || m)
  },
  {
    name: indexNVZfvveX6mMeta?.name ?? "casino-ringGame-_components-Rings___cn",
    path: indexNVZfvveX6mMeta?.path ?? "/cn/casino/ringGame/_components/Rings",
    meta: indexNVZfvveX6mMeta || {},
    alias: indexNVZfvveX6mMeta?.alias || [],
    redirect: indexNVZfvveX6mMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/_components/Rings/index.vue").then(m => m.default || m)
  },
  {
    name: ResultYYHoZPYAYpMeta?.name ?? "casino-ringGame-_components-Rings-Result___en",
    path: ResultYYHoZPYAYpMeta?.path ?? "/casino/ringGame/_components/Rings/Result",
    meta: ResultYYHoZPYAYpMeta || {},
    alias: ResultYYHoZPYAYpMeta?.alias || [],
    redirect: ResultYYHoZPYAYpMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/_components/Rings/Result.vue").then(m => m.default || m)
  },
  {
    name: ResultYYHoZPYAYpMeta?.name ?? "casino-ringGame-_components-Rings-Result___cn",
    path: ResultYYHoZPYAYpMeta?.path ?? "/cn/casino/ringGame/_components/Rings/Result",
    meta: ResultYYHoZPYAYpMeta || {},
    alias: ResultYYHoZPYAYpMeta?.alias || [],
    redirect: ResultYYHoZPYAYpMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/_components/Rings/Result.vue").then(m => m.default || m)
  },
  {
    name: StarsLaUIlYtgahMeta?.name ?? "casino-ringGame-_components-Rings-Stars___en",
    path: StarsLaUIlYtgahMeta?.path ?? "/casino/ringGame/_components/Rings/Stars",
    meta: StarsLaUIlYtgahMeta || {},
    alias: StarsLaUIlYtgahMeta?.alias || [],
    redirect: StarsLaUIlYtgahMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/_components/Rings/Stars.vue").then(m => m.default || m)
  },
  {
    name: StarsLaUIlYtgahMeta?.name ?? "casino-ringGame-_components-Rings-Stars___cn",
    path: StarsLaUIlYtgahMeta?.path ?? "/cn/casino/ringGame/_components/Rings/Stars",
    meta: StarsLaUIlYtgahMeta || {},
    alias: StarsLaUIlYtgahMeta?.alias || [],
    redirect: StarsLaUIlYtgahMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/_components/Rings/Stars.vue").then(m => m.default || m)
  },
  {
    name: indexhh2rhT31XhMeta?.name ?? "casino-ringGame-data___en",
    path: indexhh2rhT31XhMeta?.path ?? "/casino/ringGame/data",
    meta: indexhh2rhT31XhMeta || {},
    alias: indexhh2rhT31XhMeta?.alias || [],
    redirect: indexhh2rhT31XhMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexhh2rhT31XhMeta?.name ?? "casino-ringGame-data___cn",
    path: indexhh2rhT31XhMeta?.path ?? "/cn/casino/ringGame/data",
    meta: indexhh2rhT31XhMeta || {},
    alias: indexhh2rhT31XhMeta?.alias || [],
    redirect: indexhh2rhT31XhMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexaRCx6gIwLaMeta?.name ?? "casino-ringGame___en",
    path: indexaRCx6gIwLaMeta?.path ?? "/casino/ringGame",
    meta: indexaRCx6gIwLaMeta || {},
    alias: indexaRCx6gIwLaMeta?.alias || [],
    redirect: indexaRCx6gIwLaMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexaRCx6gIwLaMeta?.name ?? "casino-ringGame___cn",
    path: indexaRCx6gIwLaMeta?.path ?? "/cn/casino/ringGame",
    meta: indexaRCx6gIwLaMeta || {},
    alias: indexaRCx6gIwLaMeta?.alias || [],
    redirect: indexaRCx6gIwLaMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/index.vue").then(m => m.default || m)
  },
  {
    name: ringGamexD2Y1qp0NUMeta?.name ?? "casino-ringGame-ts-ringGame___en",
    path: ringGamexD2Y1qp0NUMeta?.path ?? "/casino/ringGame/ts/ringGame",
    meta: ringGamexD2Y1qp0NUMeta || {},
    alias: ringGamexD2Y1qp0NUMeta?.alias || [],
    redirect: ringGamexD2Y1qp0NUMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/ts/ringGame.ts").then(m => m.default || m)
  },
  {
    name: ringGamexD2Y1qp0NUMeta?.name ?? "casino-ringGame-ts-ringGame___cn",
    path: ringGamexD2Y1qp0NUMeta?.path ?? "/cn/casino/ringGame/ts/ringGame",
    meta: ringGamexD2Y1qp0NUMeta || {},
    alias: ringGamexD2Y1qp0NUMeta?.alias || [],
    redirect: ringGamexD2Y1qp0NUMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/ringGame/ts/ringGame.ts").then(m => m.default || m)
  },
  {
    name: indexi5k6NnlRcQMeta?.name ?? "casino-rouletteGame___en",
    path: indexi5k6NnlRcQMeta?.path ?? "/casino/rouletteGame",
    meta: indexi5k6NnlRcQMeta || {},
    alias: indexi5k6NnlRcQMeta?.alias || [],
    redirect: indexi5k6NnlRcQMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexi5k6NnlRcQMeta?.name ?? "casino-rouletteGame___cn",
    path: indexi5k6NnlRcQMeta?.path ?? "/cn/casino/rouletteGame",
    meta: indexi5k6NnlRcQMeta || {},
    alias: indexi5k6NnlRcQMeta?.alias || [],
    redirect: indexi5k6NnlRcQMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/index.vue").then(m => m.default || m)
  },
  {
    name: rouletteData8nVDpMSc3gMeta?.name ?? "casino-rouletteGame-js-rouletteData___en",
    path: rouletteData8nVDpMSc3gMeta?.path ?? "/casino/rouletteGame/js/rouletteData",
    meta: rouletteData8nVDpMSc3gMeta || {},
    alias: rouletteData8nVDpMSc3gMeta?.alias || [],
    redirect: rouletteData8nVDpMSc3gMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/js/rouletteData.ts").then(m => m.default || m)
  },
  {
    name: rouletteData8nVDpMSc3gMeta?.name ?? "casino-rouletteGame-js-rouletteData___cn",
    path: rouletteData8nVDpMSc3gMeta?.path ?? "/cn/casino/rouletteGame/js/rouletteData",
    meta: rouletteData8nVDpMSc3gMeta || {},
    alias: rouletteData8nVDpMSc3gMeta?.alias || [],
    redirect: rouletteData8nVDpMSc3gMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/js/rouletteData.ts").then(m => m.default || m)
  },
  {
    name: rouletteFngdzsDs7GOFMeta?.name ?? "casino-rouletteGame-js-rouletteFn___en",
    path: rouletteFngdzsDs7GOFMeta?.path ?? "/casino/rouletteGame/js/rouletteFn",
    meta: rouletteFngdzsDs7GOFMeta || {},
    alias: rouletteFngdzsDs7GOFMeta?.alias || [],
    redirect: rouletteFngdzsDs7GOFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/js/rouletteFn.ts").then(m => m.default || m)
  },
  {
    name: rouletteFngdzsDs7GOFMeta?.name ?? "casino-rouletteGame-js-rouletteFn___cn",
    path: rouletteFngdzsDs7GOFMeta?.path ?? "/cn/casino/rouletteGame/js/rouletteFn",
    meta: rouletteFngdzsDs7GOFMeta || {},
    alias: rouletteFngdzsDs7GOFMeta?.alias || [],
    redirect: rouletteFngdzsDs7GOFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/js/rouletteFn.ts").then(m => m.default || m)
  },
  {
    name: rouletteGameUaSCy2weXsMeta?.name ?? "casino-rouletteGame-js-rouletteGame___en",
    path: rouletteGameUaSCy2weXsMeta?.path ?? "/casino/rouletteGame/js/rouletteGame",
    meta: rouletteGameUaSCy2weXsMeta || {},
    alias: rouletteGameUaSCy2weXsMeta?.alias || [],
    redirect: rouletteGameUaSCy2weXsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/js/rouletteGame.js").then(m => m.default || m)
  },
  {
    name: rouletteGameUaSCy2weXsMeta?.name ?? "casino-rouletteGame-js-rouletteGame___cn",
    path: rouletteGameUaSCy2weXsMeta?.path ?? "/cn/casino/rouletteGame/js/rouletteGame",
    meta: rouletteGameUaSCy2weXsMeta || {},
    alias: rouletteGameUaSCy2weXsMeta?.alias || [],
    redirect: rouletteGameUaSCy2weXsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/js/rouletteGame.js").then(m => m.default || m)
  },
  {
    name: rouletteRuleCZFSI3VzdIMeta?.name ?? "casino-rouletteGame-js-rouletteRule___en",
    path: rouletteRuleCZFSI3VzdIMeta?.path ?? "/casino/rouletteGame/js/rouletteRule",
    meta: rouletteRuleCZFSI3VzdIMeta || {},
    alias: rouletteRuleCZFSI3VzdIMeta?.alias || [],
    redirect: rouletteRuleCZFSI3VzdIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/js/rouletteRule.js").then(m => m.default || m)
  },
  {
    name: rouletteRuleCZFSI3VzdIMeta?.name ?? "casino-rouletteGame-js-rouletteRule___cn",
    path: rouletteRuleCZFSI3VzdIMeta?.path ?? "/cn/casino/rouletteGame/js/rouletteRule",
    meta: rouletteRuleCZFSI3VzdIMeta || {},
    alias: rouletteRuleCZFSI3VzdIMeta?.alias || [],
    redirect: rouletteRuleCZFSI3VzdIMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/rouletteGame/js/rouletteRule.js").then(m => m.default || m)
  },
  {
    name: ChoseNumberZB0jnw1SQEMeta?.name ?? "casino-spacediceGame-_components-BetNumber-ChoseNumber___en",
    path: ChoseNumberZB0jnw1SQEMeta?.path ?? "/casino/spacediceGame/_components/BetNumber/ChoseNumber",
    meta: ChoseNumberZB0jnw1SQEMeta || {},
    alias: ChoseNumberZB0jnw1SQEMeta?.alias || [],
    redirect: ChoseNumberZB0jnw1SQEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/BetNumber/ChoseNumber.vue").then(m => m.default || m)
  },
  {
    name: ChoseNumberZB0jnw1SQEMeta?.name ?? "casino-spacediceGame-_components-BetNumber-ChoseNumber___cn",
    path: ChoseNumberZB0jnw1SQEMeta?.path ?? "/cn/casino/spacediceGame/_components/BetNumber/ChoseNumber",
    meta: ChoseNumberZB0jnw1SQEMeta || {},
    alias: ChoseNumberZB0jnw1SQEMeta?.alias || [],
    redirect: ChoseNumberZB0jnw1SQEMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/BetNumber/ChoseNumber.vue").then(m => m.default || m)
  },
  {
    name: indexpzQzeewYIvMeta?.name ?? "casino-spacediceGame-_components-BetNumber___en",
    path: indexpzQzeewYIvMeta?.path ?? "/casino/spacediceGame/_components/BetNumber",
    meta: indexpzQzeewYIvMeta || {},
    alias: indexpzQzeewYIvMeta?.alias || [],
    redirect: indexpzQzeewYIvMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/BetNumber/index.vue").then(m => m.default || m)
  },
  {
    name: indexpzQzeewYIvMeta?.name ?? "casino-spacediceGame-_components-BetNumber___cn",
    path: indexpzQzeewYIvMeta?.path ?? "/cn/casino/spacediceGame/_components/BetNumber",
    meta: indexpzQzeewYIvMeta || {},
    alias: indexpzQzeewYIvMeta?.alias || [],
    redirect: indexpzQzeewYIvMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/BetNumber/index.vue").then(m => m.default || m)
  },
  {
    name: CasinoIconEput4NxGYAMeta?.name ?? "casino-spacediceGame-_components-CasinoIcon___en",
    path: CasinoIconEput4NxGYAMeta?.path ?? "/casino/spacediceGame/_components/CasinoIcon",
    meta: CasinoIconEput4NxGYAMeta || {},
    alias: CasinoIconEput4NxGYAMeta?.alias || [],
    redirect: CasinoIconEput4NxGYAMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/CasinoIcon.vue").then(m => m.default || m)
  },
  {
    name: CasinoIconEput4NxGYAMeta?.name ?? "casino-spacediceGame-_components-CasinoIcon___cn",
    path: CasinoIconEput4NxGYAMeta?.path ?? "/cn/casino/spacediceGame/_components/CasinoIcon",
    meta: CasinoIconEput4NxGYAMeta || {},
    alias: CasinoIconEput4NxGYAMeta?.alias || [],
    redirect: CasinoIconEput4NxGYAMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/CasinoIcon.vue").then(m => m.default || m)
  },
  {
    name: DicePointerS9hRHxjp2YMeta?.name ?? "casino-spacediceGame-_components-DicePointer___en",
    path: DicePointerS9hRHxjp2YMeta?.path ?? "/casino/spacediceGame/_components/DicePointer",
    meta: DicePointerS9hRHxjp2YMeta || {},
    alias: DicePointerS9hRHxjp2YMeta?.alias || [],
    redirect: DicePointerS9hRHxjp2YMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/DicePointer.vue").then(m => m.default || m)
  },
  {
    name: DicePointerS9hRHxjp2YMeta?.name ?? "casino-spacediceGame-_components-DicePointer___cn",
    path: DicePointerS9hRHxjp2YMeta?.path ?? "/cn/casino/spacediceGame/_components/DicePointer",
    meta: DicePointerS9hRHxjp2YMeta || {},
    alias: DicePointerS9hRHxjp2YMeta?.alias || [],
    redirect: DicePointerS9hRHxjp2YMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/DicePointer.vue").then(m => m.default || m)
  },
  {
    name: HistoryBarfqVvmBLObDMeta?.name ?? "casino-spacediceGame-_components-HistoryBar___en",
    path: HistoryBarfqVvmBLObDMeta?.path ?? "/casino/spacediceGame/_components/HistoryBar",
    meta: HistoryBarfqVvmBLObDMeta || {},
    alias: HistoryBarfqVvmBLObDMeta?.alias || [],
    redirect: HistoryBarfqVvmBLObDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/HistoryBar.vue").then(m => m.default || m)
  },
  {
    name: HistoryBarfqVvmBLObDMeta?.name ?? "casino-spacediceGame-_components-HistoryBar___cn",
    path: HistoryBarfqVvmBLObDMeta?.path ?? "/cn/casino/spacediceGame/_components/HistoryBar",
    meta: HistoryBarfqVvmBLObDMeta || {},
    alias: HistoryBarfqVvmBLObDMeta?.alias || [],
    redirect: HistoryBarfqVvmBLObDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/HistoryBar.vue").then(m => m.default || m)
  },
  {
    name: Sliderh60rfUt028Meta?.name ?? "casino-spacediceGame-_components-Slider___en",
    path: Sliderh60rfUt028Meta?.path ?? "/casino/spacediceGame/_components/Slider",
    meta: Sliderh60rfUt028Meta || {},
    alias: Sliderh60rfUt028Meta?.alias || [],
    redirect: Sliderh60rfUt028Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/Slider.vue").then(m => m.default || m)
  },
  {
    name: Sliderh60rfUt028Meta?.name ?? "casino-spacediceGame-_components-Slider___cn",
    path: Sliderh60rfUt028Meta?.path ?? "/cn/casino/spacediceGame/_components/Slider",
    meta: Sliderh60rfUt028Meta || {},
    alias: Sliderh60rfUt028Meta?.alias || [],
    redirect: Sliderh60rfUt028Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/Slider.vue").then(m => m.default || m)
  },
  {
    name: StatisticsW8uw4jaX7IMeta?.name ?? "casino-spacediceGame-_components-Statistics___en",
    path: StatisticsW8uw4jaX7IMeta?.path ?? "/casino/spacediceGame/_components/Statistics",
    meta: StatisticsW8uw4jaX7IMeta || {},
    alias: StatisticsW8uw4jaX7IMeta?.alias || [],
    redirect: StatisticsW8uw4jaX7IMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/Statistics.vue").then(m => m.default || m)
  },
  {
    name: StatisticsW8uw4jaX7IMeta?.name ?? "casino-spacediceGame-_components-Statistics___cn",
    path: StatisticsW8uw4jaX7IMeta?.path ?? "/cn/casino/spacediceGame/_components/Statistics",
    meta: StatisticsW8uw4jaX7IMeta || {},
    alias: StatisticsW8uw4jaX7IMeta?.alias || [],
    redirect: StatisticsW8uw4jaX7IMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/_components/Statistics.vue").then(m => m.default || m)
  },
  {
    name: indexSC96BH4tetMeta?.name ?? "casino-spacediceGame___en",
    path: indexSC96BH4tetMeta?.path ?? "/casino/spacediceGame",
    meta: indexSC96BH4tetMeta || {},
    alias: indexSC96BH4tetMeta?.alias || [],
    redirect: indexSC96BH4tetMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexSC96BH4tetMeta?.name ?? "casino-spacediceGame___cn",
    path: indexSC96BH4tetMeta?.path ?? "/cn/casino/spacediceGame",
    meta: indexSC96BH4tetMeta || {},
    alias: indexSC96BH4tetMeta?.alias || [],
    redirect: indexSC96BH4tetMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/index.vue").then(m => m.default || m)
  },
  {
    name: composablekL2bttF4XxMeta?.name ?? "casino-spacediceGame-js-composable___en",
    path: composablekL2bttF4XxMeta?.path ?? "/casino/spacediceGame/js/composable",
    meta: composablekL2bttF4XxMeta || {},
    alias: composablekL2bttF4XxMeta?.alias || [],
    redirect: composablekL2bttF4XxMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/js/composable.ts").then(m => m.default || m)
  },
  {
    name: composablekL2bttF4XxMeta?.name ?? "casino-spacediceGame-js-composable___cn",
    path: composablekL2bttF4XxMeta?.path ?? "/cn/casino/spacediceGame/js/composable",
    meta: composablekL2bttF4XxMeta || {},
    alias: composablekL2bttF4XxMeta?.alias || [],
    redirect: composablekL2bttF4XxMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/js/composable.ts").then(m => m.default || m)
  },
  {
    name: spaceDiceRule1mqUVNg9qOMeta?.name ?? "casino-spacediceGame-js-spaceDiceRule___en",
    path: spaceDiceRule1mqUVNg9qOMeta?.path ?? "/casino/spacediceGame/js/spaceDiceRule",
    meta: spaceDiceRule1mqUVNg9qOMeta || {},
    alias: spaceDiceRule1mqUVNg9qOMeta?.alias || [],
    redirect: spaceDiceRule1mqUVNg9qOMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/js/spaceDiceRule.js").then(m => m.default || m)
  },
  {
    name: spaceDiceRule1mqUVNg9qOMeta?.name ?? "casino-spacediceGame-js-spaceDiceRule___cn",
    path: spaceDiceRule1mqUVNg9qOMeta?.path ?? "/cn/casino/spacediceGame/js/spaceDiceRule",
    meta: spaceDiceRule1mqUVNg9qOMeta || {},
    alias: spaceDiceRule1mqUVNg9qOMeta?.alias || [],
    redirect: spaceDiceRule1mqUVNg9qOMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/spacediceGame/js/spaceDiceRule.js").then(m => m.default || m)
  },
  {
    name: Boarde1LKvA7UuaMeta?.name ?? "casino-stairsGame-_components-Board___en",
    path: Boarde1LKvA7UuaMeta?.path ?? "/casino/stairsGame/_components/Board",
    meta: Boarde1LKvA7UuaMeta || {},
    alias: Boarde1LKvA7UuaMeta?.alias || [],
    redirect: Boarde1LKvA7UuaMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/Board.vue").then(m => m.default || m)
  },
  {
    name: Boarde1LKvA7UuaMeta?.name ?? "casino-stairsGame-_components-Board___cn",
    path: Boarde1LKvA7UuaMeta?.path ?? "/cn/casino/stairsGame/_components/Board",
    meta: Boarde1LKvA7UuaMeta || {},
    alias: Boarde1LKvA7UuaMeta?.alias || [],
    redirect: Boarde1LKvA7UuaMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/Board.vue").then(m => m.default || m)
  },
  {
    name: CoefficientsInner0Q74cArWGuMeta?.name ?? "casino-stairsGame-_components-CoefficientsInner___en",
    path: CoefficientsInner0Q74cArWGuMeta?.path ?? "/casino/stairsGame/_components/CoefficientsInner",
    meta: CoefficientsInner0Q74cArWGuMeta || {},
    alias: CoefficientsInner0Q74cArWGuMeta?.alias || [],
    redirect: CoefficientsInner0Q74cArWGuMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/CoefficientsInner.vue").then(m => m.default || m)
  },
  {
    name: CoefficientsInner0Q74cArWGuMeta?.name ?? "casino-stairsGame-_components-CoefficientsInner___cn",
    path: CoefficientsInner0Q74cArWGuMeta?.path ?? "/cn/casino/stairsGame/_components/CoefficientsInner",
    meta: CoefficientsInner0Q74cArWGuMeta || {},
    alias: CoefficientsInner0Q74cArWGuMeta?.alias || [],
    redirect: CoefficientsInner0Q74cArWGuMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/CoefficientsInner.vue").then(m => m.default || m)
  },
  {
    name: LevelOptionQNF2LBziRvMeta?.name ?? "casino-stairsGame-_components-LevelOption___en",
    path: LevelOptionQNF2LBziRvMeta?.path ?? "/casino/stairsGame/_components/LevelOption",
    meta: LevelOptionQNF2LBziRvMeta || {},
    alias: LevelOptionQNF2LBziRvMeta?.alias || [],
    redirect: LevelOptionQNF2LBziRvMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/LevelOption.vue").then(m => m.default || m)
  },
  {
    name: LevelOptionQNF2LBziRvMeta?.name ?? "casino-stairsGame-_components-LevelOption___cn",
    path: LevelOptionQNF2LBziRvMeta?.path ?? "/cn/casino/stairsGame/_components/LevelOption",
    meta: LevelOptionQNF2LBziRvMeta || {},
    alias: LevelOptionQNF2LBziRvMeta?.alias || [],
    redirect: LevelOptionQNF2LBziRvMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/LevelOption.vue").then(m => m.default || m)
  },
  {
    name: Mans92619KbPLMeta?.name ?? "casino-stairsGame-_components-Man___en",
    path: Mans92619KbPLMeta?.path ?? "/casino/stairsGame/_components/Man",
    meta: Mans92619KbPLMeta || {},
    alias: Mans92619KbPLMeta?.alias || [],
    redirect: Mans92619KbPLMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/Man.vue").then(m => m.default || m)
  },
  {
    name: Mans92619KbPLMeta?.name ?? "casino-stairsGame-_components-Man___cn",
    path: Mans92619KbPLMeta?.path ?? "/cn/casino/stairsGame/_components/Man",
    meta: Mans92619KbPLMeta || {},
    alias: Mans92619KbPLMeta?.alias || [],
    redirect: Mans92619KbPLMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/Man.vue").then(m => m.default || m)
  },
  {
    name: StairsTileGoxHC1LkvdMeta?.name ?? "casino-stairsGame-_components-StairsTile___en",
    path: StairsTileGoxHC1LkvdMeta?.path ?? "/casino/stairsGame/_components/StairsTile",
    meta: StairsTileGoxHC1LkvdMeta || {},
    alias: StairsTileGoxHC1LkvdMeta?.alias || [],
    redirect: StairsTileGoxHC1LkvdMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/StairsTile.vue").then(m => m.default || m)
  },
  {
    name: StairsTileGoxHC1LkvdMeta?.name ?? "casino-stairsGame-_components-StairsTile___cn",
    path: StairsTileGoxHC1LkvdMeta?.path ?? "/cn/casino/stairsGame/_components/StairsTile",
    meta: StairsTileGoxHC1LkvdMeta || {},
    alias: StairsTileGoxHC1LkvdMeta?.alias || [],
    redirect: StairsTileGoxHC1LkvdMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/_components/StairsTile.vue").then(m => m.default || m)
  },
  {
    name: useStairpbCR5xD8ITMeta?.name ?? "casino-stairsGame-composable-useStair___en",
    path: useStairpbCR5xD8ITMeta?.path ?? "/casino/stairsGame/composable/useStair",
    meta: useStairpbCR5xD8ITMeta || {},
    alias: useStairpbCR5xD8ITMeta?.alias || [],
    redirect: useStairpbCR5xD8ITMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/composable/useStair.ts").then(m => m.default || m)
  },
  {
    name: useStairpbCR5xD8ITMeta?.name ?? "casino-stairsGame-composable-useStair___cn",
    path: useStairpbCR5xD8ITMeta?.path ?? "/cn/casino/stairsGame/composable/useStair",
    meta: useStairpbCR5xD8ITMeta || {},
    alias: useStairpbCR5xD8ITMeta?.alias || [],
    redirect: useStairpbCR5xD8ITMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/composable/useStair.ts").then(m => m.default || m)
  },
  {
    name: indexCzhHWynsn7Meta?.name ?? "casino-stairsGame-data___en",
    path: indexCzhHWynsn7Meta?.path ?? "/casino/stairsGame/data",
    meta: indexCzhHWynsn7Meta || {},
    alias: indexCzhHWynsn7Meta?.alias || [],
    redirect: indexCzhHWynsn7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexCzhHWynsn7Meta?.name ?? "casino-stairsGame-data___cn",
    path: indexCzhHWynsn7Meta?.path ?? "/cn/casino/stairsGame/data",
    meta: indexCzhHWynsn7Meta || {},
    alias: indexCzhHWynsn7Meta?.alias || [],
    redirect: indexCzhHWynsn7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexp6mNTODM7yMeta?.name ?? "casino-stairsGame___en",
    path: indexp6mNTODM7yMeta?.path ?? "/casino/stairsGame",
    meta: indexp6mNTODM7yMeta || {},
    alias: indexp6mNTODM7yMeta?.alias || [],
    redirect: indexp6mNTODM7yMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexp6mNTODM7yMeta?.name ?? "casino-stairsGame___cn",
    path: indexp6mNTODM7yMeta?.path ?? "/cn/casino/stairsGame",
    meta: indexp6mNTODM7yMeta || {},
    alias: indexp6mNTODM7yMeta?.alias || [],
    redirect: indexp6mNTODM7yMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/stairsGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexIzlC1TuqthMeta?.name ?? "casino-testGame___en",
    path: indexIzlC1TuqthMeta?.path ?? "/casino/testGame",
    meta: indexIzlC1TuqthMeta || {},
    alias: indexIzlC1TuqthMeta?.alias || [],
    redirect: indexIzlC1TuqthMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/testGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexIzlC1TuqthMeta?.name ?? "casino-testGame___cn",
    path: indexIzlC1TuqthMeta?.path ?? "/cn/casino/testGame",
    meta: indexIzlC1TuqthMeta || {},
    alias: indexIzlC1TuqthMeta?.alias || [],
    redirect: indexIzlC1TuqthMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/testGame/index.vue").then(m => m.default || m)
  },
  {
    name: BoardxlBH2tyYi7Meta?.name ?? "casino-towerGame-_components-Board___en",
    path: BoardxlBH2tyYi7Meta?.path ?? "/casino/towerGame/_components/Board",
    meta: BoardxlBH2tyYi7Meta || {},
    alias: BoardxlBH2tyYi7Meta?.alias || [],
    redirect: BoardxlBH2tyYi7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/_components/Board.vue").then(m => m.default || m)
  },
  {
    name: BoardxlBH2tyYi7Meta?.name ?? "casino-towerGame-_components-Board___cn",
    path: BoardxlBH2tyYi7Meta?.path ?? "/cn/casino/towerGame/_components/Board",
    meta: BoardxlBH2tyYi7Meta || {},
    alias: BoardxlBH2tyYi7Meta?.alias || [],
    redirect: BoardxlBH2tyYi7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/_components/Board.vue").then(m => m.default || m)
  },
  {
    name: LevelOptionnqJpFLEdd6Meta?.name ?? "casino-towerGame-_components-LevelOption___en",
    path: LevelOptionnqJpFLEdd6Meta?.path ?? "/casino/towerGame/_components/LevelOption",
    meta: LevelOptionnqJpFLEdd6Meta || {},
    alias: LevelOptionnqJpFLEdd6Meta?.alias || [],
    redirect: LevelOptionnqJpFLEdd6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/_components/LevelOption.vue").then(m => m.default || m)
  },
  {
    name: LevelOptionnqJpFLEdd6Meta?.name ?? "casino-towerGame-_components-LevelOption___cn",
    path: LevelOptionnqJpFLEdd6Meta?.path ?? "/cn/casino/towerGame/_components/LevelOption",
    meta: LevelOptionnqJpFLEdd6Meta || {},
    alias: LevelOptionnqJpFLEdd6Meta?.alias || [],
    redirect: LevelOptionnqJpFLEdd6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/_components/LevelOption.vue").then(m => m.default || m)
  },
  {
    name: Result5GUQ3qP6ywMeta?.name ?? "casino-towerGame-_components-Result___en",
    path: Result5GUQ3qP6ywMeta?.path ?? "/casino/towerGame/_components/Result",
    meta: Result5GUQ3qP6ywMeta || {},
    alias: Result5GUQ3qP6ywMeta?.alias || [],
    redirect: Result5GUQ3qP6ywMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/_components/Result.vue").then(m => m.default || m)
  },
  {
    name: Result5GUQ3qP6ywMeta?.name ?? "casino-towerGame-_components-Result___cn",
    path: Result5GUQ3qP6ywMeta?.path ?? "/cn/casino/towerGame/_components/Result",
    meta: Result5GUQ3qP6ywMeta || {},
    alias: Result5GUQ3qP6ywMeta?.alias || [],
    redirect: Result5GUQ3qP6ywMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/_components/Result.vue").then(m => m.default || m)
  },
  {
    name: index4plxwnBQG7Meta?.name ?? "casino-towerGame-data___en",
    path: index4plxwnBQG7Meta?.path ?? "/casino/towerGame/data",
    meta: index4plxwnBQG7Meta || {},
    alias: index4plxwnBQG7Meta?.alias || [],
    redirect: index4plxwnBQG7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: index4plxwnBQG7Meta?.name ?? "casino-towerGame-data___cn",
    path: index4plxwnBQG7Meta?.path ?? "/cn/casino/towerGame/data",
    meta: index4plxwnBQG7Meta || {},
    alias: index4plxwnBQG7Meta?.alias || [],
    redirect: index4plxwnBQG7Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexPN5eYURMH3Meta?.name ?? "casino-towerGame___en",
    path: indexPN5eYURMH3Meta?.path ?? "/casino/towerGame",
    meta: indexPN5eYURMH3Meta || {},
    alias: indexPN5eYURMH3Meta?.alias || [],
    redirect: indexPN5eYURMH3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexPN5eYURMH3Meta?.name ?? "casino-towerGame___cn",
    path: indexPN5eYURMH3Meta?.path ?? "/cn/casino/towerGame",
    meta: indexPN5eYURMH3Meta || {},
    alias: indexPN5eYURMH3Meta?.alias || [],
    redirect: indexPN5eYURMH3Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/towerGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexZrv5b2Jx7jMeta?.name ?? "casino-tripleGame-_components-gameContent___en",
    path: indexZrv5b2Jx7jMeta?.path ?? "/casino/tripleGame/_components/gameContent",
    meta: indexZrv5b2Jx7jMeta || {},
    alias: indexZrv5b2Jx7jMeta?.alias || [],
    redirect: indexZrv5b2Jx7jMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/_components/gameContent/index.vue").then(m => m.default || m)
  },
  {
    name: indexZrv5b2Jx7jMeta?.name ?? "casino-tripleGame-_components-gameContent___cn",
    path: indexZrv5b2Jx7jMeta?.path ?? "/cn/casino/tripleGame/_components/gameContent",
    meta: indexZrv5b2Jx7jMeta || {},
    alias: indexZrv5b2Jx7jMeta?.alias || [],
    redirect: indexZrv5b2Jx7jMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/_components/gameContent/index.vue").then(m => m.default || m)
  },
  {
    name: indexhvuCedM9zKMeta?.name ?? "casino-tripleGame-_components-gameControls___en",
    path: indexhvuCedM9zKMeta?.path ?? "/casino/tripleGame/_components/gameControls",
    meta: indexhvuCedM9zKMeta || {},
    alias: indexhvuCedM9zKMeta?.alias || [],
    redirect: indexhvuCedM9zKMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/_components/gameControls/index.vue").then(m => m.default || m)
  },
  {
    name: indexhvuCedM9zKMeta?.name ?? "casino-tripleGame-_components-gameControls___cn",
    path: indexhvuCedM9zKMeta?.path ?? "/cn/casino/tripleGame/_components/gameControls",
    meta: indexhvuCedM9zKMeta || {},
    alias: indexhvuCedM9zKMeta?.alias || [],
    redirect: indexhvuCedM9zKMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/_components/gameControls/index.vue").then(m => m.default || m)
  },
  {
    name: indexyicjEhRvleMeta?.name ?? "casino-tripleGame-_components-result___en",
    path: indexyicjEhRvleMeta?.path ?? "/casino/tripleGame/_components/result",
    meta: indexyicjEhRvleMeta || {},
    alias: indexyicjEhRvleMeta?.alias || [],
    redirect: indexyicjEhRvleMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/_components/result/index.vue").then(m => m.default || m)
  },
  {
    name: indexyicjEhRvleMeta?.name ?? "casino-tripleGame-_components-result___cn",
    path: indexyicjEhRvleMeta?.path ?? "/cn/casino/tripleGame/_components/result",
    meta: indexyicjEhRvleMeta || {},
    alias: indexyicjEhRvleMeta?.alias || [],
    redirect: indexyicjEhRvleMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/_components/result/index.vue").then(m => m.default || m)
  },
  {
    name: indexY94mXoY9UVMeta?.name ?? "casino-tripleGame-_components-resultCoef___en",
    path: indexY94mXoY9UVMeta?.path ?? "/casino/tripleGame/_components/resultCoef",
    meta: indexY94mXoY9UVMeta || {},
    alias: indexY94mXoY9UVMeta?.alias || [],
    redirect: indexY94mXoY9UVMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/_components/resultCoef/index.vue").then(m => m.default || m)
  },
  {
    name: indexY94mXoY9UVMeta?.name ?? "casino-tripleGame-_components-resultCoef___cn",
    path: indexY94mXoY9UVMeta?.path ?? "/cn/casino/tripleGame/_components/resultCoef",
    meta: indexY94mXoY9UVMeta || {},
    alias: indexY94mXoY9UVMeta?.alias || [],
    redirect: indexY94mXoY9UVMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/_components/resultCoef/index.vue").then(m => m.default || m)
  },
  {
    name: indexjsjv76NEsDMeta?.name ?? "casino-tripleGame-data___en",
    path: indexjsjv76NEsDMeta?.path ?? "/casino/tripleGame/data",
    meta: indexjsjv76NEsDMeta || {},
    alias: indexjsjv76NEsDMeta?.alias || [],
    redirect: indexjsjv76NEsDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexjsjv76NEsDMeta?.name ?? "casino-tripleGame-data___cn",
    path: indexjsjv76NEsDMeta?.path ?? "/cn/casino/tripleGame/data",
    meta: indexjsjv76NEsDMeta || {},
    alias: indexjsjv76NEsDMeta?.alias || [],
    redirect: indexjsjv76NEsDMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/data/index.ts").then(m => m.default || m)
  },
  {
    name: indexgqGAimBaDjMeta?.name ?? "casino-tripleGame___en",
    path: indexgqGAimBaDjMeta?.path ?? "/casino/tripleGame",
    meta: indexgqGAimBaDjMeta || {},
    alias: indexgqGAimBaDjMeta?.alias || [],
    redirect: indexgqGAimBaDjMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/index.vue").then(m => m.default || m)
  },
  {
    name: indexgqGAimBaDjMeta?.name ?? "casino-tripleGame___cn",
    path: indexgqGAimBaDjMeta?.path ?? "/cn/casino/tripleGame",
    meta: indexgqGAimBaDjMeta || {},
    alias: indexgqGAimBaDjMeta?.alias || [],
    redirect: indexgqGAimBaDjMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/index.vue").then(m => m.default || m)
  },
  {
    name: index7wzUdrKCl6Meta?.name ?? "casino-tripleGame-utils___en",
    path: index7wzUdrKCl6Meta?.path ?? "/casino/tripleGame/utils",
    meta: index7wzUdrKCl6Meta || {},
    alias: index7wzUdrKCl6Meta?.alias || [],
    redirect: index7wzUdrKCl6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/utils/index.ts").then(m => m.default || m)
  },
  {
    name: index7wzUdrKCl6Meta?.name ?? "casino-tripleGame-utils___cn",
    path: index7wzUdrKCl6Meta?.path ?? "/cn/casino/tripleGame/utils",
    meta: index7wzUdrKCl6Meta || {},
    alias: index7wzUdrKCl6Meta?.alias || [],
    redirect: index7wzUdrKCl6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/tripleGame/utils/index.ts").then(m => m.default || m)
  },
  {
    name: AnamationQMxG8Or1vgMeta?.name ?? "casino-zhajinhuaGame-_components-Anamation___en",
    path: AnamationQMxG8Or1vgMeta?.path ?? "/casino/zhajinhuaGame/_components/Anamation",
    meta: AnamationQMxG8Or1vgMeta || {},
    alias: AnamationQMxG8Or1vgMeta?.alias || [],
    redirect: AnamationQMxG8Or1vgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/Anamation.vue").then(m => m.default || m)
  },
  {
    name: AnamationQMxG8Or1vgMeta?.name ?? "casino-zhajinhuaGame-_components-Anamation___cn",
    path: AnamationQMxG8Or1vgMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/Anamation",
    meta: AnamationQMxG8Or1vgMeta || {},
    alias: AnamationQMxG8Or1vgMeta?.alias || [],
    redirect: AnamationQMxG8Or1vgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/Anamation.vue").then(m => m.default || m)
  },
  {
    name: cardTyperNNoX6ghc4Meta?.name ?? "casino-zhajinhuaGame-_components-cardType___en",
    path: cardTyperNNoX6ghc4Meta?.path ?? "/casino/zhajinhuaGame/_components/cardType",
    meta: cardTyperNNoX6ghc4Meta || {},
    alias: cardTyperNNoX6ghc4Meta?.alias || [],
    redirect: cardTyperNNoX6ghc4Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/cardType.vue").then(m => m.default || m)
  },
  {
    name: cardTyperNNoX6ghc4Meta?.name ?? "casino-zhajinhuaGame-_components-cardType___cn",
    path: cardTyperNNoX6ghc4Meta?.path ?? "/cn/casino/zhajinhuaGame/_components/cardType",
    meta: cardTyperNNoX6ghc4Meta || {},
    alias: cardTyperNNoX6ghc4Meta?.alias || [],
    redirect: cardTyperNNoX6ghc4Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/cardType.vue").then(m => m.default || m)
  },
  {
    name: CompareDailogW08l7szIwlMeta?.name ?? "casino-zhajinhuaGame-_components-CompareDailog___en",
    path: CompareDailogW08l7szIwlMeta?.path ?? "/casino/zhajinhuaGame/_components/CompareDailog",
    meta: CompareDailogW08l7szIwlMeta || {},
    alias: CompareDailogW08l7szIwlMeta?.alias || [],
    redirect: CompareDailogW08l7szIwlMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/CompareDailog.vue").then(m => m.default || m)
  },
  {
    name: CompareDailogW08l7szIwlMeta?.name ?? "casino-zhajinhuaGame-_components-CompareDailog___cn",
    path: CompareDailogW08l7szIwlMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/CompareDailog",
    meta: CompareDailogW08l7szIwlMeta || {},
    alias: CompareDailogW08l7szIwlMeta?.alias || [],
    redirect: CompareDailogW08l7szIwlMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/CompareDailog.vue").then(m => m.default || m)
  },
  {
    name: hallCoverRmBZZ0FDwFMeta?.name ?? "casino-zhajinhuaGame-_components-hallCover___en",
    path: hallCoverRmBZZ0FDwFMeta?.path ?? "/casino/zhajinhuaGame/_components/hallCover",
    meta: hallCoverRmBZZ0FDwFMeta || {},
    alias: hallCoverRmBZZ0FDwFMeta?.alias || [],
    redirect: hallCoverRmBZZ0FDwFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/hallCover.vue").then(m => m.default || m)
  },
  {
    name: hallCoverRmBZZ0FDwFMeta?.name ?? "casino-zhajinhuaGame-_components-hallCover___cn",
    path: hallCoverRmBZZ0FDwFMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/hallCover",
    meta: hallCoverRmBZZ0FDwFMeta || {},
    alias: hallCoverRmBZZ0FDwFMeta?.alias || [],
    redirect: hallCoverRmBZZ0FDwFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/hallCover.vue").then(m => m.default || m)
  },
  {
    name: historyListaRspfQIRaRMeta?.name ?? "casino-zhajinhuaGame-_components-historyList___en",
    path: historyListaRspfQIRaRMeta?.path ?? "/casino/zhajinhuaGame/_components/historyList",
    meta: historyListaRspfQIRaRMeta || {},
    alias: historyListaRspfQIRaRMeta?.alias || [],
    redirect: historyListaRspfQIRaRMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/historyList.vue").then(m => m.default || m)
  },
  {
    name: historyListaRspfQIRaRMeta?.name ?? "casino-zhajinhuaGame-_components-historyList___cn",
    path: historyListaRspfQIRaRMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/historyList",
    meta: historyListaRspfQIRaRMeta || {},
    alias: historyListaRspfQIRaRMeta?.alias || [],
    redirect: historyListaRspfQIRaRMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/historyList.vue").then(m => m.default || m)
  },
  {
    name: LastDialogpqcBmE4eceMeta?.name ?? "casino-zhajinhuaGame-_components-LastDialog___en",
    path: LastDialogpqcBmE4eceMeta?.path ?? "/casino/zhajinhuaGame/_components/LastDialog",
    meta: LastDialogpqcBmE4eceMeta || {},
    alias: LastDialogpqcBmE4eceMeta?.alias || [],
    redirect: LastDialogpqcBmE4eceMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/LastDialog.vue").then(m => m.default || m)
  },
  {
    name: LastDialogpqcBmE4eceMeta?.name ?? "casino-zhajinhuaGame-_components-LastDialog___cn",
    path: LastDialogpqcBmE4eceMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/LastDialog",
    meta: LastDialogpqcBmE4eceMeta || {},
    alias: LastDialogpqcBmE4eceMeta?.alias || [],
    redirect: LastDialogpqcBmE4eceMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/LastDialog.vue").then(m => m.default || m)
  },
  {
    name: nameTagNeu5MfJLvsMeta?.name ?? "casino-zhajinhuaGame-_components-nameTag___en",
    path: nameTagNeu5MfJLvsMeta?.path ?? "/casino/zhajinhuaGame/_components/nameTag",
    meta: nameTagNeu5MfJLvsMeta || {},
    alias: nameTagNeu5MfJLvsMeta?.alias || [],
    redirect: nameTagNeu5MfJLvsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/nameTag.vue").then(m => m.default || m)
  },
  {
    name: nameTagNeu5MfJLvsMeta?.name ?? "casino-zhajinhuaGame-_components-nameTag___cn",
    path: nameTagNeu5MfJLvsMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/nameTag",
    meta: nameTagNeu5MfJLvsMeta || {},
    alias: nameTagNeu5MfJLvsMeta?.alias || [],
    redirect: nameTagNeu5MfJLvsMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/nameTag.vue").then(m => m.default || m)
  },
  {
    name: player13cUxY3i7bMeta?.name ?? "casino-zhajinhuaGame-_components-player___en",
    path: player13cUxY3i7bMeta?.path ?? "/casino/zhajinhuaGame/_components/player",
    meta: player13cUxY3i7bMeta || {},
    alias: player13cUxY3i7bMeta?.alias || [],
    redirect: player13cUxY3i7bMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/player.vue").then(m => m.default || m)
  },
  {
    name: player13cUxY3i7bMeta?.name ?? "casino-zhajinhuaGame-_components-player___cn",
    path: player13cUxY3i7bMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/player",
    meta: player13cUxY3i7bMeta || {},
    alias: player13cUxY3i7bMeta?.alias || [],
    redirect: player13cUxY3i7bMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/player.vue").then(m => m.default || m)
  },
  {
    name: pokerCardhMCtnqZaoNMeta?.name ?? "casino-zhajinhuaGame-_components-pokerCard___en",
    path: pokerCardhMCtnqZaoNMeta?.path ?? "/casino/zhajinhuaGame/_components/pokerCard",
    meta: pokerCardhMCtnqZaoNMeta || {},
    alias: pokerCardhMCtnqZaoNMeta?.alias || [],
    redirect: pokerCardhMCtnqZaoNMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/pokerCard.vue").then(m => m.default || m)
  },
  {
    name: pokerCardhMCtnqZaoNMeta?.name ?? "casino-zhajinhuaGame-_components-pokerCard___cn",
    path: pokerCardhMCtnqZaoNMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/pokerCard",
    meta: pokerCardhMCtnqZaoNMeta || {},
    alias: pokerCardhMCtnqZaoNMeta?.alias || [],
    redirect: pokerCardhMCtnqZaoNMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/pokerCard.vue").then(m => m.default || m)
  },
  {
    name: ScrollingNoticeebjkIcY6sPMeta?.name ?? "casino-zhajinhuaGame-_components-ScrollingNotice___en",
    path: ScrollingNoticeebjkIcY6sPMeta?.path ?? "/casino/zhajinhuaGame/_components/ScrollingNotice",
    meta: ScrollingNoticeebjkIcY6sPMeta || {},
    alias: ScrollingNoticeebjkIcY6sPMeta?.alias || [],
    redirect: ScrollingNoticeebjkIcY6sPMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/ScrollingNotice.vue").then(m => m.default || m)
  },
  {
    name: ScrollingNoticeebjkIcY6sPMeta?.name ?? "casino-zhajinhuaGame-_components-ScrollingNotice___cn",
    path: ScrollingNoticeebjkIcY6sPMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/ScrollingNotice",
    meta: ScrollingNoticeebjkIcY6sPMeta || {},
    alias: ScrollingNoticeebjkIcY6sPMeta?.alias || [],
    redirect: ScrollingNoticeebjkIcY6sPMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/ScrollingNotice.vue").then(m => m.default || m)
  },
  {
    name: TimeDialogKpllyXPs4tMeta?.name ?? "casino-zhajinhuaGame-_components-TimeDialog___en",
    path: TimeDialogKpllyXPs4tMeta?.path ?? "/casino/zhajinhuaGame/_components/TimeDialog",
    meta: TimeDialogKpllyXPs4tMeta || {},
    alias: TimeDialogKpllyXPs4tMeta?.alias || [],
    redirect: TimeDialogKpllyXPs4tMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/TimeDialog.vue").then(m => m.default || m)
  },
  {
    name: TimeDialogKpllyXPs4tMeta?.name ?? "casino-zhajinhuaGame-_components-TimeDialog___cn",
    path: TimeDialogKpllyXPs4tMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/TimeDialog",
    meta: TimeDialogKpllyXPs4tMeta || {},
    alias: TimeDialogKpllyXPs4tMeta?.alias || [],
    redirect: TimeDialogKpllyXPs4tMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/TimeDialog.vue").then(m => m.default || m)
  },
  {
    name: wagerAmountnPgmmzA7XiMeta?.name ?? "casino-zhajinhuaGame-_components-wagerAmount___en",
    path: wagerAmountnPgmmzA7XiMeta?.path ?? "/casino/zhajinhuaGame/_components/wagerAmount",
    meta: wagerAmountnPgmmzA7XiMeta || {},
    alias: wagerAmountnPgmmzA7XiMeta?.alias || [],
    redirect: wagerAmountnPgmmzA7XiMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/wagerAmount.vue").then(m => m.default || m)
  },
  {
    name: wagerAmountnPgmmzA7XiMeta?.name ?? "casino-zhajinhuaGame-_components-wagerAmount___cn",
    path: wagerAmountnPgmmzA7XiMeta?.path ?? "/cn/casino/zhajinhuaGame/_components/wagerAmount",
    meta: wagerAmountnPgmmzA7XiMeta || {},
    alias: wagerAmountnPgmmzA7XiMeta?.alias || [],
    redirect: wagerAmountnPgmmzA7XiMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/_components/wagerAmount.vue").then(m => m.default || m)
  },
  {
    name: indexeAmZtBKwvHMeta?.name ?? "casino-zhajinhuaGame-entrance___en",
    path: indexeAmZtBKwvHMeta?.path ?? "/casino/zhajinhuaGame/entrance",
    meta: indexeAmZtBKwvHMeta || {},
    alias: indexeAmZtBKwvHMeta?.alias || [],
    redirect: indexeAmZtBKwvHMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: indexeAmZtBKwvHMeta?.name ?? "casino-zhajinhuaGame-entrance___cn",
    path: indexeAmZtBKwvHMeta?.path ?? "/cn/casino/zhajinhuaGame/entrance",
    meta: indexeAmZtBKwvHMeta || {},
    alias: indexeAmZtBKwvHMeta?.alias || [],
    redirect: indexeAmZtBKwvHMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/entrance/index.vue").then(m => m.default || m)
  },
  {
    name: index8FA1bNXayrMeta?.name ?? "casino-zhajinhuaGame___en",
    path: index8FA1bNXayrMeta?.path ?? "/casino/zhajinhuaGame",
    meta: index8FA1bNXayrMeta || {},
    alias: index8FA1bNXayrMeta?.alias || [],
    redirect: index8FA1bNXayrMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/index.vue").then(m => m.default || m)
  },
  {
    name: index8FA1bNXayrMeta?.name ?? "casino-zhajinhuaGame___cn",
    path: index8FA1bNXayrMeta?.path ?? "/cn/casino/zhajinhuaGame",
    meta: index8FA1bNXayrMeta || {},
    alias: index8FA1bNXayrMeta?.alias || [],
    redirect: index8FA1bNXayrMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93bVqp79ecSFMeta?.name ?? "casino-zhajinhuaGame-indoor-id___en",
    path: _91id_93bVqp79ecSFMeta?.path ?? "/casino/zhajinhuaGame/indoor/:id()",
    meta: _91id_93bVqp79ecSFMeta || {},
    alias: _91id_93bVqp79ecSFMeta?.alias || [],
    redirect: _91id_93bVqp79ecSFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/indoor/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93bVqp79ecSFMeta?.name ?? "casino-zhajinhuaGame-indoor-id___cn",
    path: _91id_93bVqp79ecSFMeta?.path ?? "/cn/casino/zhajinhuaGame/indoor/:id()",
    meta: _91id_93bVqp79ecSFMeta || {},
    alias: _91id_93bVqp79ecSFMeta?.alias || [],
    redirect: _91id_93bVqp79ecSFMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/indoor/[id].vue").then(m => m.default || m)
  },
  {
    name: indexXgaChwOwLmMeta?.name ?? "casino-zhajinhuaGame-indoor___en",
    path: indexXgaChwOwLmMeta?.path ?? "/casino/zhajinhuaGame/indoor",
    meta: indexXgaChwOwLmMeta || {},
    alias: indexXgaChwOwLmMeta?.alias || [],
    redirect: indexXgaChwOwLmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/indoor/index.vue").then(m => m.default || m)
  },
  {
    name: indexXgaChwOwLmMeta?.name ?? "casino-zhajinhuaGame-indoor___cn",
    path: indexXgaChwOwLmMeta?.path ?? "/cn/casino/zhajinhuaGame/indoor",
    meta: indexXgaChwOwLmMeta || {},
    alias: indexXgaChwOwLmMeta?.alias || [],
    redirect: indexXgaChwOwLmMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/indoor/index.vue").then(m => m.default || m)
  },
  {
    name: animationYAT68y1vKKMeta?.name ?? "casino-zhajinhuaGame-ts-animation___en",
    path: animationYAT68y1vKKMeta?.path ?? "/casino/zhajinhuaGame/ts/animation",
    meta: animationYAT68y1vKKMeta || {},
    alias: animationYAT68y1vKKMeta?.alias || [],
    redirect: animationYAT68y1vKKMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/animation.ts").then(m => m.default || m)
  },
  {
    name: animationYAT68y1vKKMeta?.name ?? "casino-zhajinhuaGame-ts-animation___cn",
    path: animationYAT68y1vKKMeta?.path ?? "/cn/casino/zhajinhuaGame/ts/animation",
    meta: animationYAT68y1vKKMeta || {},
    alias: animationYAT68y1vKKMeta?.alias || [],
    redirect: animationYAT68y1vKKMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/animation.ts").then(m => m.default || m)
  },
  {
    name: cardsConstantqD8ya57HCjMeta?.name ?? "casino-zhajinhuaGame-ts-cardsConstant___en",
    path: cardsConstantqD8ya57HCjMeta?.path ?? "/casino/zhajinhuaGame/ts/cardsConstant",
    meta: cardsConstantqD8ya57HCjMeta || {},
    alias: cardsConstantqD8ya57HCjMeta?.alias || [],
    redirect: cardsConstantqD8ya57HCjMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/cardsConstant.ts").then(m => m.default || m)
  },
  {
    name: cardsConstantqD8ya57HCjMeta?.name ?? "casino-zhajinhuaGame-ts-cardsConstant___cn",
    path: cardsConstantqD8ya57HCjMeta?.path ?? "/cn/casino/zhajinhuaGame/ts/cardsConstant",
    meta: cardsConstantqD8ya57HCjMeta || {},
    alias: cardsConstantqD8ya57HCjMeta?.alias || [],
    redirect: cardsConstantqD8ya57HCjMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/cardsConstant.ts").then(m => m.default || m)
  },
  {
    name: constantspfC0J8NST6Meta?.name ?? "casino-zhajinhuaGame-ts-constants___en",
    path: constantspfC0J8NST6Meta?.path ?? "/casino/zhajinhuaGame/ts/constants",
    meta: constantspfC0J8NST6Meta || {},
    alias: constantspfC0J8NST6Meta?.alias || [],
    redirect: constantspfC0J8NST6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/constants.ts").then(m => m.default || m)
  },
  {
    name: constantspfC0J8NST6Meta?.name ?? "casino-zhajinhuaGame-ts-constants___cn",
    path: constantspfC0J8NST6Meta?.path ?? "/cn/casino/zhajinhuaGame/ts/constants",
    meta: constantspfC0J8NST6Meta || {},
    alias: constantspfC0J8NST6Meta?.alias || [],
    redirect: constantspfC0J8NST6Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/constants.ts").then(m => m.default || m)
  },
  {
    name: goldenFlowerCommon6ulFEkDRVGMeta?.name ?? "casino-zhajinhuaGame-ts-goldenFlowerCommon___en",
    path: goldenFlowerCommon6ulFEkDRVGMeta?.path ?? "/casino/zhajinhuaGame/ts/goldenFlowerCommon",
    meta: goldenFlowerCommon6ulFEkDRVGMeta || {},
    alias: goldenFlowerCommon6ulFEkDRVGMeta?.alias || [],
    redirect: goldenFlowerCommon6ulFEkDRVGMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/goldenFlowerCommon.ts").then(m => m.default || m)
  },
  {
    name: goldenFlowerCommon6ulFEkDRVGMeta?.name ?? "casino-zhajinhuaGame-ts-goldenFlowerCommon___cn",
    path: goldenFlowerCommon6ulFEkDRVGMeta?.path ?? "/cn/casino/zhajinhuaGame/ts/goldenFlowerCommon",
    meta: goldenFlowerCommon6ulFEkDRVGMeta || {},
    alias: goldenFlowerCommon6ulFEkDRVGMeta?.alias || [],
    redirect: goldenFlowerCommon6ulFEkDRVGMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/goldenFlowerCommon.ts").then(m => m.default || m)
  },
  {
    name: loadGSAPRo8pNP6osnMeta?.name ?? "casino-zhajinhuaGame-ts-loadGSAP___en",
    path: loadGSAPRo8pNP6osnMeta?.path ?? "/casino/zhajinhuaGame/ts/loadGSAP",
    meta: loadGSAPRo8pNP6osnMeta || {},
    alias: loadGSAPRo8pNP6osnMeta?.alias || [],
    redirect: loadGSAPRo8pNP6osnMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/loadGSAP.ts").then(m => m.default || m)
  },
  {
    name: loadGSAPRo8pNP6osnMeta?.name ?? "casino-zhajinhuaGame-ts-loadGSAP___cn",
    path: loadGSAPRo8pNP6osnMeta?.path ?? "/cn/casino/zhajinhuaGame/ts/loadGSAP",
    meta: loadGSAPRo8pNP6osnMeta || {},
    alias: loadGSAPRo8pNP6osnMeta?.alias || [],
    redirect: loadGSAPRo8pNP6osnMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/loadGSAP.ts").then(m => m.default || m)
  },
  {
    name: musicaHEBcnHGpgMeta?.name ?? "casino-zhajinhuaGame-ts-music___en",
    path: musicaHEBcnHGpgMeta?.path ?? "/casino/zhajinhuaGame/ts/music",
    meta: musicaHEBcnHGpgMeta || {},
    alias: musicaHEBcnHGpgMeta?.alias || [],
    redirect: musicaHEBcnHGpgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/music.ts").then(m => m.default || m)
  },
  {
    name: musicaHEBcnHGpgMeta?.name ?? "casino-zhajinhuaGame-ts-music___cn",
    path: musicaHEBcnHGpgMeta?.path ?? "/cn/casino/zhajinhuaGame/ts/music",
    meta: musicaHEBcnHGpgMeta || {},
    alias: musicaHEBcnHGpgMeta?.alias || [],
    redirect: musicaHEBcnHGpgMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/casino/zhajinhuaGame/ts/music.ts").then(m => m.default || m)
  },
  {
    name: allGamesCardMQr9sXpHKkMeta?.name ?? "index-_components-allGamesCard___en",
    path: allGamesCardMQr9sXpHKkMeta?.path ?? "//_components/allGamesCard",
    meta: allGamesCardMQr9sXpHKkMeta || {},
    alias: allGamesCardMQr9sXpHKkMeta?.alias || [],
    redirect: allGamesCardMQr9sXpHKkMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/_components/allGamesCard.vue").then(m => m.default || m)
  },
  {
    name: allGamesCardMQr9sXpHKkMeta?.name ?? "index-_components-allGamesCard___cn",
    path: allGamesCardMQr9sXpHKkMeta?.path ?? "/cn//_components/allGamesCard",
    meta: allGamesCardMQr9sXpHKkMeta || {},
    alias: allGamesCardMQr9sXpHKkMeta?.alias || [],
    redirect: allGamesCardMQr9sXpHKkMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/_components/allGamesCard.vue").then(m => m.default || m)
  },
  {
    name: carouselJfongjYvSqMeta?.name ?? "index-_components-carousel___en",
    path: carouselJfongjYvSqMeta?.path ?? "//_components/carousel",
    meta: carouselJfongjYvSqMeta || {},
    alias: carouselJfongjYvSqMeta?.alias || [],
    redirect: carouselJfongjYvSqMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/_components/carousel.vue").then(m => m.default || m)
  },
  {
    name: carouselJfongjYvSqMeta?.name ?? "index-_components-carousel___cn",
    path: carouselJfongjYvSqMeta?.path ?? "/cn//_components/carousel",
    meta: carouselJfongjYvSqMeta || {},
    alias: carouselJfongjYvSqMeta?.alias || [],
    redirect: carouselJfongjYvSqMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/_components/carousel.vue").then(m => m.default || m)
  },
  {
    name: gameCardiXfoqAg9ngMeta?.name ?? "index-_components-gameCard___en",
    path: gameCardiXfoqAg9ngMeta?.path ?? "//_components/gameCard",
    meta: gameCardiXfoqAg9ngMeta || {},
    alias: gameCardiXfoqAg9ngMeta?.alias || [],
    redirect: gameCardiXfoqAg9ngMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/_components/gameCard.vue").then(m => m.default || m)
  },
  {
    name: gameCardiXfoqAg9ngMeta?.name ?? "index-_components-gameCard___cn",
    path: gameCardiXfoqAg9ngMeta?.path ?? "/cn//_components/gameCard",
    meta: gameCardiXfoqAg9ngMeta || {},
    alias: gameCardiXfoqAg9ngMeta?.alias || [],
    redirect: gameCardiXfoqAg9ngMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/_components/gameCard.vue").then(m => m.default || m)
  },
  {
    name: indexg4RYZ1JsN2Meta?.name ?? "index___en",
    path: indexg4RYZ1JsN2Meta?.path ?? "/",
    meta: indexg4RYZ1JsN2Meta || {},
    alias: indexg4RYZ1JsN2Meta?.alias || [],
    redirect: indexg4RYZ1JsN2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: indexg4RYZ1JsN2Meta?.name ?? "index___cn",
    path: indexg4RYZ1JsN2Meta?.path ?? "/cn",
    meta: indexg4RYZ1JsN2Meta || {},
    alias: indexg4RYZ1JsN2Meta?.alias || [],
    redirect: indexg4RYZ1JsN2Meta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: indexQq32q16AHBMeta?.name ?? "index-ts___en",
    path: indexQq32q16AHBMeta?.path ?? "//ts",
    meta: indexQq32q16AHBMeta || {},
    alias: indexQq32q16AHBMeta?.alias || [],
    redirect: indexQq32q16AHBMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/ts/index.ts").then(m => m.default || m)
  },
  {
    name: indexQq32q16AHBMeta?.name ?? "index-ts___cn",
    path: indexQq32q16AHBMeta?.path ?? "/cn//ts",
    meta: indexQq32q16AHBMeta || {},
    alias: indexQq32q16AHBMeta?.alias || [],
    redirect: indexQq32q16AHBMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/index/ts/index.ts").then(m => m.default || m)
  },
  {
    name: indexKDpsshnscXMeta?.name ?? "information___en",
    path: indexKDpsshnscXMeta?.path ?? "/information",
    meta: indexKDpsshnscXMeta || {},
    alias: indexKDpsshnscXMeta?.alias || [],
    redirect: indexKDpsshnscXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/information/index.vue").then(m => m.default || m)
  },
  {
    name: indexKDpsshnscXMeta?.name ?? "information___cn",
    path: indexKDpsshnscXMeta?.path ?? "/cn/information",
    meta: indexKDpsshnscXMeta || {},
    alias: indexKDpsshnscXMeta?.alias || [],
    redirect: indexKDpsshnscXMeta?.redirect || undefined,
    component: () => import("/www/gamefi/pages/information/index.vue").then(m => m.default || m)
  }
]